 const statesData = {
    "110001": 24,
    "110002": 24,
    "110003": 24,
    "110004": 24,
    "110005": 24,
    "110006": 24,
    "110007": 24,
    "110008": 24,
    "110009": 24,
    "110010": 24,
    "110011": 24,
    "110012": 24,
    "110013": 24,
    "110014": 24,
    "110015": 24,
    "110016": 24,
    "110017": 24,
    "110018": 24,
    "110019": 24,
    "110020": 24,
    "110021": 24,
    "110022": 24,
    "110023": 24,
    "110024": 24,
    "110025": 24,
    "110026": 24,
    "110027": 24,
    "110028": 24,
    "110029": 24,
    "110030": 24,
    "110031": 24,
    "110032": 24,
    "110033": 24,
    "110034": 24,
    "110035": 24,
    "110036": 24,
    "110037": 24,
    "110038": 24,
    "110039": 24,
    "110040": 24,
    "110041": 24,
    "110042": 24,
    "110043": 24,
    "110044": 24,
    "110045": 24,
    "110046": 24,
    "110047": 24,
    "110048": 24,
    "110049": 24,
    "110050": 24,
    "110051": 24,
    "110052": 24,
    "110053": 24,
    "110054": 24,
    "110055": 24,
    "110056": 24,
    "110057": 24,
    "110058": 24,
    "110059": 24,
    "110060": 24,
    "110061": 24,
    "110062": 24,
    "110063": 24,
    "110064": 24,
    "110065": 24,
    "110066": 24,
    "110067": 24,
    "110068": 24,
    "110069": 24,
    "110070": 24,
    "110071": 24,
    "110072": 24,
    "110073": 24,
    "110074": 24,
    "110075": 24,
    "110076": 24,
    "110077": 24,
    "110078": 24,
    "110080": 24,
    "110081": 24,
    "110082": 24,
    "110083": 24,
    "110084": 24,
    "110085": 24,
    "110086": 24,
    "110087": 24,
    "110088": 24,
    "110089": 24,
    "110090": 24,
    "110091": 24,
    "110092": 24,
    "110093": 24,
    "110094": 24,
    "110095": 24,
    "110096": 24,
    "110097": 24,
    "110098": 24,
    "110100": 24,
    "110101": 24,
    "110103": 24,
    "110104": 24,
    "110105": 24,
    "110106": 24,
    "110107": 24,
    "110108": 24,
    "110109": 24,
    "110110": 24,
    "110112": 24,
    "110113": 24,
    "110114": 24,
    "110115": 24,
    "110116": 24,
    "110117": 24,
    "110118": 24,
    "110119": 24,
    "110120": 24,
    "110122": 24,
    "110124": 24,
    "110125": 24,
    "110301": 24,
    "110302": 24,
    "110501": 24,
    "110502": 24,
    "110503": 24,
    "110504": 24,
    "110505": 24,
    "110510": 24,
    "110511": 24,
    "110512": 24,
    "110601": 24,
    "110602": 24,
    "110603": 24,
    "110604": 24,
    "110605": 24,
    "110606": 24,
    "110607": 24,
    "110608": 24,
    "110609": 24,
    "111105": 24,
    "111111": 24,
    "111112": 24,
    "111113": 24,
    "111114": 24,
    "111115": 24,
    "111116": 24,
    "111117": 24,
    "111118": 24,
    "111119": 48,
    "111122": 48,
    "111123": 24,
    "114145": 96,
    "121000": 24,
    "121001": 24,
    "121002": 24,
    "121003": 24,
    "121004": 24,
    "121005": 24,
    "121006": 24,
    "121007": 24,
    "121008": 24,
    "121009": 24,
    "121010": 24,
    "121012": 24,
    "121013": 24,
    "121014": 24,
    "121015": 24,
    "121101": 24,
    "121102": 24,
    "121105": 48,
    "121106": 48,
    "121107": 48,
    "121206": 24,
    "122001": 24,
    "122002": 24,
    "122003": 24,
    "122004": 24,
    "122005": 24,
    "122006": 24,
    "122007": 24,
    "122008": 24,
    "122009": 24,
    "122010": 24,
    "122011": 24,
    "122012": 24,
    "122015": 24,
    "122016": 24,
    "122017": 24,
    "122018": 24,
    "122019": 24,
    "122022": 24,
    "122050": 24,
    "122051": 24,
    "122052": 24,
    "122098": 24,
    "122100": 48,
    "122101": 24,
    "122102": 24,
    "122103": 24,
    "122104": 24,
    "122105": 24,
    "122106": 48,
    "122107": 24,
    "122413": 24,
    "122414": 48,
    "122502": 48,
    "122503": 24,
    "122504": 24,
    "122505": 24,
    "122506": 24,
    "123001": 48,
    "123003": 24,
    "123021": 96,
    "123023": 48,
    "123024": 48,
    "123027": 96,
    "123028": 96,
    "123029": 96,
    "123034": 96,
    "123035": 48,
    "123101": 48,
    "123102": 48,
    "123103": 48,
    "123106": 48,
    "123110": 48,
    "123301": 48,
    "123303": 96,
    "123401": 48,
    "123411": 96,
    "123412": 48,
    "123413": 48,
    "123414": 24,
    "123501": 48,
    "123504": 24,
    "123505": 24,
    "123506": 24,
    "124001": 48,
    "124010": 48,
    "124021": 48,
    "124102": 48,
    "124103": 48,
    "124104": 48,
    "124105": 48,
    "124106": 48,
    "124107": 48,
    "124108": 48,
    "124109": 48,
    "124111": 48,
    "124112": 48,
    "124146": 48,
    "124201": 48,
    "124303": 48,
    "124401": 48,
    "124412": 48,
    "124501": 48,
    "124505": 48,
    "124506": 24,
    "124507": 24,
    "124508": 24,
    "124512": 24,
    "124514": 48,
    "124517": 48,
    "125001": 48,
    "125002": 48,
    "125003": 48,
    "125004": 48,
    "125005": 48,
    "125006": 48,
    "125007": 48,
    "125011": 48,
    "125033": 48,
    "125034": 48,
    "125039": 48,
    "125042": 48,
    "125044": 48,
    "125047": 48,
    "125048": 48,
    "125049": 48,
    "125050": 48,
    "125051": 96,
    "125052": 48,
    "125055": 48,
    "125058": 48,
    "125060": 48,
    "125075": 96,
    "125076": 96,
    "125077": 96,
    "125101": 96,
    "125102": 96,
    "125103": 96,
    "125104": 96,
    "125111": 48,
    "125112": 48,
    "125113": 48,
    "125120": 96,
    "125121": 48,
    "125122": 48,
    "125133": 96,
    "125201": 96,
    "126001": 96,
    "126101": 48,
    "126102": 48,
    "126110": 48,
    "126111": 48,
    "126112": 96,
    "126113": 48,
    "126114": 48,
    "126115": 48,
    "126116": 48,
    "126125": 48,
    "126126": 48,
    "126127": 48,
    "126128": 48,
    "126152": 48,
    "127020": 48,
    "127021": 48,
    "127022": 48,
    "127025": 48,
    "127026": 48,
    "127027": 48,
    "127031": 48,
    "127032": 48,
    "127040": 48,
    "127041": 48,
    "127043": 48,
    "127045": 96,
    "127046": 96,
    "127111": 48,
    "127201": 48,
    "127306": 48,
    "127308": 48,
    "127309": 48,
    "127310": 48,
    "131001": 48,
    "131021": 48,
    "131027": 48,
    "131028": 96,
    "131029": 48,
    "131030": 96,
    "131039": 48,
    "131101": 48,
    "131102": 48,
    "131103": 96,
    "131301": 48,
    "131305": 48,
    "132001": 48,
    "132022": 48,
    "132037": 48,
    "132039": 96,
    "132046": 96,
    "132054": 48,
    "132101": 96,
    "132102": 96,
    "132103": 48,
    "132104": 48,
    "132105": 48,
    "132106": 48,
    "132107": 48,
    "132108": 48,
    "132110": 48,
    "132113": 96,
    "132114": 48,
    "132115": 96,
    "132116": 120,
    "132117": 120,
    "132122": 96,
    "132132": 48,
    "132140": 96,
    "132145": 48,
    "132151": 48,
    "132157": 48,
    "133001": 48,
    "133003": 48,
    "133004": 48,
    "133005": 48,
    "133006": 48,
    "133007": 48,
    "133008": 48,
    "133010": 48,
    "133021": 48,
    "133101": 48,
    "133102": 48,
    "133103": 48,
    "133104": 48,
    "133201": 48,
    "133202": 48,
    "133203": 48,
    "133204": 48,
    "133205": 48,
    "133206": 48,
    "133207": 48,
    "133301": 48,
    "133302": 48,
    "134001": 48,
    "134002": 48,
    "134003": 48,
    "134004": 48,
    "134005": 48,
    "134006": 48,
    "134007": 48,
    "134008": 48,
    "134101": 48,
    "134102": 48,
    "134103": 48,
    "134104": 48,
    "134105": 48,
    "134107": 48,
    "134108": 48,
    "134109": 48,
    "134112": 48,
    "134113": 48,
    "134114": 48,
    "134115": 48,
    "134116": 48,
    "134117": 48,
    "134118": 48,
    "134201": 48,
    "134202": 48,
    "134203": 48,
    "134204": 48,
    "134205": 48,
    "135001": 48,
    "135002": 48,
    "135003": 48,
    "135004": 48,
    "135021": 48,
    "135101": 48,
    "135102": 48,
    "135103": 48,
    "135106": 48,
    "135133": 48,
    "136020": 48,
    "136021": 48,
    "136026": 48,
    "136027": 48,
    "136030": 48,
    "136033": 48,
    "136034": 48,
    "136035": 48,
    "136038": 48,
    "136042": 48,
    "136043": 48,
    "136044": 48,
    "136118": 48,
    "136119": 48,
    "136128": 48,
    "136129": 48,
    "136130": 48,
    "136131": 48,
    "136132": 48,
    "136135": 48,
    "136136": 48,
    "136156": 48,
    "140001": 48,
    "140101": 96,
    "140102": 120,
    "140103": 96,
    "140105": 48,
    "140108": 48,
    "140109": 48,
    "140110": 48,
    "140111": 120,
    "140112": 120,
    "140113": 48,
    "140114": 48,
    "140115": 48,
    "140116": 48,
    "140117": 48,
    "140118": 48,
    "140119": 48,
    "140123": 48,
    "140124": 48,
    "140125": 48,
    "140126": 48,
    "140133": 48,
    "140201": 48,
    "140301": 48,
    "140306": 48,
    "140307": 48,
    "140308": 48,
    "140401": 48,
    "140402": 48,
    "140406": 48,
    "140407": 48,
    "140408": 48,
    "140412": 96,
    "140413": 48,
    "140417": 48,
    "140501": 48,
    "140506": 48,
    "140507": 48,
    "140601": 48,
    "140602": 48,
    "140603": 48,
    "140604": 48,
    "140701": 48,
    "140802": 96,
    "140901": 48,
    "141001": 48,
    "141002": 48,
    "141003": 48,
    "141004": 48,
    "141005": 48,
    "141006": 48,
    "141007": 48,
    "141008": 48,
    "141009": 48,
    "141010": 48,
    "141011": 48,
    "141012": 48,
    "141013": 48,
    "141014": 48,
    "141015": 48,
    "141016": 48,
    "141017": 48,
    "141020": 48,
    "141101": 48,
    "141104": 48,
    "141106": 48,
    "141110": 48,
    "141113": 48,
    "141114": 96,
    "141115": 96,
    "141116": 48,
    "141117": 48,
    "141119": 96,
    "141120": 48,
    "141121": 96,
    "141122": 48,
    "141123": 48,
    "141304": 48,
    "141309": 48,
    "141310": 96,
    "141401": 48,
    "141402": 48,
    "141411": 48,
    "141415": 96,
    "141416": 48,
    "141421": 48,
    "141422": 48,
    "141801": 120,
    "142001": 96,
    "142003": 96,
    "142021": 48,
    "142022": 48,
    "142026": 96,
    "142027": 48,
    "142037": 96,
    "142038": 96,
    "142039": 96,
    "142042": 96,
    "142043": 96,
    "142044": 96,
    "142045": 96,
    "142047": 96,
    "142048": 96,
    "142049": 96,
    "142050": 96,
    "142052": 96,
    "142053": 96,
    "142055": 96,
    "142057": 96,
    "142058": 96,
    "142060": 96,
    "143001": 48,
    "143002": 48,
    "143003": 48,
    "143004": 48,
    "143005": 48,
    "143006": 48,
    "143008": 48,
    "143010": 48,
    "143021": 48,
    "143022": 48,
    "143101": 48,
    "143102": 120,
    "143104": 48,
    "143105": 48,
    "143106": 48,
    "143107": 48,
    "143112": 96,
    "143115": 48,
    "143201": 96,
    "143202": 96,
    "143204": 96,
    "143301": 96,
    "143303": 96,
    "143305": 96,
    "143401": 96,
    "143412": 96,
    "143416": 96,
    "143419": 96,
    "143501": 48,
    "143505": 96,
    "143516": 96,
    "143521": 96,
    "143531": 96,
    "143601": 120,
    "144001": 48,
    "144002": 48,
    "144003": 48,
    "144004": 48,
    "144005": 48,
    "144006": 48,
    "144007": 48,
    "144008": 48,
    "144009": 48,
    "144010": 48,
    "144011": 48,
    "144012": 48,
    "144013": 48,
    "144014": 48,
    "144015": 48,
    "144021": 48,
    "144022": 48,
    "144023": 48,
    "144027": 48,
    "144032": 48,
    "144033": 96,
    "144039": 96,
    "144040": 96,
    "144041": 96,
    "144102": 48,
    "144201": 96,
    "144203": 96,
    "144204": 96,
    "144205": 96,
    "144207": 96,
    "144211": 96,
    "144216": 96,
    "144401": 48,
    "144402": 48,
    "144403": 48,
    "144405": 48,
    "144407": 48,
    "144408": 48,
    "144409": 96,
    "144410": 96,
    "144411": 48,
    "144415": 96,
    "144416": 96,
    "144417": 96,
    "144421": 96,
    "144422": 96,
    "144501": 48,
    "144502": 48,
    "144503": 48,
    "144504": 48,
    "144505": 96,
    "144506": 96,
    "144507": 96,
    "144508": 96,
    "144509": 96,
    "144510": 96,
    "144511": 96,
    "144512": 96,
    "144513": 96,
    "144514": 96,
    "144515": 96,
    "144516": 96,
    "144517": 96,
    "144518": 96,
    "144521": 96,
    "144523": 96,
    "144524": 96,
    "144525": 96,
    "144526": 96,
    "144527": 96,
    "144528": 96,
    "144532": 96,
    "144533": 48,
    "144601": 96,
    "144602": 96,
    "144621": 48,
    "144624": 48,
    "144626": 96,
    "144632": 48,
    "144633": 48,
    "144801": 48,
    "144802": 96,
    "145001": 96,
    "145023": 96,
    "146001": 48,
    "146021": 48,
    "146022": 48,
    "146023": 48,
    "146024": 48,
    "146105": 48,
    "146111": 48,
    "147001": 48,
    "147002": 48,
    "147003": 48,
    "147004": 48,
    "147005": 48,
    "147021": 48,
    "147101": 96,
    "147102": 48,
    "147103": 48,
    "147105": 96,
    "147111": 48,
    "147201": 48,
    "147202": 48,
    "147203": 48,
    "147301": 48,
    "148001": 48,
    "148002": 48,
    "148017": 48,
    "148019": 96,
    "148020": 96,
    "148021": 96,
    "148022": 96,
    "148023": 96,
    "148024": 48,
    "148025": 48,
    "148026": 48,
    "148028": 120,
    "148029": 48,
    "148031": 48,
    "148033": 96,
    "148034": 48,
    "148035": 48,
    "148100": 48,
    "148101": 48,
    "148102": 48,
    "148103": 48,
    "148104": 48,
    "148105": 48,
    "148106": 48,
    "148107": 48,
    "148108": 120,
    "148109": 120,
    "151001": 48,
    "151002": 48,
    "151003": 48,
    "151004": 48,
    "151005": 48,
    "151101": 48,
    "151102": 48,
    "151103": 120,
    "151104": 120,
    "151105": 120,
    "151106": 120,
    "151108": 120,
    "151111": 120,
    "151201": 48,
    "151202": 96,
    "151203": 96,
    "151204": 96,
    "151205": 96,
    "151206": 96,
    "151207": 96,
    "151208": 96,
    "151209": 96,
    "151210": 96,
    "151212": 96,
    "151301": 96,
    "151302": 96,
    "151401": 48,
    "151501": 96,
    "151502": 96,
    "151503": 96,
    "151504": 96,
    "151505": 96,
    "151507": 96,
    "151508": 96,
    "151509": 96,
    "151510": 48,
    "152001": 96,
    "152002": 96,
    "152003": 96,
    "152004": 96,
    "152005": 96,
    "152020": 96,
    "152021": 96,
    "152022": 96,
    "152023": 96,
    "152024": 96,
    "152025": 96,
    "152026": 96,
    "152031": 96,
    "152032": 96,
    "152033": 96,
    "152101": 96,
    "152107": 96,
    "152112": 96,
    "152113": 96,
    "152114": 96,
    "152115": 96,
    "152116": 96,
    "152117": 96,
    "152118": 96,
    "152121": 96,
    "152122": 96,
    "152123": 96,
    "152124": 96,
    "152128": 96,
    "152132": 96,
    "160001": 48,
    "160002": 48,
    "160003": 48,
    "160004": 48,
    "160005": 48,
    "160006": 48,
    "160007": 48,
    "160008": 48,
    "160009": 48,
    "160010": 48,
    "160011": 48,
    "160012": 48,
    "160013": 48,
    "160014": 48,
    "160015": 48,
    "160016": 48,
    "160017": 48,
    "160018": 48,
    "160019": 48,
    "160020": 48,
    "160021": 48,
    "160022": 48,
    "160023": 48,
    "160024": 48,
    "160025": 48,
    "160026": 48,
    "160027": 48,
    "160028": 48,
    "160029": 48,
    "160030": 48,
    "160031": 48,
    "160032": 48,
    "160033": 48,
    "160034": 48,
    "160035": 48,
    "160036": 48,
    "160037": 48,
    "160038": 48,
    "160039": 48,
    "160040": 48,
    "160041": 48,
    "160042": 48,
    "160043": 48,
    "160044": 48,
    "160045": 48,
    "160046": 48,
    "160047": 48,
    "160048": 48,
    "160049": 48,
    "160051": 48,
    "160052": 48,
    "160053": 48,
    "160054": 48,
    "160055": 48,
    "160056": 48,
    "160057": 48,
    "160058": 48,
    "160059": 48,
    "160061": 48,
    "160062": 48,
    "160071": 48,
    "160101": 48,
    "160102": 48,
    "160103": 48,
    "160104": 48,
    "160106": 48,
    "171001": 48,
    "171002": 48,
    "171003": 48,
    "171004": 48,
    "171005": 48,
    "171006": 48,
    "171008": 48,
    "171009": 48,
    "171010": 48,
    "171011": 48,
    "171013": 48,
    "171014": 48,
    "171015": 48,
    "171102": 96,
    "171201": 96,
    "171209": 96,
    "171212": 96,
    "171213": 96,
    "171220": 96,
    "171222": 96,
    "171226": 96,
    "172001": 96,
    "172024": 96,
    "172027": 96,
    "172029": 96,
    "172030": 96,
    "172031": 96,
    "172105": 120,
    "172107": 120,
    "172108": 120,
    "172116": 120,
    "172201": 96,
    "173001": 48,
    "173021": 48,
    "173025": 48,
    "173026": 48,
    "173029": 48,
    "173030": 48,
    "173031": 48,
    "173101": 48,
    "173201": 48,
    "173202": 48,
    "173204": 48,
    "173205": 48,
    "173206": 48,
    "173207": 96,
    "173208": 96,
    "173209": 48,
    "173210": 48,
    "173211": 48,
    "173212": 48,
    "173213": 48,
    "173214": 48,
    "173220": 48,
    "173222": 96,
    "173223": 48,
    "173229": 48,
    "173230": 48,
    "173235": 96,
    "174001": 48,
    "174002": 48,
    "174004": 48,
    "174005": 48,
    "174011": 48,
    "174012": 48,
    "174013": 48,
    "174015": 48,
    "174021": 48,
    "174023": 48,
    "174024": 48,
    "174026": 48,
    "174027": 48,
    "174028": 48,
    "174029": 48,
    "174030": 48,
    "174031": 48,
    "174032": 48,
    "174033": 48,
    "174034": 48,
    "174036": 48,
    "174101": 48,
    "174103": 48,
    "174201": 48,
    "174301": 48,
    "174302": 96,
    "174303": 48,
    "174304": 96,
    "174305": 96,
    "174306": 48,
    "174307": 96,
    "174308": 96,
    "174310": 48,
    "174314": 96,
    "174315": 48,
    "174317": 48,
    "174319": 96,
    "174507": 48,
    "175001": 96,
    "175002": 96,
    "175003": 96,
    "175004": 96,
    "175005": 96,
    "175006": 96,
    "175008": 96,
    "175010": 96,
    "175011": 96,
    "175012": 96,
    "175015": 96,
    "175017": 48,
    "175018": 96,
    "175019": 96,
    "175021": 96,
    "175023": 96,
    "175024": 96,
    "175025": 96,
    "175026": 96,
    "175027": 96,
    "175028": 96,
    "175029": 96,
    "175030": 48,
    "175032": 96,
    "175033": 96,
    "175034": 96,
    "175036": 96,
    "175039": 96,
    "175040": 96,
    "175042": 96,
    "175045": 96,
    "175046": 96,
    "175049": 96,
    "175101": 96,
    "175103": 96,
    "175104": 96,
    "175121": 96,
    "175125": 96,
    "175126": 96,
    "175128": 96,
    "175129": 96,
    "175130": 96,
    "175131": 96,
    "175136": 96,
    "175138": 96,
    "175143": 96,
    "176001": 96,
    "176002": 96,
    "176022": 144,
    "176023": 144,
    "176026": 96,
    "176028": 96,
    "176029": 96,
    "176031": 96,
    "176036": 96,
    "176037": 96,
    "176038": 96,
    "176041": 96,
    "176042": 48,
    "176043": 48,
    "176045": 96,
    "176047": 96,
    "176048": 96,
    "176051": 144,
    "176052": 96,
    "176053": 144,
    "176054": 96,
    "176056": 96,
    "176057": 96,
    "176059": 96,
    "176060": 96,
    "176061": 96,
    "176062": 96,
    "176063": 96,
    "176064": 96,
    "176066": 96,
    "176073": 96,
    "176075": 96,
    "176076": 96,
    "176077": 96,
    "176081": 96,
    "176082": 96,
    "176083": 96,
    "176084": 96,
    "176085": 96,
    "176086": 96,
    "176087": 96,
    "176088": 96,
    "176090": 96,
    "176091": 96,
    "176092": 96,
    "176093": 96,
    "176095": 96,
    "176096": 96,
    "176097": 96,
    "176098": 96,
    "176101": 96,
    "176102": 96,
    "176103": 96,
    "176107": 96,
    "176108": 96,
    "176109": 96,
    "176110": 96,
    "176111": 96,
    "176115": 96,
    "176125": 96,
    "176128": 96,
    "176201": 144,
    "176202": 144,
    "176205": 96,
    "176206": 96,
    "176208": 96,
    "176209": 96,
    "176213": 96,
    "176214": 96,
    "176215": 96,
    "176216": 96,
    "176217": 96,
    "176218": 96,
    "176219": 96,
    "176301": 168,
    "176302": 168,
    "176303": 168,
    "176304": 168,
    "176305": 168,
    "176306": 168,
    "176310": 168,
    "176314": 168,
    "176318": 168,
    "176403": 96,
    "176601": 48,
    "177001": 48,
    "177005": 48,
    "177022": 96,
    "177023": 96,
    "177024": 96,
    "177025": 96,
    "177026": 96,
    "177027": 48,
    "177028": 96,
    "177029": 48,
    "177033": 96,
    "177038": 96,
    "177040": 96,
    "177041": 96,
    "177042": 96,
    "177043": 96,
    "177044": 96,
    "177045": 96,
    "177048": 96,
    "177101": 96,
    "177103": 96,
    "177104": 96,
    "177105": 96,
    "177106": 96,
    "177107": 96,
    "177108": 96,
    "177109": 96,
    "177110": 96,
    "177113": 96,
    "177114": 96,
    "177117": 96,
    "177201": 96,
    "177202": 96,
    "177203": 96,
    "177204": 96,
    "177205": 96,
    "177206": 96,
    "177207": 48,
    "177208": 96,
    "177209": 48,
    "177210": 96,
    "177211": 96,
    "177212": 96,
    "177213": 96,
    "177219": 96,
    "177220": 48,
    "177301": 96,
    "177601": 96,
    "180001": 48,
    "180002": 48,
    "180003": 96,
    "180004": 48,
    "180005": 48,
    "180006": 48,
    "180007": 48,
    "180010": 48,
    "180011": 48,
    "180012": 48,
    "180013": 48,
    "180015": 48,
    "180016": 48,
    "180017": 96,
    "180018": 48,
    "180019": 96,
    "180020": 48,
    "181101": 96,
    "181102": 96,
    "181111": 96,
    "181121": 48,
    "181122": 96,
    "181123": 48,
    "181124": 48,
    "181132": 96,
    "181133": 96,
    "181134": 96,
    "181141": 96,
    "181143": 96,
    "181145": 96,
    "181152": 48,
    "181201": 96,
    "181202": 96,
    "181205": 48,
    "181206": 96,
    "181221": 96,
    "182101": 96,
    "182104": 96,
    "182121": 96,
    "182122": 96,
    "182301": 96,
    "182311": 96,
    "182320": 96,
    "184101": 96,
    "184102": 96,
    "184104": 96,
    "184120": 96,
    "184121": 96,
    "184141": 96,
    "184142": 96,
    "184143": 96,
    "184144": 96,
    "184148": 96,
    "184151": 96,
    "184152": 96,
    "190001": 96,
    "190005": 96,
    "190007": 96,
    "190008": 96,
    "190014": 96,
    "190015": 96,
    "201001": 24,
    "201002": 24,
    "201003": 24,
    "201004": 24,
    "201005": 24,
    "201006": 24,
    "201007": 24,
    "201008": 48,
    "201009": 24,
    "201010": 24,
    "201011": 24,
    "201012": 24,
    "201013": 24,
    "201014": 24,
    "201015": 24,
    "201016": 24,
    "201017": 24,
    "201018": 24,
    "201019": 24,
    "201020": 24,
    "201102": 48,
    "201103": 48,
    "201111": 24,
    "201201": 48,
    "201204": 48,
    "201206": 48,
    "201301": 24,
    "201303": 24,
    "201304": 24,
    "201305": 24,
    "201306": 24,
    "201307": 24,
    "201308": 24,
    "201309": 24,
    "201310": 24,
    "201311": 24,
    "201312": 24,
    "201313": 24,
    "201314": 48,
    "201315": 24,
    "201316": 24,
    "201317": 24,
    "201318": 24,
    "202001": 48,
    "202002": 48,
    "202124": 48,
    "202125": 48,
    "202127": 48,
    "202130": 48,
    "202138": 48,
    "202145": 48,
    "202280": 48,
    "203001": 48,
    "203002": 48,
    "203131": 48,
    "203132": 48,
    "203135": 24,
    "203150": 48,
    "203201": 24,
    "203202": 24,
    "203203": 24,
    "203205": 24,
    "203206": 24,
    "203207": 48,
    "203209": 24,
    "203389": 48,
    "203390": 48,
    "203393": 48,
    "203394": 48,
    "203395": 48,
    "203401": 48,
    "203408": 24,
    "203411": 48,
    "203412": 48,
    "204101": 96,
    "204213": 96,
    "204215": 48,
    "204216": 96,
    "205001": 96,
    "205121": 96,
    "205261": 96,
    "205262": 96,
    "205264": 96,
    "205265": 96,
    "205301": 96,
    "205303": 96,
    "206001": 96,
    "206002": 96,
    "206003": 96,
    "206120": 96,
    "206121": 96,
    "206122": 96,
    "206123": 96,
    "206124": 96,
    "206125": 96,
    "206126": 96,
    "206127": 96,
    "206128": 96,
    "206129": 96,
    "206130": 96,
    "206131": 96,
    "206241": 96,
    "206242": 96,
    "206243": 96,
    "206244": 96,
    "206245": 96,
    "206246": 96,
    "206247": 96,
    "206249": 96,
    "206252": 96,
    "206253": 96,
    "207001": 96,
    "208001": 48,
    "208002": 48,
    "208003": 48,
    "208004": 48,
    "208005": 48,
    "208006": 48,
    "208007": 48,
    "208008": 48,
    "208009": 48,
    "208010": 48,
    "208011": 48,
    "208012": 48,
    "208013": 48,
    "208014": 48,
    "208015": 48,
    "208016": 48,
    "208017": 48,
    "208018": 48,
    "208019": 48,
    "208020": 48,
    "208021": 48,
    "208022": 48,
    "208023": 48,
    "208024": 48,
    "208025": 48,
    "208026": 48,
    "208027": 48,
    "209101": 96,
    "209111": 96,
    "209112": 96,
    "209115": 96,
    "209121": 96,
    "209125": 96,
    "209202": 96,
    "209203": 48,
    "209204": 48,
    "209205": 48,
    "209206": 48,
    "209214": 48,
    "209217": 48,
    "209302": 96,
    "209303": 96,
    "209304": 48,
    "209305": 48,
    "209306": 48,
    "209307": 96,
    "209310": 96,
    "209311": 96,
    "209401": 48,
    "209402": 48,
    "209501": 96,
    "209502": 96,
    "209503": 96,
    "209601": 96,
    "209602": 96,
    "209621": 96,
    "209622": 96,
    "209624": 96,
    "209625": 96,
    "209651": 96,
    "209652": 96,
    "209721": 96,
    "209722": 96,
    "209723": 96,
    "209724": 96,
    "209725": 48,
    "209726": 48,
    "209727": 48,
    "209728": 96,
    "209729": 96,
    "209731": 96,
    "209732": 96,
    "209733": 96,
    "209739": 96,
    "209743": 96,
    "209801": 48,
    "209821": 48,
    "209825": 48,
    "209827": 48,
    "209831": 48,
    "209841": 48,
    "209859": 48,
    "209861": 48,
    "209862": 48,
    "209863": 48,
    "209865": 48,
    "209866": 48,
    "209867": 48,
    "209868": 48,
    "209871": 48,
    "210001": 96,
    "210010": 48,
    "210129": 96,
    "210201": 96,
    "210204": 96,
    "210205": 96,
    "210206": 96,
    "210207": 96,
    "210208": 96,
    "210209": 96,
    "210301": 96,
    "210341": 96,
    "210421": 96,
    "210423": 96,
    "210424": 96,
    "210425": 96,
    "210426": 96,
    "210427": 96,
    "210429": 96,
    "210431": 96,
    "210501": 96,
    "210502": 96,
    "210504": 96,
    "210505": 96,
    "210506": 96,
    "210507": 96,
    "211001": 48,
    "211002": 48,
    "211003": 48,
    "211004": 48,
    "211005": 48,
    "211006": 48,
    "211007": 48,
    "211008": 48,
    "211009": 48,
    "211010": 48,
    "211011": 48,
    "211012": 48,
    "211013": 48,
    "211014": 48,
    "211015": 48,
    "211016": 48,
    "211017": 48,
    "211018": 48,
    "211019": 48,
    "212105": 48,
    "212201": 96,
    "212202": 96,
    "212203": 96,
    "212205": 96,
    "212206": 96,
    "212207": 96,
    "212212": 48,
    "212213": 96,
    "212217": 96,
    "212301": 48,
    "212405": 48,
    "212601": 96,
    "212620": 96,
    "212622": 96,
    "212635": 96,
    "212651": 96,
    "212652": 96,
    "212655": 96,
    "212657": 96,
    "212663": 96,
    "212664": 96,
    "212665": 96,
    "221001": 48,
    "221002": 48,
    "221003": 48,
    "221004": 48,
    "221005": 48,
    "221006": 48,
    "221007": 48,
    "221008": 48,
    "221010": 48,
    "221011": 48,
    "221012": 48,
    "221101": 48,
    "221103": 48,
    "221105": 48,
    "221106": 48,
    "221107": 48,
    "221108": 48,
    "221109": 48,
    "221301": 96,
    "221302": 48,
    "221303": 96,
    "221304": 96,
    "221306": 96,
    "221308": 96,
    "221310": 96,
    "221314": 96,
    "221401": 96,
    "221402": 96,
    "221403": 96,
    "221404": 96,
    "221406": 96,
    "221409": 96,
    "221503": 48,
    "221505": 48,
    "221701": 96,
    "221711": 96,
    "221712": 96,
    "221713": 96,
    "221717": 96,
    "222001": 96,
    "222002": 96,
    "222109": 96,
    "222125": 96,
    "222129": 96,
    "222131": 96,
    "222132": 96,
    "222136": 96,
    "222139": 96,
    "222142": 96,
    "222143": 96,
    "222161": 96,
    "222170": 96,
    "222180": 96,
    "222201": 96,
    "222203": 96,
    "222302": 48,
    "222333": 24,
    "223101": 96,
    "223223": 96,
    "224001": 96,
    "224120": 96,
    "224122": 96,
    "224123": 96,
    "224127": 96,
    "224129": 96,
    "224133": 96,
    "224135": 96,
    "224141": 96,
    "224143": 96,
    "224145": 96,
    "224149": 96,
    "224155": 96,
    "224158": 96,
    "224164": 96,
    "224188": 96,
    "224190": 96,
    "224201": 96,
    "224206": 96,
    "224207": 96,
    "224209": 96,
    "224229": 96,
    "224238": 96,
    "225001": 96,
    "225002": 96,
    "225003": 96,
    "225119": 96,
    "225120": 96,
    "225121": 96,
    "225122": 96,
    "225123": 96,
    "225124": 96,
    "225201": 96,
    "225202": 96,
    "225203": 96,
    "225204": 96,
    "225205": 96,
    "225206": 96,
    "225207": 96,
    "225208": 96,
    "225301": 96,
    "225302": 96,
    "225303": 96,
    "225304": 96,
    "225305": 96,
    "225306": 96,
    "225403": 96,
    "225405": 96,
    "225409": 96,
    "225412": 96,
    "225413": 96,
    "225414": 96,
    "225415": 96,
    "226001": 48,
    "226002": 48,
    "226003": 48,
    "226004": 48,
    "226005": 48,
    "226006": 48,
    "226007": 48,
    "226008": 48,
    "226009": 48,
    "226010": 48,
    "226011": 48,
    "226012": 48,
    "226013": 48,
    "226014": 48,
    "226015": 48,
    "226016": 48,
    "226017": 48,
    "226018": 48,
    "226019": 48,
    "226020": 48,
    "226021": 48,
    "226022": 48,
    "226023": 48,
    "226024": 48,
    "226025": 48,
    "226026": 48,
    "226027": 48,
    "226028": 48,
    "226029": 48,
    "226030": 48,
    "226031": 48,
    "226101": 48,
    "226102": 48,
    "226103": 48,
    "226104": 48,
    "226201": 48,
    "226202": 48,
    "226203": 48,
    "226301": 48,
    "226302": 48,
    "226303": 48,
    "226401": 48,
    "226501": 48,
    "227105": 48,
    "227405": 48,
    "227408": 48,
    "227409": 48,
    "227411": 48,
    "227412": 48,
    "227801": 48,
    "227805": 48,
    "227808": 48,
    "227809": 48,
    "227812": 48,
    "227813": 48,
    "227817": 48,
    "228001": 48,
    "228118": 48,
    "228119": 48,
    "228125": 48,
    "228141": 48,
    "228145": 48,
    "228155": 48,
    "229001": 48,
    "229010": 48,
    "229120": 48,
    "229122": 48,
    "229124": 48,
    "229126": 48,
    "229127": 48,
    "229129": 48,
    "229206": 48,
    "229207": 48,
    "229301": 48,
    "229302": 48,
    "229303": 48,
    "229304": 48,
    "229305": 48,
    "229306": 48,
    "229307": 48,
    "229309": 48,
    "229310": 48,
    "229316": 48,
    "229401": 48,
    "229402": 48,
    "229404": 48,
    "229405": 48,
    "229406": 48,
    "229801": 48,
    "230001": 96,
    "230002": 96,
    "230124": 96,
    "230132": 96,
    "230135": 96,
    "230136": 96,
    "230301": 96,
    "230304": 96,
    "230402": 96,
    "230403": 96,
    "230501": 96,
    "230502": 96,
    "230503": 96,
    "231001": 96,
    "231205": 96,
    "231206": 96,
    "231208": 96,
    "231210": 96,
    "231213": 96,
    "231215": 96,
    "231216": 96,
    "231217": 96,
    "231218": 96,
    "231219": 96,
    "231220": 96,
    "231221": 96,
    "231222": 96,
    "231223": 96,
    "231225": 96,
    "231301": 96,
    "231304": 96,
    "231305": 48,
    "231306": 96,
    "231307": 96,
    "231501": 96,
    "232101": 48,
    "232104": 48,
    "232326": 96,
    "232333": 96,
    "233001": 96,
    "233224": 96,
    "233226": 96,
    "233228": 96,
    "233230": 96,
    "233232": 96,
    "233300": 96,
    "233302": 96,
    "233303": 96,
    "233304": 96,
    "233305": 96,
    "233306": 96,
    "241001": 96,
    "242001": 96,
    "242021": 48,
    "242042": 96,
    "242220": 96,
    "242221": 96,
    "242223": 96,
    "242301": 96,
    "242305": 96,
    "242306": 96,
    "242307": 96,
    "242401": 96,
    "242405": 96,
    "242406": 96,
    "242407": 96,
    "243001": 48,
    "243002": 48,
    "243003": 48,
    "243004": 48,
    "243005": 48,
    "243006": 48,
    "243122": 48,
    "243123": 48,
    "243126": 48,
    "243201": 48,
    "243202": 48,
    "243301": 96,
    "243302": 96,
    "243303": 96,
    "243401": 96,
    "243403": 96,
    "243501": 48,
    "243502": 48,
    "243503": 48,
    "243504": 48,
    "243505": 48,
    "243601": 96,
    "243631": 96,
    "243633": 96,
    "243634": 96,
    "243635": 96,
    "243636": 96,
    "243637": 96,
    "243638": 96,
    "243639": 96,
    "243641": 96,
    "243720": 96,
    "243722": 48,
    "243723": 48,
    "243724": 96,
    "243726": 96,
    "243727": 48,
    "244001": 48,
    "244102": 48,
    "244103": 48,
    "244104": 48,
    "244105": 48,
    "244221": 96,
    "244222": 48,
    "244223": 48,
    "244225": 96,
    "244231": 96,
    "244235": 48,
    "244236": 96,
    "244241": 48,
    "244242": 48,
    "244251": 96,
    "244301": 48,
    "244302": 48,
    "244303": 48,
    "244304": 48,
    "244401": 48,
    "244402": 48,
    "244410": 48,
    "244411": 48,
    "244412": 48,
    "244413": 48,
    "244501": 48,
    "244601": 48,
    "244602": 48,
    "244701": 48,
    "244712": 48,
    "244713": 48,
    "244715": 48,
    "244901": 48,
    "244921": 48,
    "244922": 48,
    "244923": 48,
    "244924": 48,
    "244925": 48,
    "244927": 48,
    "244928": 48,
    "245101": 24,
    "245201": 24,
    "245206": 24,
    "245207": 24,
    "245301": 24,
    "245304": 24,
    "246001": 120,
    "246127": 96,
    "246149": 96,
    "246171": 96,
    "246174": 96,
    "246401": 120,
    "246421": 96,
    "246424": 120,
    "246472": 120,
    "246475": 96,
    "246701": 48,
    "246721": 48,
    "246722": 48,
    "246724": 48,
    "246725": 48,
    "246726": 48,
    "246727": 48,
    "246728": 48,
    "246731": 48,
    "246732": 48,
    "246733": 48,
    "246734": 48,
    "246735": 48,
    "246736": 48,
    "246746": 48,
    "246747": 48,
    "246749": 48,
    "246761": 48,
    "246762": 48,
    "246763": 48,
    "246764": 48,
    "247001": 48,
    "247002": 48,
    "247120": 48,
    "247121": 48,
    "247122": 48,
    "247129": 48,
    "247231": 48,
    "247232": 48,
    "247340": 48,
    "247341": 48,
    "247342": 48,
    "247451": 48,
    "247452": 48,
    "247551": 48,
    "247554": 48,
    "247656": 48,
    "247661": 48,
    "247662": 48,
    "247663": 48,
    "247664": 48,
    "247665": 48,
    "247666": 48,
    "247667": 48,
    "247668": 48,
    "247669": 48,
    "247771": 96,
    "247772": 96,
    "247773": 96,
    "247774": 96,
    "247775": 96,
    "247776": 96,
    "247777": 96,
    "247778": 96,
    "248001": 48,
    "248002": 48,
    "248003": 48,
    "248005": 48,
    "248006": 48,
    "248007": 48,
    "248008": 48,
    "248009": 48,
    "248010": 48,
    "248011": 96,
    "248012": 48,
    "248013": 48,
    "248014": 48,
    "248015": 48,
    "248016": 96,
    "248102": 48,
    "248110": 48,
    "248115": 48,
    "248121": 48,
    "248122": 48,
    "248125": 96,
    "248126": 48,
    "248140": 96,
    "248141": 48,
    "248142": 96,
    "248143": 96,
    "248145": 96,
    "248146": 48,
    "248160": 48,
    "248161": 96,
    "248171": 48,
    "248195": 48,
    "248197": 96,
    "248198": 96,
    "249137": 48,
    "249175": 48,
    "249201": 48,
    "249202": 48,
    "249203": 48,
    "249204": 48,
    "249205": 48,
    "249302": 48,
    "249401": 48,
    "249402": 48,
    "249403": 48,
    "249404": 48,
    "249405": 48,
    "249407": 48,
    "249408": 48,
    "249409": 48,
    "249410": 48,
    "249411": 48,
    "250001": 48,
    "250002": 48,
    "250003": 48,
    "250004": 48,
    "250005": 48,
    "250101": 48,
    "250105": 48,
    "250110": 48,
    "250345": 48,
    "250402": 96,
    "250404": 96,
    "250406": 96,
    "250501": 96,
    "250502": 96,
    "250601": 48,
    "250606": 48,
    "250609": 48,
    "250611": 48,
    "250615": 48,
    "250617": 48,
    "250619": 48,
    "250620": 48,
    "250622": 48,
    "250625": 48,
    "251301": 96,
    "251305": 96,
    "251309": 96,
    "251319": 96,
    "261001": 48,
    "261121": 96,
    "261131": 96,
    "261135": 48,
    "261141": 96,
    "261201": 96,
    "261202": 96,
    "261203": 96,
    "261204": 96,
    "261205": 96,
    "261206": 96,
    "261208": 96,
    "261301": 96,
    "261302": 96,
    "261303": 96,
    "261401": 96,
    "261402": 96,
    "261403": 96,
    "261405": 96,
    "261501": 48,
    "261505": 48,
    "261506": 48,
    "262001": 96,
    "262122": 96,
    "262201": 96,
    "262302": 48,
    "262308": 96,
    "262401": 48,
    "262405": 96,
    "262406": 48,
    "262501": 120,
    "262520": 120,
    "262523": 120,
    "262524": 120,
    "262530": 120,
    "262701": 48,
    "262702": 48,
    "262721": 48,
    "262722": 48,
    "262724": 48,
    "262725": 48,
    "262726": 48,
    "262728": 48,
    "262801": 48,
    "262802": 48,
    "262803": 48,
    "262804": 48,
    "262805": 48,
    "262901": 48,
    "262902": 48,
    "262903": 48,
    "262907": 48,
    "263126": 96,
    "263139": 96,
    "263141": 96,
    "263145": 48,
    "263148": 48,
    "263152": 48,
    "263153": 48,
    "263160": 48,
    "263601": 120,
    "263637": 120,
    "263645": 96,
    "263653": 120,
    "263656": 120,
    "271001": 96,
    "271002": 96,
    "271003": 96,
    "271201": 96,
    "271205": 96,
    "271208": 96,
    "271210": 96,
    "271302": 96,
    "271303": 96,
    "271305": 96,
    "271306": 96,
    "271313": 96,
    "271604": 96,
    "271607": 96,
    "271609": 96,
    "271801": 96,
    "271803": 96,
    "271821": 96,
    "271824": 96,
    "271831": 96,
    "271835": 96,
    "271845": 96,
    "271851": 96,
    "271855": 96,
    "271861": 96,
    "271865": 96,
    "271871": 96,
    "271875": 96,
    "271882": 96,
    "271902": 96,
    "271903": 96,
    "272001": 96,
    "272002": 96,
    "272123": 96,
    "272124": 96,
    "272125": 96,
    "272127": 96,
    "272131": 96,
    "272151": 96,
    "272152": 96,
    "272153": 96,
    "272155": 96,
    "272162": 96,
    "272163": 96,
    "272164": 96,
    "272172": 96,
    "272173": 96,
    "272175": 96,
    "272176": 96,
    "272178": 96,
    "272182": 96,
    "272189": 96,
    "272190": 96,
    "272192": 96,
    "272194": 96,
    "272199": 96,
    "272201": 96,
    "272202": 96,
    "272203": 96,
    "272204": 96,
    "272205": 96,
    "272206": 96,
    "272207": 96,
    "272270": 96,
    "272271": 96,
    "272301": 96,
    "272302": 96,
    "273001": 48,
    "273002": 48,
    "273003": 48,
    "273004": 48,
    "273005": 48,
    "273006": 48,
    "273007": 48,
    "273008": 48,
    "273009": 48,
    "273010": 48,
    "273012": 48,
    "273013": 48,
    "273014": 48,
    "273015": 48,
    "273016": 48,
    "273017": 48,
    "273151": 96,
    "273152": 48,
    "273155": 96,
    "273161": 96,
    "273162": 96,
    "273163": 96,
    "273164": 96,
    "273165": 48,
    "273201": 48,
    "273202": 48,
    "273203": 48,
    "273207": 96,
    "273209": 96,
    "273212": 96,
    "273213": 96,
    "273301": 96,
    "273302": 96,
    "273303": 96,
    "273304": 96,
    "273305": 96,
    "273308": 96,
    "273310": 96,
    "273401": 96,
    "273402": 96,
    "273403": 96,
    "273406": 96,
    "273408": 96,
    "273409": 96,
    "273411": 96,
    "273412": 96,
    "273413": 96,
    "274001": 96,
    "274202": 96,
    "274204": 96,
    "274304": 96,
    "274401": 96,
    "274402": 96,
    "274403": 96,
    "274404": 96,
    "274406": 96,
    "274502": 96,
    "274509": 96,
    "274601": 96,
    "274702": 96,
    "275101": 96,
    "275102": 96,
    "275201": 96,
    "275301": 96,
    "275303": 96,
    "275304": 96,
    "275305": 96,
    "275307": 96,
    "276001": 96,
    "276121": 96,
    "276128": 96,
    "276129": 96,
    "276141": 96,
    "276202": 96,
    "276204": 96,
    "276206": 96,
    "276207": 96,
    "276303": 96,
    "276304": 96,
    "276305": 96,
    "276306": 96,
    "276402": 96,
    "276403": 96,
    "276404": 96,
    "277001": 96,
    "277123": 96,
    "277202": 96,
    "277209": 96,
    "277211": 96,
    "277303": 96,
    "277304": 96,
    "277401": 96,
    "277501": 96,
    "277503": 96,
    "281001": 48,
    "281003": 48,
    "281004": 48,
    "281005": 48,
    "281006": 48,
    "281121": 48,
    "281122": 48,
    "281123": 48,
    "281201": 48,
    "281202": 48,
    "281204": 48,
    "281301": 48,
    "281306": 96,
    "281401": 48,
    "281403": 48,
    "281406": 48,
    "281501": 48,
    "281502": 48,
    "282001": 48,
    "282002": 48,
    "282003": 48,
    "282004": 48,
    "282005": 48,
    "282006": 48,
    "282007": 48,
    "282008": 48,
    "282009": 48,
    "282010": 48,
    "283101": 48,
    "283102": 48,
    "283105": 48,
    "283110": 48,
    "283111": 48,
    "283112": 48,
    "283119": 48,
    "283121": 48,
    "283122": 48,
    "283124": 48,
    "283125": 48,
    "283126": 48,
    "283130": 96,
    "283135": 96,
    "283145": 96,
    "283151": 96,
    "283152": 96,
    "283201": 48,
    "283202": 48,
    "283203": 96,
    "283204": 96,
    "284001": 48,
    "284002": 48,
    "284003": 48,
    "284120": 48,
    "284121": 48,
    "284124": 96,
    "284125": 96,
    "284126": 96,
    "284128": 48,
    "284135": 48,
    "284201": 48,
    "284202": 48,
    "284204": 48,
    "284205": 48,
    "284301": 48,
    "284303": 48,
    "284305": 48,
    "284401": 48,
    "284403": 96,
    "284404": 96,
    "284405": 96,
    "285001": 96,
    "285122": 96,
    "285123": 96,
    "285201": 96,
    "285202": 96,
    "285204": 96,
    "285205": 96,
    "301001": 48,
    "301018": 48,
    "301019": 48,
    "301020": 48,
    "301021": 48,
    "301022": 48,
    "301024": 48,
    "301030": 48,
    "301402": 48,
    "301404": 48,
    "301405": 48,
    "301411": 48,
    "301427": 48,
    "301701": 48,
    "301702": 48,
    "301703": 48,
    "301704": 48,
    "301705": 48,
    "301706": 48,
    "301707": 48,
    "301713": 48,
    "302001": 48,
    "302002": 48,
    "302003": 48,
    "302004": 48,
    "302005": 48,
    "302006": 48,
    "302007": 48,
    "302008": 48,
    "302009": 48,
    "302010": 48,
    "302011": 48,
    "302012": 48,
    "302013": 48,
    "302015": 48,
    "302016": 48,
    "302017": 48,
    "302018": 48,
    "302019": 48,
    "302020": 48,
    "302021": 48,
    "302022": 48,
    "302023": 48,
    "302024": 48,
    "302025": 48,
    "302026": 48,
    "302027": 48,
    "302028": 48,
    "302029": 48,
    "302031": 48,
    "302032": 48,
    "302033": 48,
    "302034": 48,
    "302037": 48,
    "302039": 48,
    "302111": 48,
    "303005": 48,
    "303007": 48,
    "303008": 48,
    "303012": 48,
    "303101": 48,
    "303103": 48,
    "303106": 48,
    "303108": 48,
    "303301": 48,
    "303303": 96,
    "303305": 96,
    "303313": 96,
    "303326": 96,
    "303338": 48,
    "303501": 96,
    "303503": 48,
    "303504": 48,
    "303505": 48,
    "303509": 96,
    "303510": 48,
    "303511": 48,
    "303702": 48,
    "303704": 48,
    "303712": 48,
    "303805": 48,
    "303806": 48,
    "303901": 48,
    "303903": 48,
    "303904": 48,
    "303905": 48,
    "303908": 48,
    "304021": 48,
    "304022": 48,
    "305001": 48,
    "305002": 48,
    "305003": 48,
    "305004": 48,
    "305005": 48,
    "305006": 48,
    "305007": 48,
    "305008": 48,
    "305022": 96,
    "305025": 96,
    "305401": 96,
    "305402": 96,
    "305404": 96,
    "305601": 96,
    "305624": 48,
    "305801": 48,
    "305802": 48,
    "305814": 48,
    "305817": 48,
    "305901": 48,
    "306103": 48,
    "306104": 48,
    "306115": 48,
    "306116": 48,
    "306302": 96,
    "306401": 48,
    "306902": 96,
    "307001": 48,
    "307019": 48,
    "307022": 48,
    "307023": 48,
    "307026": 48,
    "307027": 48,
    "307029": 96,
    "307510": 48,
    "307513": 48,
    "307514": 48,
    "307801": 48,
    "311001": 48,
    "311011": 48,
    "311021": 48,
    "311022": 48,
    "311024": 48,
    "311025": 48,
    "311301": 48,
    "311401": 48,
    "311402": 48,
    "311403": 48,
    "311601": 48,
    "311603": 48,
    "311604": 48,
    "311801": 48,
    "311802": 48,
    "312001": 96,
    "312021": 96,
    "312022": 96,
    "312024": 96,
    "312601": 96,
    "312605": 48,
    "312612": 96,
    "312617": 96,
    "312901": 96,
    "313001": 48,
    "313002": 48,
    "313003": 48,
    "313004": 48,
    "313011": 48,
    "313022": 48,
    "313024": 48,
    "313202": 48,
    "313203": 48,
    "313205": 48,
    "313211": 48,
    "313301": 48,
    "313324": 48,
    "313601": 48,
    "313602": 48,
    "313901": 48,
    "314025": 48,
    "314026": 48,
    "321001": 48,
    "321201": 48,
    "321202": 48,
    "321401": 48,
    "321404": 48,
    "321602": 48,
    "322001": 48,
    "322021": 48,
    "322024": 48,
    "322201": 96,
    "322202": 96,
    "322220": 96,
    "322230": 96,
    "322241": 96,
    "322702": 48,
    "323001": 48,
    "323021": 48,
    "324001": 48,
    "324002": 48,
    "324003": 48,
    "324004": 48,
    "324005": 48,
    "324006": 48,
    "324007": 48,
    "324008": 48,
    "324009": 48,
    "324010": 48,
    "325001": 48,
    "325202": 48,
    "325601": 96,
    "326001": 96,
    "326038": 96,
    "327001": 48,
    "327022": 48,
    "327024": 48,
    "328001": 48,
    "328021": 48,
    "328024": 48,
    "331001": 48,
    "331021": 48,
    "331022": 48,
    "331023": 48,
    "331024": 48,
    "331025": 48,
    "331027": 48,
    "331028": 48,
    "331304": 48,
    "331305": 48,
    "331403": 96,
    "331411": 96,
    "331506": 96,
    "331507": 96,
    "331517": 96,
    "331802": 96,
    "331803": 48,
    "331811": 48,
    "332001": 48,
    "332002": 48,
    "332021": 48,
    "332023": 48,
    "332024": 48,
    "332031": 48,
    "332041": 48,
    "332301": 48,
    "332311": 48,
    "332402": 48,
    "332403": 48,
    "332404": 48,
    "332405": 48,
    "332713": 48,
    "332715": 48,
    "332718": 48,
    "333001": 48,
    "333021": 48,
    "333022": 48,
    "333023": 48,
    "333025": 48,
    "333026": 48,
    "333029": 48,
    "333031": 48,
    "333035": 48,
    "333042": 96,
    "333307": 96,
    "333516": 48,
    "333704": 48,
    "333705": 96,
    "334001": 48,
    "334003": 48,
    "334004": 48,
    "334006": 48,
    "334022": 48,
    "334401": 48,
    "334402": 48,
    "334403": 48,
    "334603": 48,
    "334802": 96,
    "334803": 96,
    "335001": 48,
    "335002": 48,
    "335024": 48,
    "335027": 48,
    "335037": 48,
    "335041": 48,
    "335051": 48,
    "335062": 96,
    "335063": 96,
    "335073": 48,
    "335501": 96,
    "335502": 96,
    "335504": 96,
    "335505": 48,
    "335511": 48,
    "335512": 96,
    "335513": 96,
    "335514": 48,
    "335523": 96,
    "335524": 96,
    "335525": 96,
    "335526": 96,
    "335702": 96,
    "335704": 96,
    "335801": 96,
    "335802": 96,
    "335803": 96,
    "335804": 96,
    "335805": 96,
    "341001": 48,
    "341021": 48,
    "341024": 48,
    "341026": 48,
    "341028": 48,
    "341302": 96,
    "341303": 96,
    "341304": 96,
    "341306": 96,
    "341316": 96,
    "341502": 96,
    "341505": 96,
    "341506": 96,
    "341508": 96,
    "341509": 96,
    "341512": 48,
    "342001": 48,
    "342002": 48,
    "342003": 48,
    "342004": 48,
    "342005": 48,
    "342006": 48,
    "342007": 48,
    "342008": 48,
    "342009": 48,
    "342010": 48,
    "342011": 48,
    "342012": 48,
    "342013": 48,
    "342014": 48,
    "342015": 48,
    "342024": 48,
    "342026": 48,
    "342027": 48,
    "342037": 48,
    "342301": 96,
    "342304": 48,
    "342305": 48,
    "342307": 96,
    "342601": 96,
    "342602": 96,
    "342801": 48,
    "343001": 96,
    "343022": 96,
    "343029": 96,
    "344001": 96,
    "344011": 96,
    "344022": 96,
    "344024": 96,
    "344032": 96,
    "344033": 96,
    "344034": 96,
    "344035": 96,
    "344701": 96,
    "344702": 96,
    "345001": 96,
    "345021": 96,
    "360001": 48,
    "360002": 48,
    "360003": 48,
    "360004": 48,
    "360005": 48,
    "360006": 48,
    "360007": 48,
    "360008": 48,
    "360009": 48,
    "360020": 24,
    "360021": 48,
    "360023": 48,
    "360024": 48,
    "360040": 48,
    "360050": 48,
    "360055": 48,
    "360060": 48,
    "360070": 48,
    "360110": 24,
    "360311": 48,
    "360320": 48,
    "360360": 48,
    "360370": 48,
    "360375": 48,
    "360405": 48,
    "360410": 48,
    "360421": 48,
    "360430": 48,
    "360440": 48,
    "360450": 48,
    "360452": 48,
    "360460": 48,
    "360470": 48,
    "360480": 48,
    "360490": 48,
    "360510": 48,
    "360530": 48,
    "360545": 48,
    "360550": 48,
    "360560": 48,
    "360570": 48,
    "360575": 48,
    "360576": 48,
    "360577": 48,
    "360578": 48,
    "360579": 48,
    "360590": 48,
    "361001": 48,
    "361002": 48,
    "361003": 48,
    "361004": 48,
    "361005": 48,
    "361006": 48,
    "361007": 48,
    "361008": 48,
    "361009": 48,
    "361010": 48,
    "361110": 48,
    "361120": 48,
    "361140": 48,
    "361141": 48,
    "361142": 48,
    "361150": 48,
    "361170": 48,
    "361210": 48,
    "361280": 48,
    "361305": 48,
    "361306": 48,
    "361310": 48,
    "361315": 48,
    "361330": 48,
    "361335": 48,
    "361345": 48,
    "361347": 48,
    "361350": 48,
    "362001": 48,
    "362002": 48,
    "362003": 48,
    "362004": 48,
    "362011": 48,
    "362015": 48,
    "362020": 48,
    "362030": 48,
    "362037": 48,
    "362110": 48,
    "362120": 48,
    "362135": 48,
    "362140": 48,
    "362150": 48,
    "362205": 48,
    "362215": 48,
    "362220": 48,
    "362222": 48,
    "362225": 48,
    "362226": 48,
    "362227": 48,
    "362229": 48,
    "362230": 48,
    "362235": 48,
    "362240": 48,
    "362245": 48,
    "362250": 48,
    "362255": 48,
    "362260": 48,
    "362265": 48,
    "362266": 48,
    "362267": 48,
    "362268": 48,
    "362269": 48,
    "362275": 48,
    "362310": 48,
    "362315": 48,
    "362520": 48,
    "362540": 48,
    "362560": 48,
    "362610": 48,
    "362620": 48,
    "362625": 48,
    "362630": 48,
    "362640": 48,
    "362650": 48,
    "362715": 48,
    "362720": 48,
    "362725": 48,
    "363001": 48,
    "363002": 48,
    "363020": 48,
    "363030": 48,
    "363035": 48,
    "363040": 48,
    "363110": 48,
    "363115": 48,
    "363310": 24,
    "363320": 24,
    "363330": 48,
    "363415": 48,
    "363421": 48,
    "363427": 48,
    "363430": 48,
    "363435": 48,
    "363510": 48,
    "363520": 48,
    "363530": 48,
    "363621": 48,
    "363641": 48,
    "363642": 48,
    "363643": 48,
    "363650": 48,
    "363660": 48,
    "364001": 24,
    "364002": 24,
    "364003": 24,
    "364004": 24,
    "364005": 24,
    "364006": 24,
    "364050": 24,
    "364055": 24,
    "364060": 48,
    "364110": 24,
    "364140": 48,
    "364150": 24,
    "364230": 48,
    "364240": 48,
    "364250": 48,
    "364265": 48,
    "364270": 48,
    "364290": 48,
    "364295": 48,
    "364310": 24,
    "364421": 48,
    "364490": 48,
    "364505": 48,
    "364515": 48,
    "364521": 48,
    "364522": 48,
    "364525": 48,
    "364540": 48,
    "364630": 48,
    "364710": 48,
    "364720": 48,
    "364750": 48,
    "364765": 48,
    "365220": 48,
    "365410": 48,
    "365421": 48,
    "365435": 48,
    "365440": 48,
    "365455": 48,
    "365456": 48,
    "365460": 48,
    "365535": 48,
    "365540": 48,
    "365541": 48,
    "365545": 48,
    "365550": 48,
    "365560": 48,
    "365565": 48,
    "365601": 48,
    "365610": 48,
    "365620": 48,
    "365630": 48,
    "365635": 48,
    "370001": 48,
    "370015": 48,
    "370020": 48,
    "370030": 48,
    "370105": 48,
    "370110": 48,
    "370130": 48,
    "370140": 48,
    "370150": 48,
    "370165": 48,
    "370201": 48,
    "370203": 24,
    "370205": 48,
    "370210": 48,
    "370230": 24,
    "370240": 24,
    "370405": 48,
    "370415": 48,
    "370421": 48,
    "370429": 48,
    "370430": 48,
    "370435": 48,
    "370445": 48,
    "370450": 48,
    "370455": 48,
    "370460": 48,
    "370465": 48,
    "370475": 48,
    "370511": 48,
    "370601": 48,
    "370605": 48,
    "370610": 48,
    "370615": 48,
    "370645": 48,
    "370655": 48,
    "370665": 48,
    "370670": 48,
    "370675": 48,
    "380001": 24,
    "380002": 24,
    "380003": 24,
    "380004": 24,
    "380005": 24,
    "380006": 24,
    "380007": 24,
    "380008": 24,
    "380009": 24,
    "380012": 24,
    "380013": 24,
    "380014": 24,
    "380015": 24,
    "380016": 24,
    "380018": 24,
    "380019": 24,
    "380021": 24,
    "380022": 24,
    "380023": 24,
    "380024": 24,
    "380025": 24,
    "380026": 24,
    "380027": 24,
    "380028": 24,
    "380050": 24,
    "380051": 24,
    "380052": 24,
    "380053": 24,
    "380054": 24,
    "380055": 24,
    "380058": 24,
    "380059": 24,
    "380060": 24,
    "380061": 24,
    "380063": 24,
    "381111": 24,
    "382001": 24,
    "382002": 24,
    "382003": 24,
    "382004": 24,
    "382005": 24,
    "382006": 24,
    "382007": 24,
    "382008": 24,
    "382009": 24,
    "382010": 24,
    "382011": 24,
    "382012": 24,
    "382013": 24,
    "382014": 24,
    "382015": 24,
    "382016": 24,
    "382017": 24,
    "382018": 24,
    "382019": 24,
    "382020": 24,
    "382021": 24,
    "382022": 24,
    "382023": 24,
    "382024": 24,
    "382025": 24,
    "382026": 24,
    "382027": 24,
    "382028": 24,
    "382029": 24,
    "382030": 24,
    "382041": 24,
    "382042": 24,
    "382044": 24,
    "382051": 24,
    "382110": 24,
    "382115": 24,
    "382120": 24,
    "382150": 24,
    "382170": 24,
    "382210": 24,
    "382213": 24,
    "382220": 24,
    "382225": 24,
    "382240": 24,
    "382245": 48,
    "382255": 48,
    "382260": 24,
    "382305": 24,
    "382308": 24,
    "382315": 24,
    "382325": 24,
    "382330": 24,
    "382340": 24,
    "382345": 24,
    "382346": 24,
    "382350": 24,
    "382352": 24,
    "382355": 24,
    "382405": 24,
    "382410": 24,
    "382415": 24,
    "382418": 24,
    "382420": 24,
    "382421": 24,
    "382422": 24,
    "382424": 24,
    "382425": 24,
    "382426": 24,
    "382427": 24,
    "382428": 24,
    "382430": 24,
    "382440": 24,
    "382442": 24,
    "382443": 24,
    "382445": 24,
    "382449": 24,
    "382450": 48,
    "382455": 24,
    "382460": 24,
    "382463": 24,
    "382465": 24,
    "382470": 24,
    "382475": 24,
    "382480": 24,
    "382481": 24,
    "382610": 24,
    "382620": 24,
    "382625": 24,
    "382644": 24,
    "382655": 24,
    "382705": 24,
    "382715": 24,
    "382721": 24,
    "382725": 24,
    "382729": 24,
    "382732": 24,
    "382735": 24,
    "382740": 24,
    "382775": 48,
    "382845": 24,
    "382870": 24,
    "383001": 24,
    "383006": 24,
    "383110": 24,
    "383205": 24,
    "383215": 24,
    "383235": 24,
    "383245": 24,
    "383255": 24,
    "383305": 24,
    "383307": 48,
    "383310": 24,
    "383315": 24,
    "383325": 24,
    "383350": 48,
    "383410": 24,
    "383430": 24,
    "383460": 24,
    "384001": 24,
    "384002": 24,
    "384003": 24,
    "384120": 24,
    "384151": 24,
    "384160": 24,
    "384170": 24,
    "384205": 24,
    "384206": 24,
    "384210": 24,
    "384240": 48,
    "384245": 48,
    "384265": 48,
    "384315": 24,
    "384325": 24,
    "384330": 24,
    "384355": 24,
    "385001": 24,
    "385010": 24,
    "385135": 24,
    "385210": 24,
    "385310": 48,
    "385320": 48,
    "385330": 48,
    "385340": 48,
    "385360": 48,
    "385410": 24,
    "385421": 24,
    "385505": 24,
    "385510": 24,
    "385515": 24,
    "385520": 24,
    "385530": 48,
    "385535": 48,
    "385555": 48,
    "385565": 48,
    "385566": 48,
    "385570": 48,
    "385575": 48,
    "387001": 24,
    "387002": 24,
    "387003": 24,
    "387110": 24,
    "387115": 24,
    "387120": 24,
    "387130": 24,
    "387210": 24,
    "387230": 24,
    "387240": 24,
    "387310": 24,
    "387315": 24,
    "387320": 24,
    "387325": 24,
    "387330": 24,
    "387335": 24,
    "387350": 24,
    "387355": 24,
    "387365": 48,
    "387370": 24,
    "387380": 24,
    "387411": 24,
    "387430": 24,
    "387520": 24,
    "387530": 24,
    "387540": 24,
    "387560": 24,
    "387570": 24,
    "387610": 48,
    "387620": 48,
    "387630": 48,
    "387635": 48,
    "387650": 48,
    "388001": 24,
    "388110": 24,
    "388120": 24,
    "388121": 24,
    "388130": 24,
    "388140": 24,
    "388150": 24,
    "388160": 24,
    "388180": 24,
    "388205": 24,
    "388210": 24,
    "388215": 24,
    "388220": 24,
    "388225": 24,
    "388235": 48,
    "388239": 48,
    "388245": 48,
    "388250": 24,
    "388255": 48,
    "388260": 48,
    "388265": 48,
    "388305": 24,
    "388306": 24,
    "388307": 24,
    "388315": 24,
    "388320": 24,
    "388325": 24,
    "388340": 24,
    "388345": 24,
    "388350": 24,
    "388365": 24,
    "388370": 24,
    "388421": 24,
    "388430": 24,
    "388440": 24,
    "388450": 24,
    "388460": 24,
    "388465": 24,
    "388470": 24,
    "388480": 24,
    "388510": 24,
    "388520": 24,
    "388530": 24,
    "388540": 24,
    "388545": 24,
    "388550": 24,
    "388560": 24,
    "388570": 24,
    "388580": 24,
    "388590": 24,
    "388610": 24,
    "388620": 48,
    "388625": 48,
    "388630": 48,
    "388640": 48,
    "388710": 48,
    "388713": 48,
    "389001": 48,
    "389002": 48,
    "389115": 48,
    "389120": 48,
    "389130": 48,
    "389140": 48,
    "389151": 48,
    "389152": 48,
    "389155": 48,
    "389160": 48,
    "389210": 48,
    "389220": 48,
    "389230": 48,
    "389260": 48,
    "389320": 24,
    "389330": 24,
    "389340": 48,
    "389341": 24,
    "389345": 24,
    "389350": 24,
    "389351": 24,
    "389352": 24,
    "389360": 24,
    "389365": 24,
    "389380": 48,
    "389390": 24,
    "390001": 24,
    "390002": 24,
    "390003": 24,
    "390004": 24,
    "390005": 24,
    "390006": 24,
    "390007": 24,
    "390008": 24,
    "390009": 24,
    "390010": 24,
    "390011": 24,
    "390012": 24,
    "390013": 24,
    "390014": 24,
    "390015": 24,
    "390016": 24,
    "390017": 24,
    "390018": 24,
    "390019": 24,
    "390020": 24,
    "390021": 24,
    "390022": 24,
    "390023": 24,
    "390024": 24,
    "390025": 24,
    "391101": 24,
    "391105": 48,
    "391110": 48,
    "391115": 48,
    "391135": 48,
    "391145": 48,
    "391150": 48,
    "391160": 48,
    "391165": 48,
    "391170": 48,
    "391210": 48,
    "391240": 48,
    "391243": 24,
    "391244": 48,
    "391250": 48,
    "391310": 24,
    "391320": 24,
    "391330": 24,
    "391340": 24,
    "391345": 24,
    "391346": 24,
    "391347": 24,
    "391350": 24,
    "391410": 24,
    "391430": 24,
    "391440": 24,
    "391447": 24,
    "391450": 24,
    "391510": 24,
    "391520": 24,
    "391740": 24,
    "391742": 24,
    "391745": 24,
    "391750": 24,
    "391760": 24,
    "391770": 24,
    "391775": 24,
    "391780": 24,
    "392001": 48,
    "392002": 48,
    "392011": 48,
    "392012": 48,
    "392015": 48,
    "392020": 48,
    "392025": 48,
    "392110": 48,
    "392130": 48,
    "392140": 48,
    "392150": 48,
    "392210": 48,
    "392215": 48,
    "392220": 48,
    "392240": 48,
    "392310": 48,
    "393001": 24,
    "393002": 24,
    "393010": 24,
    "393017": 24,
    "393030": 24,
    "393110": 48,
    "393115": 24,
    "393120": 48,
    "393125": 48,
    "393130": 24,
    "393135": 24,
    "393140": 48,
    "393145": 48,
    "393151": 48,
    "394101": 48,
    "394105": 48,
    "394107": 48,
    "394110": 48,
    "394111": 48,
    "394115": 24,
    "394116": 24,
    "394120": 48,
    "394125": 24,
    "394130": 48,
    "394140": 48,
    "394150": 48,
    "394155": 48,
    "394160": 48,
    "394170": 48,
    "394180": 48,
    "394185": 48,
    "394190": 48,
    "394210": 48,
    "394220": 48,
    "394221": 48,
    "394230": 48,
    "394235": 48,
    "394240": 48,
    "394245": 48,
    "394246": 48,
    "394248": 48,
    "394250": 48,
    "394270": 48,
    "394305": 48,
    "394310": 48,
    "394315": 48,
    "394317": 48,
    "394320": 48,
    "394325": 48,
    "394326": 48,
    "394327": 48,
    "394330": 48,
    "394335": 48,
    "394340": 48,
    "394345": 48,
    "394350": 48,
    "394352": 48,
    "394355": 48,
    "394360": 48,
    "394375": 48,
    "394410": 24,
    "394421": 48,
    "394430": 48,
    "394444": 48,
    "394510": 48,
    "394515": 48,
    "394516": 48,
    "394518": 48,
    "394601": 48,
    "394602": 48,
    "394620": 48,
    "394630": 48,
    "394633": 48,
    "394635": 48,
    "394640": 48,
    "394641": 48,
    "394650": 48,
    "394651": 48,
    "394652": 48,
    "394655": 48,
    "394660": 48,
    "394670": 48,
    "394680": 48,
    "394690": 48,
    "394710": 96,
    "394810": 24,
    "395002": 48,
    "395003": 48,
    "395004": 48,
    "395005": 48,
    "395006": 48,
    "395008": 48,
    "395009": 48,
    "395010": 48,
    "395011": 48,
    "395012": 48,
    "395013": 48,
    "395023": 48,
    "396001": 48,
    "396002": 48,
    "396007": 48,
    "396020": 48,
    "396030": 48,
    "396035": 48,
    "396040": 48,
    "396045": 48,
    "396050": 48,
    "396055": 48,
    "396060": 48,
    "396065": 24,
    "396105": 24,
    "396120": 48,
    "396130": 48,
    "396135": 48,
    "396150": 48,
    "396155": 24,
    "396165": 48,
    "396170": 48,
    "396171": 48,
    "396191": 24,
    "396193": 48,
    "396195": 24,
    "396210": 24,
    "396215": 24,
    "396220": 24,
    "396230": 48,
    "396235": 48,
    "396240": 48,
    "396310": 48,
    "396321": 48,
    "396325": 48,
    "396350": 48,
    "396360": 48,
    "396370": 48,
    "396375": 48,
    "396380": 48,
    "396409": 48,
    "396415": 48,
    "396421": 48,
    "396424": 48,
    "396427": 48,
    "396430": 48,
    "396436": 48,
    "396439": 48,
    "396445": 48,
    "396450": 48,
    "396463": 48,
    "396475": 48,
    "396521": 48,
    "396530": 48,
    "396560": 48,
    "396580": 48,
    "396590": 48,
    "400000": 24,
    "400001": 24,
    "400002": 24,
    "400003": 24,
    "400004": 24,
    "400005": 24,
    "400006": 24,
    "400007": 24,
    "400008": 24,
    "400009": 24,
    "400010": 24,
    "400011": 24,
    "400012": 24,
    "400013": 24,
    "400014": 24,
    "400015": 24,
    "400016": 24,
    "400017": 24,
    "400018": 24,
    "400019": 24,
    "400020": 24,
    "400021": 24,
    "400022": 24,
    "400023": 24,
    "400024": 24,
    "400025": 24,
    "400026": 24,
    "400027": 24,
    "400028": 24,
    "400029": 24,
    "400030": 24,
    "400031": 24,
    "400032": 24,
    "400033": 24,
    "400034": 24,
    "400035": 24,
    "400036": 24,
    "400037": 24,
    "400038": 24,
    "400039": 24,
    "400042": 24,
    "400043": 24,
    "400049": 24,
    "400050": 24,
    "400051": 24,
    "400052": 24,
    "400053": 24,
    "400054": 24,
    "400055": 24,
    "400056": 24,
    "400057": 24,
    "400058": 24,
    "400059": 24,
    "400060": 24,
    "400061": 24,
    "400062": 24,
    "400063": 24,
    "400064": 24,
    "400065": 24,
    "400066": 24,
    "400067": 24,
    "400068": 24,
    "400069": 24,
    "400070": 24,
    "400071": 24,
    "400072": 24,
    "400074": 24,
    "400075": 24,
    "400076": 24,
    "400077": 24,
    "400078": 24,
    "400079": 24,
    "400080": 24,
    "400081": 24,
    "400082": 24,
    "400083": 24,
    "400084": 24,
    "400085": 24,
    "400086": 24,
    "400087": 24,
    "400088": 24,
    "400089": 24,
    "400090": 24,
    "400091": 24,
    "400092": 24,
    "400093": 24,
    "400094": 24,
    "400095": 24,
    "400096": 24,
    "400097": 24,
    "400098": 24,
    "400099": 24,
    "400101": 24,
    "400102": 24,
    "400103": 24,
    "400104": 24,
    "400601": 24,
    "400602": 24,
    "400603": 24,
    "400604": 24,
    "400605": 24,
    "400606": 24,
    "400607": 24,
    "400608": 24,
    "400609": 24,
    "400610": 24,
    "400611": 24,
    "400612": 24,
    "400614": 24,
    "400615": 24,
    "400701": 24,
    "400702": 24,
    "400703": 24,
    "400704": 24,
    "400705": 24,
    "400706": 24,
    "400707": 24,
    "400708": 24,
    "400709": 24,
    "400710": 24,
    "401101": 24,
    "401102": 24,
    "401103": 24,
    "401104": 24,
    "401105": 24,
    "401106": 24,
    "401107": 24,
    "401201": 24,
    "401202": 24,
    "401203": 24,
    "401205": 24,
    "401207": 24,
    "401208": 24,
    "401209": 24,
    "401210": 24,
    "401301": 24,
    "401302": 24,
    "401303": 24,
    "401304": 24,
    "401305": 24,
    "401401": 24,
    "401402": 24,
    "401403": 24,
    "401404": 24,
    "401405": 24,
    "401407": 24,
    "401501": 24,
    "401502": 24,
    "401503": 24,
    "401504": 24,
    "401506": 24,
    "401601": 24,
    "401602": 24,
    "401607": 24,
    "401608": 24,
    "401701": 24,
    "401702": 24,
    "402101": 48,
    "402103": 48,
    "402104": 48,
    "402105": 48,
    "402106": 48,
    "402107": 48,
    "402109": 48,
    "402110": 48,
    "402111": 48,
    "402112": 48,
    "402113": 48,
    "402114": 48,
    "402115": 48,
    "402116": 48,
    "402117": 48,
    "402120": 48,
    "402125": 48,
    "402126": 48,
    "402201": 48,
    "402202": 48,
    "402203": 48,
    "402207": 48,
    "402208": 48,
    "402209": 48,
    "402301": 48,
    "402302": 48,
    "402303": 48,
    "402304": 48,
    "402305": 48,
    "402306": 48,
    "402307": 48,
    "402308": 48,
    "402309": 48,
    "402401": 48,
    "402403": 48,
    "402404": 48,
    "403001": 48,
    "403002": 48,
    "403003": 48,
    "403004": 48,
    "403005": 48,
    "403006": 48,
    "403101": 48,
    "403104": 48,
    "403105": 48,
    "403106": 48,
    "403107": 48,
    "403108": 48,
    "403109": 48,
    "403110": 48,
    "403114": 48,
    "403115": 48,
    "403201": 48,
    "403202": 48,
    "403203": 48,
    "403204": 48,
    "403206": 48,
    "403401": 48,
    "403402": 48,
    "403404": 48,
    "403405": 48,
    "403406": 48,
    "403409": 48,
    "403501": 48,
    "403502": 48,
    "403503": 48,
    "403504": 48,
    "403505": 48,
    "403506": 48,
    "403507": 48,
    "403508": 48,
    "403509": 48,
    "403510": 48,
    "403511": 48,
    "403512": 48,
    "403513": 48,
    "403514": 48,
    "403515": 48,
    "403516": 48,
    "403517": 48,
    "403518": 48,
    "403519": 48,
    "403521": 48,
    "403523": 48,
    "403524": 48,
    "403526": 48,
    "403527": 48,
    "403529": 48,
    "403530": 48,
    "403601": 48,
    "403602": 48,
    "403604": 48,
    "403701": 48,
    "403703": 48,
    "403704": 48,
    "403705": 48,
    "403706": 48,
    "403707": 48,
    "403708": 48,
    "403709": 48,
    "403710": 48,
    "403711": 48,
    "403712": 48,
    "403713": 48,
    "403714": 48,
    "403715": 48,
    "403716": 48,
    "403717": 48,
    "403718": 48,
    "403719": 48,
    "403720": 48,
    "403721": 48,
    "403722": 48,
    "403723": 48,
    "403724": 48,
    "403725": 48,
    "403726": 48,
    "403729": 48,
    "403731": 48,
    "403801": 48,
    "403802": 48,
    "403803": 48,
    "403804": 48,
    "403806": 48,
    "410101": 48,
    "410201": 48,
    "410202": 24,
    "410203": 24,
    "410204": 24,
    "410205": 48,
    "410206": 48,
    "410207": 24,
    "410208": 24,
    "410209": 24,
    "410210": 24,
    "410216": 24,
    "410217": 24,
    "410218": 24,
    "410220": 24,
    "410221": 24,
    "410222": 24,
    "410301": 24,
    "410302": 24,
    "410401": 24,
    "410402": 24,
    "410403": 24,
    "410405": 24,
    "410501": 24,
    "410502": 48,
    "410503": 48,
    "410504": 48,
    "410505": 48,
    "410506": 24,
    "410507": 24,
    "410508": 48,
    "410509": 48,
    "410510": 48,
    "410511": 48,
    "410512": 48,
    "410513": 48,
    "410515": 48,
    "410516": 48,
    "410613": 24,
    "411001": 24,
    "411002": 24,
    "411003": 24,
    "411004": 24,
    "411005": 24,
    "411006": 24,
    "411007": 24,
    "411008": 24,
    "411009": 24,
    "411010": 24,
    "411011": 24,
    "411012": 24,
    "411013": 24,
    "411014": 24,
    "411015": 24,
    "411016": 24,
    "411017": 24,
    "411018": 24,
    "411019": 24,
    "411020": 24,
    "411021": 24,
    "411022": 24,
    "411023": 24,
    "411024": 24,
    "411025": 24,
    "411026": 24,
    "411027": 24,
    "411028": 24,
    "411029": 24,
    "411030": 24,
    "411031": 24,
    "411032": 24,
    "411033": 24,
    "411034": 24,
    "411035": 24,
    "411036": 24,
    "411037": 24,
    "411038": 24,
    "411039": 24,
    "411040": 24,
    "411041": 24,
    "411042": 24,
    "411043": 24,
    "411044": 24,
    "411045": 24,
    "411046": 24,
    "411047": 24,
    "411048": 24,
    "411051": 24,
    "411052": 24,
    "411053": 24,
    "411057": 24,
    "411058": 24,
    "411060": 24,
    "411061": 24,
    "411062": 24,
    "411067": 24,
    "411068": 24,
    "411201": 24,
    "412101": 24,
    "412102": 48,
    "412103": 48,
    "412105": 24,
    "412106": 24,
    "412108": 48,
    "412109": 24,
    "412111": 48,
    "412112": 48,
    "412113": 24,
    "412115": 48,
    "412201": 48,
    "412202": 48,
    "412205": 48,
    "412207": 24,
    "412208": 24,
    "412209": 24,
    "412210": 48,
    "412213": 48,
    "412215": 48,
    "412216": 24,
    "412218": 48,
    "412219": 48,
    "412220": 24,
    "412301": 48,
    "412303": 48,
    "412306": 48,
    "412307": 48,
    "412308": 24,
    "412401": 48,
    "412402": 48,
    "412403": 48,
    "412404": 48,
    "412405": 48,
    "412406": 48,
    "412408": 48,
    "412409": 48,
    "412410": 48,
    "412411": 48,
    "412412": 48,
    "412801": 48,
    "412802": 48,
    "412803": 96,
    "412804": 96,
    "412805": 96,
    "412806": 96,
    "413001": 48,
    "413002": 48,
    "413003": 48,
    "413004": 48,
    "413005": 48,
    "413006": 48,
    "413007": 48,
    "413008": 48,
    "413101": 48,
    "413102": 48,
    "413103": 48,
    "413105": 48,
    "413106": 48,
    "413107": 48,
    "413108": 48,
    "413109": 48,
    "413110": 48,
    "413111": 48,
    "413112": 48,
    "413113": 48,
    "413115": 48,
    "413116": 48,
    "413118": 48,
    "413120": 48,
    "413130": 48,
    "413132": 48,
    "413133": 48,
    "413208": 48,
    "413209": 48,
    "413213": 48,
    "413215": 48,
    "413216": 48,
    "413222": 48,
    "413224": 48,
    "413228": 48,
    "413250": 48,
    "413255": 48,
    "413310": 48,
    "413401": 48,
    "413402": 48,
    "413403": 48,
    "413405": 48,
    "413409": 48,
    "413410": 48,
    "413411": 48,
    "413432": 96,
    "413501": 48,
    "413502": 48,
    "413503": 48,
    "413504": 48,
    "413506": 48,
    "413507": 48,
    "413509": 48,
    "413512": 48,
    "413517": 96,
    "413518": 96,
    "413519": 96,
    "413520": 48,
    "413527": 48,
    "413531": 48,
    "413532": 96,
    "413544": 48,
    "413580": 48,
    "413582": 48,
    "413601": 48,
    "413604": 48,
    "413605": 48,
    "413606": 48,
    "413701": 48,
    "413702": 48,
    "413703": 48,
    "413704": 48,
    "413705": 48,
    "413706": 48,
    "413707": 48,
    "413709": 48,
    "413710": 48,
    "413711": 48,
    "413712": 48,
    "413713": 48,
    "413714": 48,
    "413715": 48,
    "413716": 48,
    "413717": 48,
    "413718": 48,
    "413720": 48,
    "413721": 48,
    "413723": 48,
    "413726": 48,
    "413728": 48,
    "413736": 48,
    "413737": 48,
    "413738": 48,
    "413739": 48,
    "413801": 48,
    "413802": 48,
    "414001": 48,
    "414002": 48,
    "414003": 48,
    "414005": 48,
    "414006": 48,
    "414102": 48,
    "414105": 48,
    "414106": 48,
    "414110": 48,
    "414111": 48,
    "414141": 24,
    "414201": 48,
    "414301": 48,
    "414303": 48,
    "414306": 48,
    "414401": 48,
    "414402": 48,
    "414403": 48,
    "414501": 48,
    "414502": 48,
    "414503": 48,
    "414504": 48,
    "414505": 48,
    "414601": 48,
    "414602": 48,
    "414603": 48,
    "414604": 48,
    "414605": 48,
    "414607": 48,
    "414609": 48,
    "414701": 48,
    "415001": 48,
    "415002": 48,
    "415003": 48,
    "415004": 48,
    "415010": 48,
    "415011": 48,
    "415015": 48,
    "415019": 48,
    "415101": 48,
    "415103": 48,
    "415104": 48,
    "415105": 48,
    "415106": 48,
    "415107": 48,
    "415108": 48,
    "415109": 48,
    "415110": 48,
    "415111": 48,
    "415114": 48,
    "415115": 48,
    "415122": 48,
    "415124": 48,
    "415203": 48,
    "415205": 48,
    "415206": 48,
    "415209": 48,
    "415212": 48,
    "415213": 48,
    "415409": 48,
    "415414": 48,
    "415501": 48,
    "415508": 48,
    "415511": 48,
    "415513": 96,
    "415514": 96,
    "415515": 96,
    "415516": 96,
    "415517": 96,
    "415518": 48,
    "415519": 48,
    "415521": 48,
    "415522": 48,
    "415523": 48,
    "415524": 48,
    "415528": 48,
    "415530": 96,
    "415536": 96,
    "415537": 48,
    "415539": 48,
    "415601": 48,
    "415602": 48,
    "415603": 48,
    "415605": 48,
    "415606": 48,
    "415608": 48,
    "415609": 96,
    "415610": 96,
    "415611": 96,
    "415612": 48,
    "415613": 96,
    "415614": 48,
    "415615": 48,
    "415616": 48,
    "415617": 48,
    "415619": 48,
    "415620": 48,
    "415621": 48,
    "415626": 48,
    "415628": 96,
    "415629": 48,
    "415634": 96,
    "415639": 48,
    "415643": 48,
    "415702": 96,
    "415703": 96,
    "415705": 96,
    "415706": 48,
    "415709": 48,
    "415711": 48,
    "415712": 48,
    "415713": 48,
    "415714": 48,
    "415716": 48,
    "415717": 48,
    "415719": 96,
    "415720": 48,
    "415722": 48,
    "415724": 96,
    "415726": 96,
    "415728": 96,
    "415729": 96,
    "415730": 48,
    "415801": 96,
    "415802": 96,
    "415803": 48,
    "415804": 96,
    "415805": 48,
    "415806": 48,
    "415807": 48,
    "416001": 48,
    "416002": 48,
    "416003": 48,
    "416004": 48,
    "416005": 48,
    "416006": 48,
    "416007": 48,
    "416008": 48,
    "416009": 48,
    "416010": 48,
    "416011": 48,
    "416012": 48,
    "416013": 48,
    "416101": 48,
    "416107": 48,
    "416108": 48,
    "416109": 48,
    "416110": 48,
    "416112": 48,
    "416113": 48,
    "416114": 48,
    "416115": 48,
    "416116": 48,
    "416117": 48,
    "416118": 48,
    "416119": 48,
    "416121": 48,
    "416122": 48,
    "416129": 48,
    "416138": 48,
    "416143": 48,
    "416144": 48,
    "416146": 48,
    "416203": 48,
    "416205": 48,
    "416207": 48,
    "416213": 48,
    "416216": 48,
    "416219": 48,
    "416221": 48,
    "416230": 48,
    "416232": 48,
    "416234": 48,
    "416235": 48,
    "416236": 48,
    "416301": 48,
    "416302": 48,
    "416303": 48,
    "416307": 48,
    "416308": 48,
    "416309": 48,
    "416310": 48,
    "416311": 48,
    "416312": 48,
    "416314": 48,
    "416406": 48,
    "416408": 48,
    "416410": 48,
    "416415": 48,
    "416416": 48,
    "416419": 48,
    "416436": 48,
    "416502": 48,
    "416505": 48,
    "416509": 48,
    "416510": 48,
    "416511": 48,
    "416512": 48,
    "416516": 48,
    "416518": 48,
    "416520": 48,
    "416528": 48,
    "416541": 48,
    "416550": 48,
    "416601": 48,
    "416602": 48,
    "416603": 48,
    "416606": 48,
    "416609": 48,
    "416610": 48,
    "416611": 48,
    "416613": 48,
    "416614": 48,
    "416616": 48,
    "416628": 48,
    "416701": 48,
    "416702": 48,
    "416704": 48,
    "416705": 48,
    "416707": 48,
    "416709": 48,
    "416712": 48,
    "416713": 48,
    "416801": 48,
    "416810": 48,
    "416812": 48,
    "421001": 24,
    "421002": 24,
    "421003": 24,
    "421004": 24,
    "421005": 24,
    "421101": 24,
    "421102": 24,
    "421103": 24,
    "421111": 24,
    "421201": 24,
    "421202": 24,
    "421203": 24,
    "421204": 24,
    "421300": 24,
    "421301": 24,
    "421302": 24,
    "421303": 24,
    "421304": 24,
    "421305": 24,
    "421306": 24,
    "421308": 24,
    "421311": 24,
    "421312": 24,
    "421501": 24,
    "421502": 24,
    "421503": 24,
    "421504": 24,
    "421505": 24,
    "421506": 24,
    "421601": 24,
    "421605": 24,
    "422001": 48,
    "422002": 48,
    "422003": 48,
    "422004": 48,
    "422005": 48,
    "422006": 48,
    "422007": 48,
    "422008": 48,
    "422009": 48,
    "422010": 48,
    "422011": 48,
    "422012": 48,
    "422013": 48,
    "422101": 48,
    "422102": 48,
    "422103": 24,
    "422105": 48,
    "422112": 24,
    "422113": 24,
    "422203": 48,
    "422206": 48,
    "422207": 48,
    "422209": 48,
    "422303": 48,
    "422305": 48,
    "422306": 48,
    "422308": 48,
    "422401": 48,
    "422403": 24,
    "422601": 48,
    "422602": 48,
    "422603": 48,
    "422604": 48,
    "422605": 48,
    "422608": 48,
    "422610": 48,
    "422611": 48,
    "422615": 48,
    "422620": 48,
    "422622": 48,
    "423101": 48,
    "423102": 48,
    "423104": 48,
    "423105": 48,
    "423106": 48,
    "423107": 48,
    "423109": 48,
    "423201": 48,
    "423202": 48,
    "423203": 48,
    "423401": 48,
    "423402": 48,
    "423403": 48,
    "423601": 48,
    "423602": 48,
    "423603": 48,
    "423701": 48,
    "423702": 48,
    "423703": 48,
    "424001": 48,
    "424002": 48,
    "424003": 48,
    "424004": 48,
    "424005": 48,
    "424006": 48,
    "424101": 48,
    "424102": 48,
    "424103": 48,
    "424104": 48,
    "424105": 48,
    "424106": 48,
    "424107": 48,
    "424108": 48,
    "424116": 48,
    "424119": 48,
    "424202": 48,
    "424203": 48,
    "424204": 48,
    "424205": 48,
    "424206": 48,
    "424207": 48,
    "424301": 48,
    "424302": 48,
    "424303": 48,
    "424304": 48,
    "424305": 48,
    "424306": 48,
    "424307": 48,
    "424308": 48,
    "424309": 48,
    "424311": 48,
    "424318": 48,
    "425001": 48,
    "425002": 48,
    "425003": 48,
    "425004": 48,
    "425101": 48,
    "425102": 48,
    "425103": 48,
    "425104": 48,
    "425105": 48,
    "425106": 48,
    "425108": 48,
    "425109": 48,
    "425110": 48,
    "425111": 48,
    "425112": 48,
    "425113": 48,
    "425114": 48,
    "425115": 48,
    "425116": 48,
    "425117": 48,
    "425201": 48,
    "425203": 48,
    "425301": 48,
    "425302": 48,
    "425304": 48,
    "425305": 48,
    "425306": 48,
    "425307": 48,
    "425308": 48,
    "425309": 48,
    "425310": 48,
    "425311": 48,
    "425407": 48,
    "425408": 48,
    "425411": 48,
    "425412": 48,
    "425413": 48,
    "425415": 48,
    "425416": 48,
    "425422": 48,
    "425423": 48,
    "425501": 48,
    "425502": 48,
    "425503": 48,
    "425504": 48,
    "425505": 48,
    "425506": 48,
    "425507": 48,
    "425508": 48,
    "425519": 48,
    "425523": 48,
    "425524": 48,
    "431001": 24,
    "431002": 24,
    "431003": 24,
    "431004": 24,
    "431005": 24,
    "431006": 24,
    "431007": 24,
    "431009": 24,
    "431010": 24,
    "431101": 24,
    "431102": 24,
    "431103": 48,
    "431104": 48,
    "431105": 24,
    "431107": 48,
    "431109": 24,
    "431112": 48,
    "431113": 48,
    "431114": 48,
    "431115": 48,
    "431116": 48,
    "431117": 48,
    "431118": 48,
    "431122": 48,
    "431123": 48,
    "431124": 48,
    "431127": 48,
    "431128": 48,
    "431132": 48,
    "431133": 24,
    "431134": 48,
    "431135": 48,
    "431136": 24,
    "431143": 48,
    "431147": 48,
    "431150": 48,
    "431151": 48,
    "431154": 24,
    "431202": 48,
    "431203": 48,
    "431204": 48,
    "431210": 24,
    "431213": 48,
    "431401": 48,
    "431402": 48,
    "431503": 48,
    "431505": 48,
    "431506": 48,
    "431508": 48,
    "431509": 48,
    "431511": 48,
    "431512": 48,
    "431513": 96,
    "431514": 48,
    "431515": 48,
    "431516": 48,
    "431517": 48,
    "431519": 48,
    "431520": 48,
    "431521": 48,
    "431523": 48,
    "431530": 48,
    "431537": 48,
    "431540": 48,
    "431542": 96,
    "431601": 48,
    "431602": 48,
    "431603": 48,
    "431604": 48,
    "431605": 48,
    "431606": 48,
    "431701": 96,
    "431702": 96,
    "431705": 96,
    "431708": 48,
    "431709": 48,
    "431714": 48,
    "431716": 96,
    "440001": 48,
    "440002": 48,
    "440003": 48,
    "440004": 48,
    "440005": 48,
    "440006": 48,
    "440007": 48,
    "440008": 48,
    "440009": 48,
    "440010": 48,
    "440011": 48,
    "440012": 48,
    "440013": 48,
    "440014": 48,
    "440015": 48,
    "440016": 48,
    "440017": 48,
    "440018": 48,
    "440019": 48,
    "440020": 48,
    "440021": 48,
    "440022": 48,
    "440023": 48,
    "440024": 48,
    "440025": 48,
    "440026": 48,
    "440027": 48,
    "440028": 48,
    "440029": 48,
    "440030": 48,
    "440032": 48,
    "440033": 48,
    "440034": 48,
    "440035": 48,
    "440036": 48,
    "440037": 48,
    "441001": 96,
    "441002": 96,
    "441102": 48,
    "441104": 48,
    "441105": 96,
    "441106": 96,
    "441107": 48,
    "441108": 96,
    "441109": 96,
    "441110": 48,
    "441111": 48,
    "441113": 96,
    "441122": 96,
    "441203": 96,
    "441204": 48,
    "441301": 96,
    "441302": 96,
    "441304": 96,
    "441305": 96,
    "441401": 96,
    "441404": 96,
    "441501": 48,
    "441502": 48,
    "441601": 96,
    "441612": 96,
    "441614": 96,
    "441801": 96,
    "441807": 96,
    "441904": 96,
    "441906": 96,
    "441911": 96,
    "441916": 96,
    "442001": 96,
    "442006": 96,
    "442102": 96,
    "442301": 96,
    "442304": 96,
    "442305": 96,
    "442307": 96,
    "442401": 96,
    "442402": 96,
    "442403": 96,
    "442404": 96,
    "442501": 96,
    "442605": 96,
    "442701": 96,
    "442901": 96,
    "442902": 96,
    "442905": 96,
    "442907": 96,
    "443101": 96,
    "443103": 96,
    "443112": 48,
    "443204": 48,
    "443404": 96,
    "443405": 96,
    "444001": 96,
    "444002": 96,
    "444003": 96,
    "444004": 96,
    "444005": 96,
    "444006": 96,
    "444104": 96,
    "444105": 96,
    "444107": 96,
    "444302": 96,
    "444303": 120,
    "444312": 120,
    "444402": 96,
    "444403": 96,
    "444503": 96,
    "444504": 96,
    "444505": 96,
    "444506": 96,
    "444507": 96,
    "444601": 96,
    "444602": 96,
    "444603": 96,
    "444604": 96,
    "444605": 96,
    "444606": 96,
    "444607": 96,
    "444701": 96,
    "444704": 96,
    "444705": 96,
    "444708": 96,
    "444709": 96,
    "444717": 96,
    "444801": 96,
    "444803": 96,
    "444805": 96,
    "444806": 96,
    "444807": 96,
    "444901": 96,
    "444904": 96,
    "444905": 96,
    "444906": 96,
    "445001": 96,
    "445002": 96,
    "445103": 96,
    "445105": 96,
    "445106": 96,
    "445204": 120,
    "445208": 96,
    "445215": 120,
    "450001": 48,
    "450051": 48,
    "450110": 48,
    "450112": 48,
    "450113": 48,
    "450116": 48,
    "450117": 48,
    "450331": 48,
    "450445": 48,
    "451001": 48,
    "451111": 48,
    "451113": 48,
    "451115": 48,
    "451220": 48,
    "451221": 48,
    "451224": 48,
    "451225": 48,
    "451228": 48,
    "451331": 48,
    "451332": 48,
    "451335": 48,
    "451440": 48,
    "451442": 48,
    "451447": 48,
    "451449": 48,
    "451551": 48,
    "451556": 48,
    "451660": 48,
    "451666": 48,
    "451770": 48,
    "452001": 48,
    "452002": 48,
    "452003": 48,
    "452004": 48,
    "452005": 48,
    "452006": 48,
    "452007": 48,
    "452008": 48,
    "452009": 48,
    "452010": 48,
    "452011": 48,
    "452012": 48,
    "452013": 48,
    "452014": 48,
    "452015": 48,
    "452016": 48,
    "452017": 48,
    "452018": 48,
    "452019": 48,
    "452020": 48,
    "453001": 48,
    "453111": 48,
    "453112": 48,
    "453115": 48,
    "453220": 48,
    "453331": 48,
    "453441": 48,
    "453551": 48,
    "453555": 48,
    "453556": 48,
    "453771": 48,
    "454001": 48,
    "454111": 48,
    "454116": 48,
    "454331": 48,
    "454335": 48,
    "454441": 48,
    "454446": 48,
    "454449": 48,
    "454552": 48,
    "454660": 48,
    "454665": 48,
    "454772": 48,
    "454773": 48,
    "454774": 48,
    "454775": 48,
    "455001": 48,
    "455003": 48,
    "455111": 48,
    "455115": 48,
    "455116": 48,
    "455118": 48,
    "455223": 48,
    "455227": 48,
    "455332": 96,
    "455336": 96,
    "456001": 48,
    "456003": 48,
    "456006": 48,
    "456010": 48,
    "456221": 48,
    "456224": 48,
    "456313": 48,
    "456331": 48,
    "456335": 48,
    "456440": 48,
    "456443": 48,
    "456665": 48,
    "456770": 48,
    "456771": 48,
    "457001": 48,
    "457112": 48,
    "457114": 48,
    "457226": 48,
    "457661": 48,
    "457773": 48,
    "457775": 48,
    "457777": 48,
    "457779": 48,
    "457882": 48,
    "457887": 48,
    "457888": 48,
    "457990": 48,
    "457993": 48,
    "458001": 48,
    "458002": 48,
    "458110": 48,
    "458118": 48,
    "458330": 48,
    "458441": 48,
    "458468": 48,
    "458470": 48,
    "458556": 48,
    "458664": 48,
    "458667": 48,
    "460001": 96,
    "460002": 96,
    "460004": 96,
    "460005": 96,
    "460110": 96,
    "460225": 96,
    "460330": 96,
    "460440": 96,
    "460443": 96,
    "460447": 96,
    "460449": 96,
    "460551": 96,
    "460553": 96,
    "460661": 96,
    "460668": 96,
    "461001": 120,
    "461005": 120,
    "461110": 120,
    "461111": 120,
    "461114": 120,
    "461115": 120,
    "461116": 120,
    "461122": 120,
    "461221": 120,
    "461223": 120,
    "461331": 96,
    "461441": 96,
    "461446": 120,
    "461551": 120,
    "461661": 120,
    "461771": 96,
    "461775": 96,
    "461881": 96,
    "461990": 96,
    "462001": 96,
    "462002": 48,
    "462003": 48,
    "462004": 48,
    "462007": 48,
    "462008": 96,
    "462010": 96,
    "462011": 48,
    "462012": 48,
    "462013": 48,
    "462016": 48,
    "462018": 96,
    "462020": 48,
    "462021": 96,
    "462022": 96,
    "462023": 96,
    "462024": 48,
    "462026": 48,
    "462027": 48,
    "462030": 96,
    "462031": 48,
    "462032": 96,
    "462033": 48,
    "462036": 48,
    "462037": 48,
    "462038": 48,
    "462039": 48,
    "462040": 48,
    "462041": 96,
    "462042": 48,
    "462043": 48,
    "462044": 48,
    "462045": 48,
    "462046": 48,
    "462047": 48,
    "462066": 48,
    "462100": 48,
    "462101": 48,
    "463106": 48,
    "464001": 96,
    "464002": 96,
    "464221": 96,
    "464224": 96,
    "464226": 96,
    "464228": 96,
    "464331": 96,
    "464334": 96,
    "464337": 96,
    "464551": 96,
    "464570": 96,
    "464661": 96,
    "464884": 96,
    "464986": 96,
    "464990": 48,
    "464993": 48,
    "465001": 48,
    "465106": 48,
    "465110": 48,
    "465223": 48,
    "465333": 48,
    "465337": 96,
    "465339": 96,
    "465441": 48,
    "465445": 48,
    "465447": 48,
    "465550": 48,
    "465661": 96,
    "465667": 96,
    "465669": 96,
    "465674": 96,
    "465677": 96,
    "465679": 96,
    "465683": 96,
    "465685": 96,
    "465697": 48,
    "466001": 96,
    "466114": 48,
    "466115": 96,
    "466116": 48,
    "466331": 96,
    "466445": 120,
    "466446": 120,
    "466651": 96,
    "466661": 96,
    "466666": 24,
    "470001": 96,
    "470002": 96,
    "470003": 96,
    "470004": 96,
    "470005": 96,
    "470021": 96,
    "470051": 96,
    "470113": 96,
    "470115": 96,
    "470117": 96,
    "470120": 96,
    "470124": 96,
    "470221": 96,
    "470223": 96,
    "470226": 96,
    "470227": 96,
    "470228": 96,
    "470229": 96,
    "470335": 96,
    "470337": 96,
    "470339": 96,
    "470442": 96,
    "470661": 96,
    "470666": 96,
    "470672": 96,
    "470675": 96,
    "470775": 96,
    "471001": 96,
    "471111": 96,
    "471201": 96,
    "471301": 96,
    "471311": 96,
    "471405": 96,
    "471501": 96,
    "471515": 96,
    "471525": 96,
    "471606": 96,
    "471625": 96,
    "472001": 120,
    "472115": 120,
    "472118": 120,
    "472221": 120,
    "472246": 96,
    "472336": 120,
    "472442": 120,
    "473001": 96,
    "473002": 96,
    "473101": 96,
    "473110": 96,
    "473111": 96,
    "473112": 96,
    "473115": 96,
    "473222": 96,
    "473226": 96,
    "473331": 96,
    "473335": 96,
    "473443": 96,
    "473446": 96,
    "473551": 96,
    "473638": 96,
    "473660": 96,
    "473885": 96,
    "473995": 96,
    "474001": 48,
    "474002": 48,
    "474003": 48,
    "474004": 48,
    "474005": 48,
    "474006": 48,
    "474007": 48,
    "474008": 48,
    "474009": 48,
    "474010": 48,
    "474011": 48,
    "474012": 48,
    "474015": 48,
    "474020": 48,
    "475005": 96,
    "475110": 96,
    "475115": 96,
    "475335": 96,
    "475661": 96,
    "476001": 96,
    "476111": 96,
    "476115": 96,
    "476221": 96,
    "476224": 96,
    "476229": 96,
    "476337": 96,
    "477001": 96,
    "477116": 48,
    "477117": 48,
    "477441": 96,
    "477445": 96,
    "477660": 96,
    "480001": 96,
    "480002": 96,
    "480105": 96,
    "480106": 96,
    "480107": 96,
    "480108": 96,
    "480112": 96,
    "480115": 96,
    "480334": 96,
    "480337": 96,
    "480441": 96,
    "480551": 96,
    "480661": 96,
    "480667": 96,
    "480880": 96,
    "480882": 96,
    "480884": 96,
    "480886": 96,
    "480888": 96,
    "480990": 96,
    "480991": 96,
    "480994": 96,
    "480997": 96,
    "481001": 96,
    "481102": 96,
    "481115": 96,
    "481224": 96,
    "481226": 96,
    "481331": 96,
    "481332": 96,
    "481335": 96,
    "481337": 96,
    "481441": 96,
    "481661": 96,
    "481879": 120,
    "481880": 120,
    "481882": 120,
    "481883": 120,
    "481884": 120,
    "481990": 120,
    "482001": 96,
    "482002": 96,
    "482003": 96,
    "482004": 96,
    "482005": 96,
    "482006": 96,
    "482007": 96,
    "482008": 96,
    "482009": 96,
    "482010": 96,
    "482011": 96,
    "482020": 96,
    "482021": 96,
    "482051": 96,
    "482056": 96,
    "483053": 96,
    "483119": 96,
    "483220": 96,
    "483222": 96,
    "483225": 96,
    "483334": 96,
    "483336": 96,
    "483501": 96,
    "483503": 96,
    "483504": 96,
    "483770": 96,
    "483775": 96,
    "483880": 96,
    "484001": 96,
    "484110": 96,
    "484114": 96,
    "484116": 96,
    "484117": 96,
    "484120": 96,
    "484220": 96,
    "484224": 96,
    "484330": 96,
    "484334": 96,
    "484336": 96,
    "484440": 96,
    "484444": 96,
    "484551": 96,
    "484555": 96,
    "484661": 96,
    "484771": 120,
    "484774": 120,
    "484776": 120,
    "485001": 96,
    "485002": 96,
    "485003": 96,
    "485004": 96,
    "485005": 96,
    "485111": 96,
    "485112": 96,
    "485113": 96,
    "485114": 96,
    "485221": 96,
    "485226": 96,
    "485441": 96,
    "485446": 96,
    "485661": 96,
    "485666": 96,
    "485771": 96,
    "485772": 96,
    "485773": 96,
    "485774": 96,
    "485775": 96,
    "486001": 96,
    "486002": 96,
    "486003": 96,
    "486005": 96,
    "486006": 96,
    "486111": 96,
    "486335": 120,
    "486338": 96,
    "486341": 96,
    "486440": 96,
    "486441": 96,
    "486446": 96,
    "486450": 96,
    "486550": 96,
    "486661": 120,
    "486669": 120,
    "486670": 120,
    "486675": 120,
    "486771": 120,
    "486775": 120,
    "486884": 120,
    "486885": 120,
    "486886": 120,
    "486887": 120,
    "486888": 120,
    "486889": 120,
    "486890": 120,
    "486892": 120,
    "487001": 96,
    "487110": 96,
    "487114": 96,
    "487118": 96,
    "487221": 96,
    "487330": 96,
    "487334": 96,
    "487337": 96,
    "487551": 96,
    "487555": 96,
    "487661": 96,
    "487770": 96,
    "487881": 96,
    "488001": 96,
    "488333": 96,
    "488888": 24,
    "490001": 48,
    "490006": 48,
    "490009": 48,
    "490011": 48,
    "490012": 48,
    "490013": 48,
    "490020": 48,
    "490021": 48,
    "490022": 48,
    "490023": 48,
    "490024": 48,
    "490025": 48,
    "490026": 48,
    "490027": 48,
    "490036": 48,
    "490042": 48,
    "491001": 48,
    "491002": 48,
    "491107": 48,
    "491227": 96,
    "491331": 48,
    "491441": 48,
    "492001": 48,
    "492002": 48,
    "492003": 48,
    "492004": 48,
    "492005": 48,
    "492006": 48,
    "492007": 48,
    "492008": 48,
    "492009": 48,
    "492010": 48,
    "492012": 48,
    "492013": 48,
    "492014": 48,
    "492015": 48,
    "492099": 48,
    "493118": 96,
    "493221": 48,
    "493770": 96,
    "493773": 96,
    "493776": 96,
    "495001": 48,
    "495004": 48,
    "495005": 48,
    "495006": 48,
    "495009": 48,
    "495220": 48,
    "495223": 48,
    "495450": 96,
    "495454": 96,
    "495551": 48,
    "495557": 96,
    "495671": 96,
    "495677": 96,
    "495678": 96,
    "495684": 96,
    "495689": 96,
    "495690": 96,
    "496001": 96,
    "496005": 96,
    "497001": 96,
    "497101": 96,
    "497226": 96,
    "499999": 24,
    "500000": 24,
    "500001": 24,
    "500002": 24,
    "500003": 24,
    "500004": 24,
    "500005": 24,
    "500006": 24,
    "500007": 24,
    "500009": 24,
    "500010": 24,
    "500011": 24,
    "500012": 24,
    "500013": 24,
    "500014": 24,
    "500015": 24,
    "500016": 24,
    "500017": 24,
    "500018": 24,
    "500019": 24,
    "500020": 24,
    "500021": 24,
    "500022": 24,
    "500023": 24,
    "500024": 24,
    "500025": 24,
    "500026": 24,
    "500027": 24,
    "500029": 24,
    "500030": 24,
    "500031": 24,
    "500032": 24,
    "500033": 24,
    "500034": 24,
    "500035": 24,
    "500036": 24,
    "500037": 24,
    "500038": 24,
    "500039": 24,
    "500040": 24,
    "500041": 24,
    "500042": 24,
    "500043": 24,
    "500044": 24,
    "500045": 24,
    "500046": 24,
    "500047": 24,
    "500048": 24,
    "500049": 24,
    "500050": 24,
    "500051": 24,
    "500052": 24,
    "500053": 24,
    "500054": 24,
    "500055": 24,
    "500056": 24,
    "500057": 24,
    "500058": 24,
    "500059": 24,
    "500060": 24,
    "500061": 24,
    "500062": 24,
    "500063": 24,
    "500064": 24,
    "500065": 24,
    "500066": 24,
    "500067": 24,
    "500068": 24,
    "500069": 24,
    "500070": 24,
    "500071": 24,
    "500072": 24,
    "500073": 24,
    "500074": 24,
    "500075": 24,
    "500076": 24,
    "500077": 24,
    "500078": 24,
    "500079": 24,
    "500080": 24,
    "500081": 24,
    "500082": 24,
    "500083": 24,
    "500084": 24,
    "500085": 24,
    "500086": 24,
    "500087": 24,
    "500088": 24,
    "500089": 24,
    "500090": 24,
    "500091": 24,
    "500092": 24,
    "500093": 24,
    "500094": 24,
    "500095": 24,
    "500096": 24,
    "500097": 24,
    "500098": 24,
    "500100": 24,
    "500101": 24,
    "500102": 24,
    "500103": 24,
    "500104": 24,
    "500105": 24,
    "500107": 24,
    "500108": 24,
    "500110": 24,
    "500111": 24,
    "500123": 24,
    "500146": 24,
    "500170": 24,
    "500177": 24,
    "500178": 24,
    "500195": 24,
    "500409": 24,
    "500472": 24,
    "500475": 24,
    "500476": 24,
    "500484": 24,
    "500486": 24,
    "500488": 24,
    "500605": 24,
    "500768": 24,
    "500789": 24,
    "500890": 24,
    "500960": 24,
    "500991": 24,
    "501101": 48,
    "501102": 48,
    "501218": 24,
    "501301": 24,
    "501359": 24,
    "501401": 24,
    "501503": 48,
    "501505": 24,
    "501506": 24,
    "501507": 24,
    "501508": 24,
    "501510": 24,
    "501511": 24,
    "501512": 24,
    "502001": 48,
    "502032": 24,
    "502103": 48,
    "502110": 96,
    "502205": 24,
    "502248": 96,
    "502269": 96,
    "502270": 96,
    "502278": 96,
    "502285": 24,
    "502286": 96,
    "502290": 96,
    "502291": 96,
    "502300": 24,
    "502305": 24,
    "502307": 24,
    "502312": 96,
    "502319": 24,
    "502324": 24,
    "502325": 24,
    "502329": 24,
    "503001": 96,
    "503002": 96,
    "503003": 96,
    "503165": 48,
    "503174": 96,
    "503175": 96,
    "503180": 96,
    "503185": 96,
    "503186": 96,
    "503217": 96,
    "503224": 96,
    "503230": 96,
    "503307": 48,
    "503311": 48,
    "504106": 96,
    "504218": 96,
    "504220": 96,
    "504231": 96,
    "504251": 96,
    "504272": 96,
    "504302": 96,
    "504307": 96,
    "505001": 48,
    "505002": 48,
    "505122": 48,
    "505172": 48,
    "505186": 48,
    "505187": 48,
    "505208": 48,
    "505209": 48,
    "505210": 48,
    "505211": 48,
    "505215": 48,
    "505301": 48,
    "505302": 48,
    "505305": 48,
    "505307": 48,
    "505325": 48,
    "505326": 48,
    "505327": 48,
    "505330": 48,
    "505401": 48,
    "505402": 48,
    "505403": 48,
    "505404": 48,
    "505405": 48,
    "505415": 48,
    "505450": 48,
    "505460": 48,
    "505467": 48,
    "505468": 48,
    "505470": 48,
    "505490": 48,
    "505524": 48,
    "506001": 48,
    "506002": 48,
    "506003": 48,
    "506004": 48,
    "506005": 48,
    "506006": 48,
    "506007": 48,
    "506008": 48,
    "506009": 48,
    "506010": 48,
    "506011": 48,
    "506012": 48,
    "506013": 48,
    "506015": 48,
    "506101": 96,
    "506132": 48,
    "506142": 48,
    "506163": 48,
    "506164": 48,
    "506166": 48,
    "506167": 48,
    "506168": 48,
    "506169": 48,
    "506172": 48,
    "506315": 96,
    "506319": 48,
    "506370": 48,
    "506371": 48,
    "506381": 96,
    "507001": 96,
    "507002": 96,
    "507003": 96,
    "507004": 96,
    "507101": 96,
    "507111": 96,
    "507113": 96,
    "507115": 96,
    "507121": 96,
    "507123": 96,
    "507128": 96,
    "507129": 96,
    "507130": 96,
    "507133": 96,
    "507134": 96,
    "507137": 96,
    "507140": 96,
    "507168": 96,
    "507203": 48,
    "507303": 96,
    "507318": 96,
    "508001": 48,
    "508116": 48,
    "508126": 24,
    "508204": 48,
    "508206": 48,
    "508207": 48,
    "508213": 96,
    "508233": 48,
    "508234": 48,
    "508238": 48,
    "508252": 48,
    "509001": 48,
    "509002": 48,
    "509102": 48,
    "509103": 96,
    "509104": 48,
    "509106": 48,
    "509110": 48,
    "509120": 48,
    "509125": 48,
    "509131": 48,
    "509202": 48,
    "509206": 48,
    "509208": 48,
    "509209": 96,
    "509210": 48,
    "509215": 96,
    "509216": 48,
    "509219": 48,
    "509228": 48,
    "509301": 48,
    "509302": 48,
    "509351": 48,
    "509381": 48,
    "509407": 48,
    "509412": 48,
    "511111": 24,
    "515001": 48,
    "515002": 48,
    "515003": 48,
    "515004": 48,
    "515005": 48,
    "515101": 48,
    "515102": 48,
    "515110": 48,
    "515122": 48,
    "515133": 48,
    "515134": 48,
    "515144": 48,
    "515164": 48,
    "515201": 48,
    "515202": 48,
    "515211": 48,
    "515212": 48,
    "515213": 48,
    "515231": 48,
    "515241": 48,
    "515261": 48,
    "515271": 48,
    "515291": 48,
    "515301": 48,
    "515303": 48,
    "515331": 48,
    "515401": 48,
    "515402": 48,
    "515404": 48,
    "515405": 48,
    "515411": 48,
    "515413": 48,
    "515415": 48,
    "515425": 48,
    "515427": 48,
    "515445": 48,
    "515446": 48,
    "515501": 48,
    "515502": 48,
    "515541": 48,
    "515551": 48,
    "515561": 48,
    "515591": 48,
    "515631": 48,
    "515651": 48,
    "515671": 48,
    "515701": 48,
    "515722": 48,
    "515741": 48,
    "515761": 48,
    "515763": 48,
    "515767": 48,
    "515801": 48,
    "515803": 48,
    "515832": 48,
    "515834": 48,
    "515842": 48,
    "515843": 48,
    "515865": 48,
    "515867": 48,
    "516001": 48,
    "516002": 48,
    "516003": 48,
    "516004": 48,
    "516005": 48,
    "516104": 48,
    "516107": 48,
    "516115": 48,
    "516126": 48,
    "516127": 48,
    "516128": 48,
    "516130": 48,
    "516150": 48,
    "516151": 48,
    "516152": 48,
    "516162": 48,
    "516163": 48,
    "516172": 48,
    "516193": 48,
    "516203": 48,
    "516213": 48,
    "516214": 48,
    "516215": 48,
    "516216": 48,
    "516218": 48,
    "516227": 48,
    "516228": 48,
    "516233": 48,
    "516237": 48,
    "516247": 48,
    "516257": 48,
    "516267": 48,
    "516268": 48,
    "516269": 48,
    "516270": 48,
    "516289": 48,
    "516293": 48,
    "516309": 48,
    "516310": 48,
    "516311": 48,
    "516312": 48,
    "516321": 48,
    "516329": 48,
    "516339": 48,
    "516349": 48,
    "516350": 48,
    "516355": 48,
    "516359": 48,
    "516360": 48,
    "516361": 48,
    "516362": 48,
    "516366": 48,
    "516390": 48,
    "516391": 48,
    "516396": 48,
    "516401": 48,
    "516421": 48,
    "516434": 48,
    "516454": 48,
    "516501": 48,
    "516502": 48,
    "516504": 48,
    "516505": 48,
    "517001": 48,
    "517002": 48,
    "517003": 48,
    "517004": 48,
    "517101": 48,
    "517102": 48,
    "517112": 48,
    "517113": 96,
    "517123": 96,
    "517124": 48,
    "517125": 48,
    "517126": 48,
    "517127": 48,
    "517128": 48,
    "517129": 96,
    "517130": 48,
    "517131": 48,
    "517132": 48,
    "517143": 48,
    "517152": 96,
    "517167": 48,
    "517192": 96,
    "517193": 96,
    "517214": 96,
    "517234": 96,
    "517247": 96,
    "517305": 48,
    "517403": 48,
    "517408": 96,
    "517415": 96,
    "517416": 96,
    "517419": 48,
    "517421": 48,
    "517422": 48,
    "517429": 96,
    "517501": 48,
    "517502": 48,
    "517503": 48,
    "517504": 48,
    "517505": 48,
    "517506": 48,
    "517507": 48,
    "517520": 48,
    "517526": 48,
    "517536": 48,
    "517541": 48,
    "517551": 48,
    "517561": 48,
    "517569": 48,
    "517571": 48,
    "517581": 48,
    "517582": 48,
    "517583": 48,
    "517584": 48,
    "517586": 48,
    "517587": 48,
    "517588": 48,
    "517589": 48,
    "517590": 48,
    "517591": 48,
    "517592": 48,
    "517599": 96,
    "517620": 48,
    "517640": 48,
    "517641": 48,
    "517643": 48,
    "517644": 48,
    "517645": 48,
    "517646": 48,
    "518001": 48,
    "518002": 48,
    "518003": 48,
    "518004": 48,
    "518005": 48,
    "518006": 48,
    "518007": 48,
    "518010": 48,
    "518124": 48,
    "518186": 48,
    "518222": 48,
    "518301": 48,
    "518360": 48,
    "518422": 48,
    "518452": 48,
    "520001": 48,
    "520002": 48,
    "520003": 48,
    "520004": 48,
    "520005": 48,
    "520006": 48,
    "520007": 48,
    "520008": 48,
    "520009": 48,
    "520010": 48,
    "520011": 48,
    "520012": 48,
    "520013": 48,
    "520014": 48,
    "520015": 48,
    "521001": 48,
    "521002": 48,
    "521101": 48,
    "521102": 48,
    "521104": 48,
    "521105": 48,
    "521106": 48,
    "521107": 48,
    "521108": 48,
    "521109": 48,
    "521110": 48,
    "521111": 48,
    "521113": 48,
    "521114": 48,
    "521121": 48,
    "521125": 48,
    "521126": 48,
    "521137": 48,
    "521139": 48,
    "521148": 48,
    "521151": 48,
    "521158": 48,
    "521165": 48,
    "521175": 48,
    "521185": 48,
    "521201": 48,
    "521202": 48,
    "521212": 48,
    "521215": 48,
    "521225": 48,
    "521263": 48,
    "521286": 48,
    "521301": 48,
    "521311": 48,
    "521312": 48,
    "521321": 48,
    "521322": 48,
    "521323": 48,
    "521325": 48,
    "521326": 48,
    "521327": 48,
    "521330": 48,
    "521331": 48,
    "521343": 48,
    "521345": 48,
    "521356": 48,
    "521358": 48,
    "521444": 48,
    "521456": 48,
    "522001": 48,
    "522002": 48,
    "522003": 48,
    "522004": 48,
    "522005": 48,
    "522006": 48,
    "522007": 48,
    "522009": 48,
    "522022": 48,
    "522034": 48,
    "522101": 48,
    "522102": 48,
    "522124": 48,
    "522201": 48,
    "522202": 48,
    "522212": 48,
    "522222": 24,
    "522262": 48,
    "522263": 48,
    "522265": 48,
    "522314": 48,
    "522315": 48,
    "522329": 48,
    "522403": 96,
    "522413": 96,
    "522501": 48,
    "522502": 48,
    "522503": 48,
    "522508": 48,
    "522509": 48,
    "522510": 48,
    "522601": 48,
    "522614": 96,
    "522616": 48,
    "523115": 96,
    "523155": 48,
    "523157": 48,
    "523201": 48,
    "523211": 48,
    "523212": 48,
    "523247": 48,
    "523262": 48,
    "523274": 48,
    "523301": 48,
    "523316": 48,
    "523333": 48,
    "523334": 48,
    "524001": 48,
    "524002": 48,
    "524003": 48,
    "524004": 48,
    "524005": 48,
    "524101": 48,
    "524121": 48,
    "524126": 48,
    "524129": 48,
    "524132": 48,
    "524137": 48,
    "524142": 96,
    "524152": 96,
    "524201": 96,
    "524202": 96,
    "524203": 96,
    "524221": 96,
    "524222": 96,
    "524223": 96,
    "524224": 96,
    "524227": 96,
    "524228": 96,
    "524230": 96,
    "524234": 96,
    "524239": 96,
    "524240": 48,
    "524301": 96,
    "524303": 96,
    "524304": 96,
    "524305": 48,
    "524307": 96,
    "524308": 96,
    "524309": 96,
    "524311": 48,
    "524313": 48,
    "524315": 48,
    "524316": 48,
    "524317": 48,
    "524318": 48,
    "524319": 48,
    "524320": 48,
    "524322": 96,
    "524341": 96,
    "524344": 48,
    "524346": 48,
    "524366": 48,
    "524401": 48,
    "524405": 48,
    "524410": 48,
    "524411": 48,
    "524412": 48,
    "524413": 48,
    "524415": 48,
    "524421": 48,
    "528101": 48,
    "530001": 48,
    "530002": 48,
    "530003": 48,
    "530004": 48,
    "530005": 48,
    "530006": 48,
    "530007": 48,
    "530008": 48,
    "530009": 48,
    "530010": 48,
    "530011": 48,
    "530012": 48,
    "530013": 48,
    "530014": 48,
    "530015": 48,
    "530016": 48,
    "530017": 48,
    "530018": 48,
    "530020": 48,
    "530021": 48,
    "530022": 48,
    "530023": 48,
    "530024": 48,
    "530025": 48,
    "530026": 48,
    "530027": 48,
    "530028": 48,
    "530029": 48,
    "530032": 48,
    "530035": 48,
    "530037": 48,
    "530040": 48,
    "530041": 48,
    "530042": 96,
    "530043": 48,
    "530044": 48,
    "530045": 96,
    "530046": 48,
    "530047": 48,
    "530048": 96,
    "530049": 48,
    "530051": 48,
    "530052": 96,
    "530053": 48,
    "531011": 48,
    "531019": 48,
    "531020": 48,
    "531021": 48,
    "531033": 48,
    "531061": 48,
    "531114": 96,
    "531116": 96,
    "531118": 96,
    "531126": 48,
    "531162": 96,
    "531163": 96,
    "531173": 96,
    "532001": 96,
    "532005": 96,
    "532127": 120,
    "532185": 120,
    "532186": 120,
    "532195": 120,
    "532201": 120,
    "532203": 120,
    "532211": 120,
    "532212": 120,
    "532221": 120,
    "532222": 120,
    "532405": 120,
    "532406": 120,
    "532409": 96,
    "532421": 120,
    "532430": 120,
    "532464": 48,
    "532484": 120,
    "533001": 48,
    "533002": 48,
    "533003": 48,
    "533004": 48,
    "533005": 48,
    "533006": 48,
    "533007": 48,
    "533008": 48,
    "533016": 48,
    "533101": 48,
    "533102": 48,
    "533103": 48,
    "533104": 48,
    "533105": 48,
    "533106": 48,
    "533107": 48,
    "533125": 48,
    "533126": 48,
    "533201": 48,
    "533211": 48,
    "533216": 48,
    "533223": 48,
    "533242": 48,
    "533244": 48,
    "533250": 48,
    "533251": 48,
    "533253": 48,
    "533254": 48,
    "533291": 48,
    "533294": 48,
    "533296": 48,
    "533342": 48,
    "533345": 48,
    "533346": 48,
    "533349": 48,
    "533350": 48,
    "533351": 48,
    "533401": 48,
    "533406": 48,
    "533445": 48,
    "533447": 48,
    "533450": 48,
    "533463": 48,
    "533464": 48,
    "534001": 48,
    "534002": 48,
    "534003": 48,
    "534004": 48,
    "534005": 48,
    "534006": 48,
    "534007": 48,
    "534101": 48,
    "534102": 48,
    "534111": 48,
    "534112": 48,
    "534145": 48,
    "534146": 48,
    "534165": 48,
    "534166": 48,
    "534195": 48,
    "534196": 48,
    "534197": 48,
    "534201": 48,
    "534202": 48,
    "534203": 48,
    "534204": 48,
    "534211": 48,
    "534247": 48,
    "534250": 48,
    "534251": 48,
    "534260": 48,
    "534265": 48,
    "534266": 48,
    "534268": 48,
    "534275": 96,
    "534281": 48,
    "534301": 48,
    "534305": 48,
    "534313": 48,
    "534327": 48,
    "534338": 48,
    "534350": 48,
    "534401": 48,
    "534406": 48,
    "534411": 48,
    "534416": 48,
    "534425": 48,
    "534435": 48,
    "534437": 48,
    "534442": 48,
    "534444": 48,
    "534460": 96,
    "534467": 48,
    "534475": 48,
    "535001": 96,
    "535002": 96,
    "535101": 120,
    "535117": 96,
    "535128": 120,
    "535204": 96,
    "535217": 120,
    "535501": 120,
    "535502": 120,
    "535522": 120,
    "535527": 120,
    "536201": 48,
    "544444": 24,
    "555555": 24,
    "560000": 24,
    "560001": 24,
    "560002": 24,
    "560003": 24,
    "560004": 24,
    "560005": 24,
    "560006": 24,
    "560007": 24,
    "560008": 24,
    "560009": 24,
    "560010": 24,
    "560011": 24,
    "560012": 24,
    "560013": 24,
    "560014": 24,
    "560015": 24,
    "560016": 24,
    "560017": 24,
    "560018": 24,
    "560019": 24,
    "560020": 24,
    "560021": 24,
    "560022": 24,
    "560023": 24,
    "560024": 24,
    "560025": 24,
    "560026": 24,
    "560027": 24,
    "560028": 24,
    "560029": 24,
    "560030": 24,
    "560031": 24,
    "560032": 24,
    "560033": 24,
    "560034": 24,
    "560035": 24,
    "560036": 24,
    "560037": 24,
    "560038": 24,
    "560039": 24,
    "560040": 24,
    "560041": 24,
    "560042": 24,
    "560043": 24,
    "560044": 24,
    "560046": 24,
    "560047": 24,
    "560048": 24,
    "560049": 24,
    "560050": 24,
    "560051": 24,
    "560052": 24,
    "560053": 24,
    "560054": 24,
    "560055": 24,
    "560056": 24,
    "560057": 24,
    "560058": 24,
    "560059": 24,
    "560060": 24,
    "560061": 24,
    "560062": 24,
    "560063": 24,
    "560064": 24,
    "560065": 24,
    "560066": 24,
    "560067": 24,
    "560068": 24,
    "560069": 24,
    "560070": 24,
    "560071": 24,
    "560072": 24,
    "560073": 24,
    "560074": 24,
    "560075": 24,
    "560076": 24,
    "560077": 24,
    "560078": 24,
    "560079": 24,
    "560080": 24,
    "560081": 24,
    "560082": 24,
    "560083": 24,
    "560084": 24,
    "560085": 24,
    "560086": 24,
    "560087": 24,
    "560088": 24,
    "560089": 24,
    "560090": 24,
    "560091": 24,
    "560092": 24,
    "560093": 24,
    "560094": 24,
    "560095": 24,
    "560096": 24,
    "560097": 24,
    "560098": 24,
    "560099": 24,
    "560100": 24,
    "560102": 24,
    "560103": 24,
    "560104": 24,
    "560105": 24,
    "560106": 24,
    "560107": 24,
    "560108": 24,
    "560109": 24,
    "560110": 24,
    "560111": 24,
    "560112": 24,
    "560300": 24,
    "560500": 24,
    "561201": 24,
    "561202": 48,
    "561203": 24,
    "561205": 24,
    "561206": 48,
    "561207": 48,
    "561208": 48,
    "561210": 48,
    "561211": 48,
    "561212": 48,
    "561213": 48,
    "562101": 24,
    "562103": 24,
    "562105": 24,
    "562106": 24,
    "562107": 24,
    "562109": 24,
    "562110": 24,
    "562111": 48,
    "562112": 48,
    "562114": 24,
    "562115": 24,
    "562116": 48,
    "562120": 48,
    "562122": 24,
    "562123": 24,
    "562125": 24,
    "562127": 48,
    "562129": 24,
    "562130": 48,
    "562132": 24,
    "562137": 48,
    "562149": 24,
    "562151": 48,
    "562152": 24,
    "562157": 24,
    "562159": 48,
    "562160": 48,
    "562161": 48,
    "562162": 24,
    "562163": 24,
    "563101": 48,
    "563102": 48,
    "563103": 48,
    "563109": 48,
    "563113": 48,
    "563115": 48,
    "563116": 48,
    "563117": 48,
    "563118": 48,
    "563119": 48,
    "563120": 48,
    "563121": 48,
    "563122": 48,
    "563125": 48,
    "563128": 48,
    "563130": 48,
    "563131": 48,
    "563133": 48,
    "563333": 48,
    "564545": 24,
    "566105": 24,
    "566666": 24,
    "566667": 24,
    "567233": 48,
    "567777": 24,
    "569999": 24,
    "570001": 48,
    "570002": 48,
    "570003": 48,
    "570004": 48,
    "570005": 48,
    "570006": 48,
    "570007": 48,
    "570008": 48,
    "570009": 48,
    "570010": 48,
    "570011": 48,
    "570012": 48,
    "570013": 48,
    "570014": 48,
    "570015": 48,
    "570016": 48,
    "570017": 48,
    "570018": 48,
    "570019": 48,
    "570020": 48,
    "570021": 48,
    "570022": 48,
    "570023": 48,
    "570024": 48,
    "570025": 48,
    "570026": 48,
    "570027": 48,
    "570028": 48,
    "570029": 48,
    "570030": 48,
    "570031": 48,
    "570041": 48,
    "570301": 48,
    "571101": 48,
    "571103": 48,
    "571104": 48,
    "571105": 48,
    "571106": 48,
    "571107": 48,
    "571109": 48,
    "571110": 48,
    "571111": 48,
    "571114": 48,
    "571115": 48,
    "571116": 48,
    "571117": 48,
    "571118": 48,
    "571119": 48,
    "571120": 48,
    "571121": 48,
    "571122": 48,
    "571123": 48,
    "571124": 48,
    "571127": 48,
    "571128": 48,
    "571129": 48,
    "571130": 48,
    "571139": 48,
    "571156": 48,
    "571159": 48,
    "571166": 48,
    "571186": 48,
    "571189": 48,
    "571201": 48,
    "571213": 48,
    "571214": 48,
    "571215": 48,
    "571216": 48,
    "571217": 48,
    "571218": 48,
    "571219": 48,
    "571221": 48,
    "571231": 48,
    "571232": 48,
    "571233": 48,
    "571234": 48,
    "571235": 48,
    "571236": 48,
    "571237": 48,
    "571248": 48,
    "571251": 48,
    "571301": 48,
    "571302": 48,
    "571304": 48,
    "571311": 48,
    "571312": 48,
    "571313": 48,
    "571314": 48,
    "571315": 48,
    "571319": 48,
    "571320": 48,
    "571321": 48,
    "571322": 48,
    "571325": 48,
    "571329": 48,
    "571331": 48,
    "571337": 48,
    "571342": 48,
    "571401": 48,
    "571402": 48,
    "571403": 48,
    "571404": 48,
    "571405": 48,
    "571415": 48,
    "571416": 48,
    "571418": 48,
    "571419": 48,
    "571422": 48,
    "571423": 48,
    "571425": 48,
    "571426": 48,
    "571427": 48,
    "571428": 48,
    "571429": 48,
    "571430": 48,
    "571431": 48,
    "571432": 48,
    "571433": 48,
    "571434": 48,
    "571435": 48,
    "571436": 48,
    "571437": 48,
    "571438": 48,
    "571439": 48,
    "571440": 48,
    "571441": 48,
    "571442": 48,
    "571443": 48,
    "571445": 48,
    "571446": 48,
    "571448": 48,
    "571450": 48,
    "571454": 48,
    "571455": 48,
    "571457": 48,
    "571463": 48,
    "571476": 48,
    "571477": 48,
    "571478": 48,
    "571480": 48,
    "571483": 48,
    "571501": 48,
    "571502": 48,
    "571511": 48,
    "571602": 48,
    "571603": 48,
    "571604": 48,
    "571605": 48,
    "571606": 48,
    "571607": 48,
    "571610": 48,
    "571617": 48,
    "571802": 48,
    "571810": 48,
    "571811": 48,
    "571812": 48,
    "572101": 48,
    "572102": 48,
    "572103": 48,
    "572104": 48,
    "572105": 48,
    "572106": 48,
    "572107": 48,
    "572108": 48,
    "572111": 48,
    "572112": 48,
    "572114": 48,
    "572118": 48,
    "572122": 48,
    "572128": 48,
    "572130": 48,
    "572137": 48,
    "572138": 48,
    "572140": 48,
    "572143": 48,
    "572144": 48,
    "572145": 48,
    "572151": 48,
    "572168": 48,
    "572201": 48,
    "572202": 48,
    "572441": 48,
    "573101": 48,
    "573102": 96,
    "573103": 96,
    "573111": 96,
    "573112": 96,
    "573115": 48,
    "573116": 96,
    "573118": 48,
    "573120": 48,
    "573121": 48,
    "573124": 96,
    "573128": 48,
    "573130": 96,
    "573131": 96,
    "573133": 96,
    "573134": 96,
    "573135": 96,
    "573143": 48,
    "573145": 48,
    "573147": 96,
    "573150": 96,
    "573160": 96,
    "573165": 96,
    "573201": 48,
    "573202": 48,
    "573210": 96,
    "573211": 96,
    "573212": 48,
    "573215": 48,
    "573216": 48,
    "573217": 48,
    "573219": 48,
    "573220": 48,
    "573225": 48,
    "573226": 48,
    "573228": 48,
    "573425": 48,
    "573445": 48,
    "573628": 48,
    "574101": 48,
    "574103": 48,
    "574104": 48,
    "574105": 48,
    "574106": 48,
    "574108": 48,
    "574110": 48,
    "574111": 48,
    "574112": 48,
    "574113": 48,
    "574116": 48,
    "574117": 48,
    "574118": 48,
    "574119": 48,
    "574120": 48,
    "574122": 48,
    "574123": 48,
    "574126": 48,
    "574130": 48,
    "574131": 48,
    "574134": 48,
    "574138": 48,
    "574139": 48,
    "574140": 48,
    "574141": 48,
    "574143": 48,
    "574144": 48,
    "574146": 48,
    "574150": 48,
    "574151": 48,
    "574152": 48,
    "574153": 48,
    "574154": 48,
    "574157": 48,
    "574159": 48,
    "574160": 48,
    "574161": 48,
    "574162": 48,
    "574163": 48,
    "574164": 48,
    "574165": 48,
    "574166": 48,
    "574167": 48,
    "574168": 48,
    "574169": 48,
    "574171": 48,
    "574172": 48,
    "574173": 48,
    "574179": 48,
    "574180": 48,
    "574181": 48,
    "574182": 48,
    "574183": 48,
    "574184": 48,
    "574187": 48,
    "574188": 48,
    "574189": 48,
    "574194": 48,
    "574197": 48,
    "574198": 48,
    "574199": 48,
    "574201": 48,
    "574202": 48,
    "574203": 48,
    "574210": 48,
    "574211": 48,
    "574212": 48,
    "574213": 48,
    "574214": 48,
    "574216": 48,
    "574217": 48,
    "574218": 48,
    "574219": 48,
    "574220": 48,
    "574221": 48,
    "574222": 48,
    "574223": 48,
    "574224": 48,
    "574225": 48,
    "574226": 48,
    "574227": 48,
    "574228": 48,
    "574229": 48,
    "574230": 48,
    "574231": 48,
    "574232": 48,
    "574233": 48,
    "574237": 48,
    "574238": 48,
    "574239": 48,
    "574240": 48,
    "574241": 48,
    "574242": 48,
    "574243": 48,
    "574245": 48,
    "574248": 48,
    "574250": 48,
    "574251": 48,
    "574253": 48,
    "574258": 48,
    "574259": 48,
    "574261": 48,
    "574262": 48,
    "574263": 48,
    "574264": 48,
    "574265": 48,
    "574266": 48,
    "574267": 48,
    "574269": 48,
    "574272": 48,
    "574274": 48,
    "574275": 48,
    "574276": 48,
    "574277": 48,
    "574282": 48,
    "574284": 48,
    "574285": 48,
    "574287": 48,
    "574289": 48,
    "574291": 48,
    "574294": 48,
    "574296": 48,
    "574297": 48,
    "574299": 48,
    "574309": 48,
    "574310": 48,
    "574311": 48,
    "574312": 48,
    "574313": 48,
    "574314": 48,
    "574315": 48,
    "574317": 48,
    "574318": 48,
    "574319": 48,
    "574324": 48,
    "574325": 48,
    "574326": 48,
    "574327": 48,
    "574335": 48,
    "574337": 48,
    "574504": 48,
    "574561": 48,
    "575001": 48,
    "575002": 48,
    "575003": 48,
    "575004": 48,
    "575005": 48,
    "575006": 48,
    "575007": 48,
    "575008": 48,
    "575009": 48,
    "575010": 48,
    "575011": 48,
    "575012": 48,
    "575013": 48,
    "575014": 48,
    "575015": 48,
    "575016": 48,
    "575017": 48,
    "575018": 48,
    "575019": 48,
    "575020": 48,
    "575021": 48,
    "575022": 48,
    "575023": 48,
    "575025": 48,
    "575026": 48,
    "575027": 48,
    "575028": 48,
    "575029": 48,
    "575030": 48,
    "575130": 96,
    "575220": 24,
    "575221": 48,
    "575253": 48,
    "575551": 48,
    "575889": 48,
    "576001": 48,
    "576003": 48,
    "576101": 48,
    "576102": 48,
    "576103": 48,
    "576104": 48,
    "576105": 48,
    "576106": 48,
    "576107": 48,
    "576108": 48,
    "576111": 48,
    "576112": 48,
    "576113": 48,
    "576114": 48,
    "576115": 48,
    "576116": 48,
    "576118": 48,
    "576119": 48,
    "576121": 48,
    "576122": 48,
    "576125": 48,
    "576126": 48,
    "576127": 48,
    "576128": 48,
    "576129": 48,
    "576131": 48,
    "576135": 48,
    "576136": 48,
    "576145": 48,
    "576201": 48,
    "576210": 48,
    "576211": 48,
    "576212": 48,
    "576213": 48,
    "576214": 48,
    "576216": 48,
    "576217": 48,
    "576218": 48,
    "576221": 48,
    "576222": 48,
    "576223": 48,
    "576224": 48,
    "576225": 48,
    "576226": 48,
    "576228": 48,
    "576229": 48,
    "576230": 48,
    "576231": 48,
    "576232": 48,
    "576233": 48,
    "576234": 48,
    "576235": 48,
    "576238": 48,
    "576241": 48,
    "576243": 48,
    "576244": 48,
    "576247": 48,
    "576249": 48,
    "576252": 48,
    "576254": 48,
    "576257": 48,
    "576262": 48,
    "576266": 48,
    "576282": 48,
    "576283": 48,
    "576425": 48,
    "576445": 48,
    "577001": 48,
    "577002": 48,
    "577003": 48,
    "577004": 48,
    "577005": 48,
    "577006": 48,
    "577101": 48,
    "577102": 48,
    "577111": 96,
    "577113": 96,
    "577115": 48,
    "577116": 96,
    "577119": 96,
    "577132": 96,
    "577133": 48,
    "577135": 96,
    "577147": 96,
    "577149": 48,
    "577156": 48,
    "577168": 48,
    "577175": 96,
    "577201": 48,
    "577202": 48,
    "577203": 48,
    "577204": 48,
    "577205": 48,
    "577213": 48,
    "577214": 48,
    "577222": 48,
    "577229": 48,
    "577232": 48,
    "577234": 48,
    "577235": 48,
    "577236": 48,
    "577245": 48,
    "577301": 48,
    "577302": 48,
    "577303": 48,
    "577401": 48,
    "577411": 48,
    "577412": 48,
    "577413": 48,
    "577414": 48,
    "577415": 48,
    "577416": 48,
    "577417": 48,
    "577422": 48,
    "577424": 48,
    "577427": 48,
    "577429": 48,
    "577430": 48,
    "577432": 48,
    "577434": 48,
    "577435": 48,
    "577439": 48,
    "577443": 48,
    "577501": 48,
    "577502": 48,
    "577511": 48,
    "577516": 48,
    "577517": 48,
    "577520": 48,
    "577521": 48,
    "577522": 48,
    "577524": 48,
    "577526": 48,
    "577527": 48,
    "577532": 48,
    "577536": 48,
    "577537": 48,
    "577538": 48,
    "577541": 48,
    "577543": 48,
    "577544": 48,
    "577545": 48,
    "577548": 96,
    "577551": 48,
    "577555": 48,
    "577556": 48,
    "577558": 48,
    "577566": 48,
    "577583": 48,
    "577598": 48,
    "577599": 48,
    "577601": 48,
    "577602": 48,
    "580001": 48,
    "580002": 48,
    "580003": 48,
    "580004": 48,
    "580005": 48,
    "580006": 48,
    "580007": 48,
    "580008": 48,
    "580009": 48,
    "580010": 48,
    "580011": 48,
    "580020": 48,
    "580021": 48,
    "580022": 48,
    "580023": 48,
    "580024": 48,
    "580025": 48,
    "580026": 48,
    "580028": 48,
    "580029": 48,
    "580030": 48,
    "580031": 48,
    "580032": 48,
    "580112": 48,
    "580114": 48,
    "580116": 48,
    "580118": 48,
    "580212": 48,
    "580213": 48,
    "580214": 48,
    "581047": 48,
    "581101": 48,
    "581102": 48,
    "581103": 48,
    "581104": 48,
    "581105": 48,
    "581106": 48,
    "581108": 48,
    "581109": 48,
    "581110": 48,
    "581111": 48,
    "581112": 48,
    "581115": 48,
    "581116": 48,
    "581118": 48,
    "581119": 48,
    "581120": 48,
    "581123": 48,
    "581124": 48,
    "581125": 48,
    "581126": 48,
    "581127": 48,
    "581128": 48,
    "581131": 48,
    "581132": 48,
    "581134": 48,
    "581138": 48,
    "581139": 48,
    "581140": 48,
    "581145": 48,
    "581147": 48,
    "581148": 48,
    "581149": 48,
    "581150": 48,
    "581153": 48,
    "581154": 48,
    "581155": 48,
    "581157": 48,
    "581158": 48,
    "581160": 48,
    "581163": 48,
    "581164": 48,
    "581167": 48,
    "581168": 48,
    "581169": 48,
    "581170": 48,
    "581177": 48,
    "581181": 48,
    "581182": 48,
    "581183": 48,
    "581185": 48,
    "581189": 48,
    "581191": 96,
    "581193": 96,
    "581197": 96,
    "581198": 48,
    "581199": 48,
    "581201": 48,
    "581202": 96,
    "581203": 48,
    "581206": 48,
    "581208": 48,
    "581210": 48,
    "581211": 48,
    "581212": 96,
    "581213": 48,
    "581214": 96,
    "581225": 48,
    "581228": 96,
    "581301": 48,
    "581302": 48,
    "581303": 48,
    "581304": 48,
    "581305": 48,
    "581306": 48,
    "581307": 48,
    "581308": 48,
    "581314": 48,
    "581316": 48,
    "581320": 48,
    "581321": 48,
    "581323": 48,
    "581324": 48,
    "581325": 48,
    "581327": 48,
    "581329": 48,
    "581330": 48,
    "581332": 48,
    "581334": 48,
    "581335": 48,
    "581341": 48,
    "581342": 48,
    "581343": 48,
    "581345": 48,
    "581348": 48,
    "581349": 96,
    "581350": 48,
    "581351": 48,
    "581352": 48,
    "581353": 48,
    "581354": 48,
    "581357": 48,
    "581360": 48,
    "581361": 48,
    "581362": 48,
    "581396": 48,
    "581400": 48,
    "581401": 96,
    "581402": 96,
    "581405": 96,
    "581411": 96,
    "581421": 48,
    "582101": 48,
    "582102": 48,
    "582103": 48,
    "582121": 48,
    "582122": 48,
    "582123": 48,
    "582201": 48,
    "582205": 48,
    "582214": 48,
    "582218": 48,
    "582225": 48,
    "582227": 48,
    "582231": 48,
    "582234": 48,
    "582243": 96,
    "583101": 48,
    "583102": 48,
    "583103": 48,
    "583104": 48,
    "583105": 48,
    "583111": 48,
    "583113": 48,
    "583114": 48,
    "583115": 48,
    "583116": 48,
    "583117": 48,
    "583120": 48,
    "583121": 48,
    "583122": 48,
    "583123": 48,
    "583129": 48,
    "583132": 48,
    "583138": 48,
    "583144": 48,
    "583147": 48,
    "583152": 48,
    "583201": 48,
    "583202": 48,
    "583203": 48,
    "583204": 48,
    "583211": 48,
    "583215": 48,
    "583221": 48,
    "583222": 48,
    "583223": 48,
    "583225": 48,
    "583227": 48,
    "583228": 48,
    "583229": 48,
    "583230": 48,
    "583231": 48,
    "583233": 48,
    "583234": 48,
    "583238": 48,
    "583239": 48,
    "583245": 48,
    "583250": 48,
    "583253": 48,
    "583255": 48,
    "583263": 48,
    "583268": 48,
    "583271": 48,
    "583272": 48,
    "583273": 48,
    "583275": 48,
    "583276": 48,
    "583286": 48,
    "584101": 48,
    "584102": 48,
    "584103": 48,
    "584104": 48,
    "584115": 48,
    "584118": 48,
    "584122": 48,
    "584123": 48,
    "584124": 48,
    "584125": 48,
    "584128": 48,
    "584129": 48,
    "584131": 48,
    "584132": 48,
    "584134": 48,
    "584135": 48,
    "584138": 48,
    "584142": 48,
    "584143": 48,
    "584167": 48,
    "584170": 48,
    "584202": 48,
    "585101": 48,
    "585102": 48,
    "585103": 48,
    "585104": 48,
    "585105": 48,
    "585201": 48,
    "585202": 48,
    "585211": 48,
    "585221": 48,
    "585222": 48,
    "585223": 48,
    "585225": 48,
    "585287": 48,
    "585292": 48,
    "585306": 48,
    "585313": 96,
    "585327": 96,
    "585330": 96,
    "585401": 96,
    "585402": 96,
    "585403": 96,
    "586101": 48,
    "586102": 48,
    "586103": 48,
    "586104": 48,
    "586105": 48,
    "586106": 48,
    "586107": 48,
    "586108": 48,
    "586109": 48,
    "586126": 96,
    "586128": 48,
    "586130": 48,
    "586144": 48,
    "586148": 48,
    "586149": 48,
    "586169": 48,
    "586202": 48,
    "586209": 96,
    "586212": 48,
    "586245": 48,
    "587101": 48,
    "587102": 48,
    "587103": 48,
    "587104": 48,
    "587111": 48,
    "587113": 96,
    "587114": 48,
    "587116": 48,
    "587118": 48,
    "587119": 96,
    "587122": 96,
    "587124": 48,
    "587125": 48,
    "587126": 48,
    "587143": 48,
    "587145": 48,
    "587154": 48,
    "587201": 48,
    "587203": 48,
    "587204": 48,
    "587205": 48,
    "587212": 96,
    "587213": 48,
    "587301": 96,
    "587302": 96,
    "587311": 96,
    "587312": 96,
    "587313": 96,
    "587314": 96,
    "587315": 96,
    "587316": 96,
    "587320": 96,
    "587322": 96,
    "590001": 48,
    "590002": 48,
    "590003": 48,
    "590004": 48,
    "590005": 48,
    "590006": 48,
    "590007": 48,
    "590008": 48,
    "590009": 48,
    "590010": 48,
    "590011": 48,
    "590012": 48,
    "590013": 48,
    "590014": 48,
    "590015": 48,
    "590016": 48,
    "590017": 48,
    "590018": 48,
    "590019": 48,
    "590543": 48,
    "591102": 48,
    "591104": 48,
    "591107": 48,
    "591108": 48,
    "591112": 48,
    "591113": 48,
    "591115": 48,
    "591118": 48,
    "591121": 48,
    "591124": 48,
    "591125": 48,
    "591126": 48,
    "591153": 48,
    "591181": 48,
    "591201": 48,
    "591211": 48,
    "591212": 96,
    "591214": 48,
    "591218": 48,
    "591219": 48,
    "591220": 96,
    "591224": 48,
    "591227": 48,
    "591229": 48,
    "591230": 96,
    "591232": 96,
    "591233": 48,
    "591237": 48,
    "591239": 48,
    "591241": 48,
    "591242": 48,
    "591244": 48,
    "591247": 48,
    "591261": 96,
    "591263": 48,
    "591304": 96,
    "591306": 48,
    "591307": 48,
    "591308": 48,
    "591312": 48,
    "591344": 48,
    "591513": 48,
    "599991": 24,
    "600000": 24,
    "600001": 24,
    "600002": 24,
    "600003": 24,
    "600004": 24,
    "600005": 24,
    "600006": 24,
    "600007": 24,
    "600008": 24,
    "600009": 24,
    "600010": 24,
    "600011": 24,
    "600012": 24,
    "600013": 24,
    "600014": 24,
    "600015": 24,
    "600016": 24,
    "600017": 24,
    "600018": 24,
    "600019": 24,
    "600020": 24,
    "600021": 24,
    "600022": 24,
    "600023": 24,
    "600024": 24,
    "600025": 24,
    "600026": 24,
    "600027": 24,
    "600028": 24,
    "600029": 24,
    "600030": 24,
    "600031": 24,
    "600032": 24,
    "600033": 24,
    "600034": 24,
    "600035": 24,
    "600036": 24,
    "600037": 24,
    "600038": 24,
    "600039": 24,
    "600040": 24,
    "600041": 24,
    "600042": 24,
    "600043": 24,
    "600044": 24,
    "600045": 24,
    "600046": 24,
    "600047": 24,
    "600048": 24,
    "600049": 24,
    "600050": 24,
    "600051": 24,
    "600052": 48,
    "600053": 24,
    "600054": 24,
    "600055": 24,
    "600056": 24,
    "600057": 24,
    "600058": 24,
    "600059": 24,
    "600060": 24,
    "600061": 24,
    "600062": 24,
    "600063": 24,
    "600064": 24,
    "600065": 24,
    "600066": 24,
    "600067": 48,
    "600068": 24,
    "600069": 48,
    "600070": 24,
    "600071": 24,
    "600072": 48,
    "600073": 24,
    "600074": 24,
    "600075": 24,
    "600076": 24,
    "600077": 24,
    "600078": 24,
    "600079": 24,
    "600080": 24,
    "600081": 24,
    "600082": 24,
    "600083": 24,
    "600084": 24,
    "600085": 24,
    "600086": 24,
    "600087": 24,
    "600088": 24,
    "600089": 24,
    "600090": 24,
    "600091": 24,
    "600092": 24,
    "600093": 24,
    "600094": 24,
    "600095": 24,
    "600096": 24,
    "600097": 24,
    "600098": 24,
    "600099": 24,
    "600100": 24,
    "600101": 24,
    "600102": 24,
    "600103": 24,
    "600104": 24,
    "600105": 24,
    "600106": 24,
    "600107": 24,
    "600108": 24,
    "600109": 24,
    "600110": 24,
    "600111": 24,
    "600112": 24,
    "600113": 24,
    "600114": 24,
    "600115": 24,
    "600116": 24,
    "600117": 24,
    "600118": 24,
    "600119": 24,
    "600120": 48,
    "600122": 48,
    "600123": 48,
    "600124": 48,
    "600125": 24,
    "600126": 24,
    "600127": 24,
    "600128": 48,
    "600129": 24,
    "600130": 24,
    "600132": 24,
    "600222": 24,
    "600704": 24,
    "601101": 48,
    "601102": 48,
    "601103": 48,
    "601201": 24,
    "601202": 48,
    "601203": 48,
    "601204": 48,
    "601205": 48,
    "601206": 48,
    "601301": 48,
    "602000": 24,
    "602001": 48,
    "602002": 48,
    "602003": 48,
    "602004": 48,
    "602010": 24,
    "602017": 24,
    "602021": 48,
    "602023": 48,
    "602024": 48,
    "602025": 48,
    "602026": 48,
    "602105": 24,
    "602106": 24,
    "602108": 48,
    "602117": 24,
    "602204": 24,
    "602205": 24,
    "603001": 48,
    "603002": 48,
    "603003": 48,
    "603004": 24,
    "603101": 48,
    "603103": 24,
    "603104": 48,
    "603105": 48,
    "603109": 48,
    "603110": 24,
    "603111": 48,
    "603112": 48,
    "603127": 48,
    "603201": 48,
    "603202": 24,
    "603203": 24,
    "603204": 24,
    "603209": 24,
    "603210": 48,
    "603211": 48,
    "603301": 48,
    "603302": 48,
    "603303": 48,
    "603304": 48,
    "603306": 48,
    "603309": 48,
    "603310": 48,
    "603311": 48,
    "603313": 48,
    "603319": 48,
    "603401": 48,
    "604001": 48,
    "604002": 48,
    "604151": 96,
    "604152": 96,
    "604153": 96,
    "604201": 96,
    "604202": 96,
    "604204": 96,
    "604205": 96,
    "604210": 96,
    "604303": 48,
    "604503": 48,
    "604504": 48,
    "604601": 96,
    "605001": 48,
    "605002": 48,
    "605003": 48,
    "605004": 48,
    "605005": 48,
    "605006": 48,
    "605007": 48,
    "605008": 48,
    "605009": 48,
    "605010": 48,
    "605011": 48,
    "605012": 48,
    "605013": 48,
    "605014": 48,
    "605101": 48,
    "605102": 48,
    "605104": 48,
    "605105": 48,
    "605106": 48,
    "605107": 48,
    "605108": 48,
    "605109": 48,
    "605110": 48,
    "605111": 48,
    "605201": 96,
    "605401": 48,
    "605501": 48,
    "605502": 48,
    "605602": 48,
    "605604": 48,
    "605606": 48,
    "605701": 48,
    "605751": 48,
    "605752": 48,
    "605754": 48,
    "605755": 48,
    "605756": 48,
    "605757": 48,
    "605758": 48,
    "605759": 48,
    "605766": 48,
    "605802": 48,
    "605803": 48,
    "606001": 48,
    "606003": 48,
    "606102": 48,
    "606103": 48,
    "606104": 48,
    "606105": 48,
    "606106": 48,
    "606107": 48,
    "606108": 48,
    "606109": 48,
    "606110": 48,
    "606111": 48,
    "606115": 48,
    "606202": 48,
    "606207": 48,
    "606301": 48,
    "606302": 48,
    "606304": 48,
    "606601": 48,
    "606602": 48,
    "606603": 48,
    "606604": 48,
    "606611": 96,
    "606701": 48,
    "606702": 48,
    "606703": 48,
    "606704": 48,
    "606705": 48,
    "606706": 48,
    "606709": 48,
    "606710": 48,
    "606752": 96,
    "606801": 48,
    "606804": 48,
    "606806": 48,
    "606808": 96,
    "606811": 48,
    "606902": 48,
    "606903": 48,
    "606905": 48,
    "606907": 48,
    "606908": 48,
    "607001": 48,
    "607002": 48,
    "607003": 48,
    "607004": 48,
    "607005": 48,
    "607006": 48,
    "607102": 48,
    "607103": 48,
    "607104": 48,
    "607105": 48,
    "607106": 48,
    "607108": 48,
    "607109": 48,
    "607112": 48,
    "607201": 48,
    "607202": 48,
    "607204": 48,
    "607301": 48,
    "607302": 48,
    "607303": 48,
    "607308": 48,
    "607401": 48,
    "607402": 48,
    "607403": 48,
    "607801": 48,
    "607802": 48,
    "607803": 48,
    "607804": 48,
    "607805": 48,
    "607807": 48,
    "608001": 48,
    "608002": 48,
    "608102": 48,
    "608201": 48,
    "608301": 48,
    "608302": 48,
    "608303": 48,
    "608305": 48,
    "608401": 48,
    "608501": 48,
    "608502": 48,
    "608601": 48,
    "608602": 48,
    "608701": 48,
    "608702": 48,
    "608704": 48,
    "609001": 48,
    "609002": 48,
    "609003": 48,
    "609101": 48,
    "609102": 48,
    "609104": 48,
    "609105": 48,
    "609106": 48,
    "609107": 48,
    "609108": 48,
    "609109": 48,
    "609110": 48,
    "609111": 48,
    "609112": 48,
    "609113": 48,
    "609115": 48,
    "609116": 48,
    "609301": 48,
    "609302": 48,
    "609303": 48,
    "609304": 48,
    "609306": 48,
    "609307": 48,
    "609309": 48,
    "609310": 48,
    "609311": 48,
    "609312": 48,
    "609313": 48,
    "609314": 48,
    "609402": 48,
    "609503": 96,
    "609601": 48,
    "609602": 48,
    "609603": 48,
    "609604": 48,
    "609605": 48,
    "609606": 48,
    "609607": 48,
    "609609": 48,
    "609702": 48,
    "609703": 48,
    "610001": 96,
    "610002": 96,
    "610003": 96,
    "610004": 96,
    "610005": 96,
    "610051": 96,
    "610101": 96,
    "610103": 96,
    "610105": 96,
    "610106": 96,
    "610109": 96,
    "610202": 96,
    "610203": 96,
    "610207": 96,
    "610210": 96,
    "610211": 96,
    "611101": 96,
    "611105": 96,
    "611112": 96,
    "612001": 48,
    "612002": 48,
    "612101": 48,
    "612103": 48,
    "612104": 48,
    "612105": 48,
    "612107": 48,
    "612108": 48,
    "612204": 48,
    "612206": 48,
    "612301": 48,
    "612303": 48,
    "612602": 48,
    "612702": 48,
    "612703": 48,
    "612803": 48,
    "612804": 48,
    "612901": 48,
    "612902": 48,
    "612903": 48,
    "613001": 48,
    "613002": 48,
    "613003": 48,
    "613004": 48,
    "613005": 48,
    "613006": 48,
    "613007": 48,
    "613008": 48,
    "613009": 48,
    "613010": 48,
    "613101": 48,
    "613104": 48,
    "613205": 48,
    "613303": 48,
    "613401": 48,
    "613403": 48,
    "613601": 48,
    "613704": 96,
    "614001": 48,
    "614010": 48,
    "614013": 48,
    "614014": 48,
    "614015": 48,
    "614016": 48,
    "614017": 48,
    "614018": 48,
    "614020": 48,
    "614024": 48,
    "614028": 48,
    "614101": 48,
    "614201": 48,
    "614202": 48,
    "614203": 48,
    "614205": 48,
    "614206": 48,
    "614207": 48,
    "614208": 48,
    "614209": 48,
    "614302": 48,
    "614303": 48,
    "614403": 48,
    "614404": 48,
    "614601": 48,
    "614602": 48,
    "614615": 48,
    "614616": 48,
    "614623": 48,
    "614624": 48,
    "614701": 48,
    "614704": 48,
    "614708": 96,
    "614713": 96,
    "614714": 96,
    "614717": 48,
    "614722": 48,
    "614804": 48,
    "614901": 48,
    "614906": 48,
    "620001": 48,
    "620002": 96,
    "620003": 96,
    "620004": 48,
    "620005": 96,
    "620006": 96,
    "620007": 48,
    "620008": 96,
    "620009": 48,
    "620010": 96,
    "620011": 96,
    "620012": 48,
    "620013": 48,
    "620014": 48,
    "620015": 48,
    "620016": 48,
    "620017": 96,
    "620018": 96,
    "620019": 48,
    "620020": 48,
    "620021": 48,
    "620022": 48,
    "620023": 48,
    "620024": 48,
    "620025": 48,
    "620026": 48,
    "620052": 48,
    "620101": 96,
    "620102": 96,
    "620114": 48,
    "621005": 48,
    "621008": 96,
    "621010": 96,
    "621012": 96,
    "621014": 96,
    "621016": 96,
    "621018": 96,
    "621022": 96,
    "621103": 48,
    "621104": 48,
    "621105": 48,
    "621108": 48,
    "621110": 48,
    "621112": 48,
    "621113": 48,
    "621115": 48,
    "621117": 48,
    "621126": 48,
    "621127": 48,
    "621132": 48,
    "621201": 48,
    "621202": 48,
    "621203": 48,
    "621206": 96,
    "621207": 48,
    "621209": 48,
    "621211": 48,
    "621212": 48,
    "621213": 48,
    "621214": 48,
    "621215": 48,
    "621216": 48,
    "621218": 48,
    "621219": 48,
    "621220": 48,
    "621221": 48,
    "621229": 48,
    "621306": 48,
    "621307": 48,
    "621312": 48,
    "621314": 48,
    "621316": 48,
    "621516": 48,
    "621591": 48,
    "621601": 48,
    "621651": 48,
    "621704": 48,
    "621707": 48,
    "621710": 48,
    "621713": 48,
    "621801": 48,
    "621802": 48,
    "621803": 48,
    "621804": 48,
    "621806": 48,
    "622001": 48,
    "622002": 48,
    "622003": 48,
    "622054": 48,
    "622301": 48,
    "622302": 48,
    "622515": 48,
    "623115": 48,
    "623135": 48,
    "623215": 48,
    "623309": 48,
    "623315": 48,
    "623402": 48,
    "623403": 48,
    "623404": 48,
    "623406": 48,
    "623407": 48,
    "623409": 48,
    "623501": 48,
    "623503": 48,
    "623504": 48,
    "623513": 48,
    "623514": 48,
    "623515": 48,
    "623517": 48,
    "623518": 48,
    "623519": 48,
    "623520": 48,
    "623521": 48,
    "623522": 48,
    "623523": 48,
    "623525": 48,
    "623526": 48,
    "623529": 48,
    "623530": 48,
    "623532": 48,
    "623533": 48,
    "623534": 48,
    "623536": 48,
    "623538": 48,
    "623539": 48,
    "623544": 48,
    "623566": 48,
    "623603": 48,
    "623604": 48,
    "623605": 48,
    "623701": 48,
    "623704": 48,
    "623705": 48,
    "623707": 48,
    "623708": 48,
    "623711": 48,
    "623712": 48,
    "623719": 48,
    "623801": 48,
    "623802": 48,
    "623804": 48,
    "623806": 48,
    "623807": 48,
    "623808": 48,
    "624001": 48,
    "624002": 48,
    "624003": 48,
    "624004": 48,
    "624005": 48,
    "624006": 48,
    "624007": 48,
    "624008": 48,
    "624009": 48,
    "624010": 48,
    "624054": 48,
    "624101": 96,
    "624102": 96,
    "624103": 96,
    "624201": 48,
    "624202": 48,
    "624204": 48,
    "624206": 48,
    "624208": 48,
    "624211": 48,
    "624212": 48,
    "624213": 48,
    "624215": 48,
    "624216": 48,
    "624219": 48,
    "624220": 48,
    "624224": 48,
    "624228": 48,
    "624301": 48,
    "624302": 48,
    "624304": 48,
    "624306": 48,
    "624307": 48,
    "624308": 48,
    "624312": 48,
    "624314": 48,
    "624316": 48,
    "624401": 48,
    "624402": 48,
    "624403": 48,
    "624404": 48,
    "624601": 48,
    "624610": 48,
    "624612": 48,
    "624614": 48,
    "624615": 48,
    "624616": 48,
    "624619": 48,
    "624620": 48,
    "624622": 48,
    "624624": 48,
    "624701": 48,
    "624702": 48,
    "624703": 48,
    "624704": 48,
    "624705": 48,
    "624706": 48,
    "624707": 48,
    "624708": 48,
    "624709": 48,
    "624710": 48,
    "624711": 48,
    "624712": 48,
    "624714": 48,
    "624771": 48,
    "624801": 48,
    "624802": 48,
    "624803": 48,
    "624881": 48,
    "624885": 48,
    "624890": 48,
    "625001": 48,
    "625002": 48,
    "625003": 48,
    "625004": 48,
    "625005": 48,
    "625006": 48,
    "625007": 48,
    "625008": 48,
    "625009": 48,
    "625010": 48,
    "625011": 48,
    "625012": 48,
    "625013": 48,
    "625014": 48,
    "625015": 48,
    "625016": 48,
    "625017": 48,
    "625018": 48,
    "625019": 48,
    "625020": 48,
    "625021": 48,
    "625022": 48,
    "625023": 48,
    "625104": 48,
    "625106": 48,
    "625107": 48,
    "625122": 48,
    "625209": 48,
    "625217": 48,
    "625218": 48,
    "625221": 48,
    "625234": 48,
    "625301": 48,
    "625401": 48,
    "625402": 48,
    "625501": 48,
    "625502": 48,
    "625503": 48,
    "625512": 48,
    "625513": 48,
    "625514": 48,
    "625515": 48,
    "625516": 48,
    "625518": 48,
    "625521": 48,
    "625522": 48,
    "625524": 48,
    "625525": 48,
    "625526": 48,
    "625528": 48,
    "625529": 48,
    "625530": 48,
    "625531": 48,
    "625532": 48,
    "625533": 48,
    "625534": 48,
    "625535": 48,
    "625536": 48,
    "625537": 48,
    "625547": 48,
    "625552": 48,
    "625556": 48,
    "625566": 48,
    "625572": 48,
    "625589": 48,
    "625621": 48,
    "625701": 48,
    "625702": 48,
    "625703": 48,
    "625704": 48,
    "625705": 48,
    "625706": 48,
    "625707": 48,
    "625708": 48,
    "626001": 48,
    "626002": 48,
    "626003": 48,
    "626004": 48,
    "626005": 48,
    "626008": 48,
    "626053": 48,
    "626100": 48,
    "626101": 48,
    "626102": 48,
    "626103": 48,
    "626105": 48,
    "626107": 48,
    "626109": 48,
    "626110": 48,
    "626112": 48,
    "626114": 48,
    "626116": 48,
    "626117": 48,
    "626119": 48,
    "626123": 48,
    "626124": 48,
    "626125": 48,
    "626126": 48,
    "626128": 48,
    "626130": 48,
    "626132": 48,
    "626135": 48,
    "626138": 48,
    "626141": 48,
    "626143": 48,
    "626149": 48,
    "626150": 48,
    "626154": 48,
    "626159": 48,
    "626169": 48,
    "626188": 48,
    "626189": 48,
    "626190": 48,
    "626202": 48,
    "626203": 48,
    "626204": 48,
    "626881": 48,
    "627001": 48,
    "627002": 48,
    "627003": 48,
    "627004": 48,
    "627005": 48,
    "627006": 48,
    "627007": 48,
    "627008": 48,
    "627009": 48,
    "627010": 48,
    "627011": 48,
    "627012": 48,
    "627051": 48,
    "627105": 48,
    "627109": 48,
    "627116": 48,
    "627117": 48,
    "627131": 48,
    "627151": 48,
    "627152": 48,
    "627201": 48,
    "627252": 48,
    "627351": 48,
    "627352": 48,
    "627353": 48,
    "627356": 48,
    "627357": 48,
    "627358": 48,
    "627359": 48,
    "627361": 48,
    "627401": 48,
    "627412": 48,
    "627413": 48,
    "627414": 48,
    "627415": 48,
    "627416": 48,
    "627417": 48,
    "627418": 48,
    "627420": 48,
    "627421": 48,
    "627422": 48,
    "627423": 48,
    "627424": 48,
    "627425": 48,
    "627426": 48,
    "627427": 48,
    "627428": 48,
    "627431": 48,
    "627435": 48,
    "627436": 48,
    "627451": 48,
    "627452": 48,
    "627453": 48,
    "627551": 48,
    "627601": 48,
    "627602": 48,
    "627603": 48,
    "627604": 48,
    "627659": 48,
    "627719": 48,
    "627724": 48,
    "627751": 48,
    "627753": 48,
    "627754": 48,
    "627755": 48,
    "627756": 48,
    "627758": 48,
    "627759": 48,
    "627760": 48,
    "627761": 48,
    "627764": 48,
    "627765": 48,
    "627773": 48,
    "627778": 48,
    "627802": 48,
    "627803": 48,
    "627804": 48,
    "627805": 48,
    "627806": 48,
    "627807": 48,
    "627808": 48,
    "627809": 48,
    "627810": 48,
    "627811": 48,
    "627812": 48,
    "627813": 48,
    "627814": 48,
    "627817": 48,
    "627818": 48,
    "627821": 48,
    "627851": 48,
    "627852": 48,
    "627855": 48,
    "627856": 48,
    "627858": 48,
    "627859": 48,
    "627862": 48,
    "627907": 48,
    "627909": 48,
    "627953": 48,
    "627956": 48,
    "628001": 48,
    "628002": 48,
    "628003": 48,
    "628004": 48,
    "628005": 48,
    "628006": 48,
    "628007": 48,
    "628008": 48,
    "628101": 48,
    "628102": 48,
    "628103": 48,
    "628105": 48,
    "628151": 48,
    "628152": 48,
    "628155": 48,
    "628202": 48,
    "628203": 48,
    "628204": 48,
    "628215": 48,
    "628223": 48,
    "628251": 48,
    "628252": 48,
    "628253": 48,
    "628303": 48,
    "628304": 48,
    "628313": 48,
    "628501": 48,
    "628502": 48,
    "628552": 48,
    "628616": 48,
    "628617": 48,
    "628722": 48,
    "628801": 48,
    "628809": 48,
    "628851": 48,
    "628907": 48,
    "629001": 96,
    "629002": 96,
    "629003": 96,
    "629004": 96,
    "629051": 96,
    "629058": 48,
    "629151": 48,
    "629153": 48,
    "629154": 96,
    "629157": 48,
    "629160": 96,
    "629163": 48,
    "629165": 48,
    "629167": 96,
    "629171": 96,
    "629172": 96,
    "629174": 96,
    "629175": 96,
    "629176": 96,
    "629177": 48,
    "629180": 96,
    "629187": 48,
    "629190": 48,
    "629191": 48,
    "629194": 48,
    "629195": 48,
    "629251": 96,
    "629252": 96,
    "629302": 96,
    "629303": 96,
    "629305": 96,
    "629401": 96,
    "629402": 96,
    "629403": 96,
    "629501": 96,
    "629502": 96,
    "629504": 96,
    "629551": 96,
    "629601": 96,
    "629602": 96,
    "629603": 96,
    "629701": 96,
    "629702": 96,
    "629703": 96,
    "629708": 96,
    "629801": 96,
    "629802": 96,
    "629805": 96,
    "629806": 96,
    "629807": 96,
    "629852": 96,
    "629854": 96,
    "629901": 96,
    "629902": 96,
    "630001": 48,
    "630002": 48,
    "630003": 48,
    "630004": 48,
    "630005": 48,
    "630006": 48,
    "630010": 48,
    "630101": 48,
    "630102": 48,
    "630103": 48,
    "630104": 48,
    "630106": 48,
    "630107": 48,
    "630108": 48,
    "630202": 48,
    "630206": 48,
    "630207": 48,
    "630208": 48,
    "630211": 48,
    "630214": 48,
    "630301": 48,
    "630302": 48,
    "630303": 48,
    "630306": 48,
    "630307": 48,
    "630311": 48,
    "630312": 48,
    "630314": 48,
    "630317": 48,
    "630318": 48,
    "630407": 48,
    "630409": 48,
    "630411": 48,
    "630551": 48,
    "630552": 48,
    "630555": 48,
    "630556": 48,
    "630557": 48,
    "630558": 48,
    "630560": 48,
    "630561": 48,
    "630562": 48,
    "630605": 48,
    "630606": 48,
    "630611": 48,
    "630702": 48,
    "630709": 48,
    "631001": 48,
    "631002": 48,
    "631003": 48,
    "631005": 48,
    "631006": 48,
    "631051": 48,
    "631102": 96,
    "631122": 48,
    "631151": 48,
    "631202": 48,
    "631203": 48,
    "631207": 48,
    "631208": 48,
    "631209": 48,
    "631301": 96,
    "631302": 96,
    "631303": 96,
    "631402": 48,
    "631501": 24,
    "631502": 24,
    "631503": 24,
    "631561": 48,
    "631601": 48,
    "631604": 24,
    "631605": 48,
    "631701": 48,
    "632001": 48,
    "632002": 48,
    "632003": 48,
    "632004": 48,
    "632005": 48,
    "632006": 48,
    "632007": 48,
    "632008": 48,
    "632009": 48,
    "632010": 48,
    "632011": 48,
    "632012": 48,
    "632013": 48,
    "632014": 48,
    "632055": 48,
    "632057": 48,
    "632058": 48,
    "632059": 48,
    "632101": 48,
    "632102": 48,
    "632104": 48,
    "632105": 48,
    "632106": 48,
    "632107": 96,
    "632113": 48,
    "632114": 48,
    "632115": 48,
    "632116": 48,
    "632201": 48,
    "632202": 48,
    "632203": 48,
    "632204": 48,
    "632209": 96,
    "632301": 48,
    "632311": 48,
    "632312": 48,
    "632314": 48,
    "632315": 48,
    "632316": 48,
    "632317": 48,
    "632318": 48,
    "632319": 48,
    "632320": 48,
    "632326": 48,
    "632401": 48,
    "632402": 48,
    "632403": 48,
    "632404": 48,
    "632405": 48,
    "632406": 48,
    "632408": 48,
    "632416": 48,
    "632442": 48,
    "632501": 48,
    "632503": 48,
    "632504": 48,
    "632505": 96,
    "632506": 48,
    "632507": 48,
    "632508": 48,
    "632509": 48,
    "632512": 48,
    "632513": 48,
    "632514": 48,
    "632515": 48,
    "632516": 48,
    "632517": 48,
    "632519": 48,
    "632520": 48,
    "632521": 48,
    "632524": 48,
    "632601": 96,
    "632602": 48,
    "632603": 96,
    "632604": 96,
    "632605": 48,
    "635001": 48,
    "635002": 48,
    "635101": 48,
    "635103": 24,
    "635104": 48,
    "635108": 48,
    "635109": 24,
    "635110": 24,
    "635111": 48,
    "635112": 48,
    "635113": 48,
    "635114": 24,
    "635115": 48,
    "635117": 48,
    "635119": 48,
    "635120": 48,
    "635123": 48,
    "635124": 48,
    "635125": 24,
    "635126": 24,
    "635201": 48,
    "635202": 48,
    "635203": 48,
    "635204": 48,
    "635206": 48,
    "635208": 48,
    "635301": 48,
    "635302": 48,
    "635303": 48,
    "635304": 48,
    "635305": 48,
    "635313": 48,
    "635601": 96,
    "635602": 96,
    "635701": 96,
    "635702": 96,
    "635710": 96,
    "635751": 48,
    "635752": 96,
    "635754": 96,
    "635801": 96,
    "635802": 48,
    "635803": 48,
    "635804": 96,
    "635805": 48,
    "635806": 96,
    "635807": 96,
    "635808": 48,
    "635809": 96,
    "635810": 48,
    "635811": 48,
    "635813": 96,
    "635814": 48,
    "635815": 96,
    "635851": 96,
    "635852": 96,
    "636001": 48,
    "636002": 48,
    "636003": 48,
    "636004": 48,
    "636005": 48,
    "636006": 48,
    "636007": 48,
    "636008": 48,
    "636009": 48,
    "636010": 48,
    "636011": 48,
    "636012": 48,
    "636013": 48,
    "636014": 48,
    "636015": 48,
    "636016": 48,
    "636017": 48,
    "636030": 48,
    "636101": 48,
    "636102": 48,
    "636103": 48,
    "636104": 48,
    "636105": 48,
    "636106": 48,
    "636107": 48,
    "636108": 48,
    "636109": 48,
    "636110": 48,
    "636111": 48,
    "636112": 48,
    "636113": 48,
    "636114": 48,
    "636115": 48,
    "636116": 48,
    "636117": 48,
    "636118": 48,
    "636119": 48,
    "636121": 48,
    "636122": 48,
    "636124": 48,
    "636130": 48,
    "636138": 48,
    "636139": 48,
    "636140": 48,
    "636141": 48,
    "636142": 48,
    "636201": 48,
    "636202": 48,
    "636203": 48,
    "636204": 48,
    "636301": 48,
    "636302": 48,
    "636304": 48,
    "636307": 48,
    "636308": 48,
    "636309": 48,
    "636354": 48,
    "636400": 48,
    "636401": 48,
    "636402": 48,
    "636403": 48,
    "636404": 48,
    "636407": 48,
    "636453": 48,
    "636455": 48,
    "636502": 48,
    "636601": 48,
    "636602": 48,
    "636604": 48,
    "636701": 48,
    "636702": 48,
    "636703": 48,
    "636704": 48,
    "636705": 48,
    "636801": 48,
    "636802": 48,
    "636803": 48,
    "636805": 48,
    "636806": 48,
    "636808": 48,
    "636809": 48,
    "636810": 48,
    "636813": 48,
    "636905": 48,
    "637001": 48,
    "637002": 48,
    "637003": 48,
    "637013": 48,
    "637014": 48,
    "637018": 48,
    "637101": 48,
    "637102": 48,
    "637103": 48,
    "637104": 48,
    "637105": 48,
    "637209": 48,
    "637211": 48,
    "637215": 48,
    "637301": 48,
    "637302": 48,
    "637303": 48,
    "637401": 48,
    "637402": 48,
    "637403": 48,
    "637406": 48,
    "637407": 48,
    "637408": 48,
    "637410": 48,
    "637411": 48,
    "637412": 48,
    "637501": 48,
    "637502": 48,
    "637503": 48,
    "637504": 48,
    "637505": 48,
    "638001": 48,
    "638002": 48,
    "638003": 48,
    "638004": 48,
    "638005": 48,
    "638006": 48,
    "638007": 48,
    "638008": 48,
    "638009": 48,
    "638010": 48,
    "638011": 48,
    "638012": 48,
    "638051": 48,
    "638052": 48,
    "638053": 48,
    "638054": 48,
    "638056": 48,
    "638058": 48,
    "638101": 48,
    "638102": 48,
    "638103": 48,
    "638104": 48,
    "638105": 48,
    "638106": 48,
    "638107": 48,
    "638108": 48,
    "638111": 48,
    "638112": 48,
    "638115": 48,
    "638153": 48,
    "638154": 48,
    "638182": 48,
    "638183": 48,
    "638201": 48,
    "638301": 48,
    "638302": 48,
    "638307": 48,
    "638308": 48,
    "638311": 48,
    "638312": 48,
    "638314": 48,
    "638315": 48,
    "638316": 48,
    "638327": 48,
    "638401": 96,
    "638402": 96,
    "638451": 96,
    "638452": 48,
    "638455": 48,
    "638458": 48,
    "638476": 48,
    "638501": 48,
    "638502": 48,
    "638503": 96,
    "638504": 48,
    "638649": 48,
    "638653": 48,
    "638656": 48,
    "638657": 48,
    "638660": 48,
    "638661": 48,
    "638672": 48,
    "638673": 48,
    "638697": 48,
    "638701": 48,
    "638702": 48,
    "638703": 48,
    "638706": 48,
    "639001": 48,
    "639002": 48,
    "639003": 48,
    "639004": 48,
    "639005": 48,
    "639006": 48,
    "639007": 48,
    "639008": 48,
    "639101": 96,
    "639103": 48,
    "639104": 48,
    "639105": 48,
    "639107": 48,
    "639109": 48,
    "639110": 48,
    "639111": 48,
    "639112": 48,
    "639114": 48,
    "639117": 48,
    "639118": 48,
    "639136": 48,
    "639201": 48,
    "639202": 48,
    "639203": 48,
    "639204": 48,
    "639205": 48,
    "639207": 48,
    "641001": 48,
    "641002": 48,
    "641003": 48,
    "641004": 48,
    "641005": 48,
    "641006": 48,
    "641007": 48,
    "641008": 48,
    "641009": 48,
    "641010": 48,
    "641011": 48,
    "641012": 48,
    "641013": 48,
    "641014": 48,
    "641015": 48,
    "641016": 48,
    "641017": 48,
    "641018": 48,
    "641019": 48,
    "641020": 48,
    "641021": 48,
    "641022": 48,
    "641023": 48,
    "641024": 48,
    "641025": 48,
    "641026": 48,
    "641027": 48,
    "641028": 48,
    "641029": 48,
    "641030": 48,
    "641031": 48,
    "641032": 48,
    "641033": 48,
    "641034": 48,
    "641035": 48,
    "641036": 48,
    "641037": 48,
    "641038": 48,
    "641039": 48,
    "641040": 48,
    "641041": 48,
    "641042": 48,
    "641043": 48,
    "641044": 48,
    "641045": 48,
    "641046": 48,
    "641047": 48,
    "641048": 48,
    "641049": 48,
    "641050": 48,
    "641062": 48,
    "641065": 48,
    "641101": 48,
    "641103": 48,
    "641104": 48,
    "641105": 48,
    "641106": 48,
    "641107": 48,
    "641108": 48,
    "641109": 48,
    "641110": 48,
    "641111": 48,
    "641112": 48,
    "641113": 48,
    "641114": 48,
    "641201": 48,
    "641202": 48,
    "641221": 48,
    "641301": 48,
    "641305": 48,
    "641401": 48,
    "641402": 48,
    "641404": 48,
    "641406": 48,
    "641407": 48,
    "641601": 48,
    "641602": 48,
    "641603": 48,
    "641604": 48,
    "641605": 48,
    "641606": 48,
    "641607": 48,
    "641608": 48,
    "641652": 48,
    "641653": 48,
    "641654": 48,
    "641655": 48,
    "641659": 48,
    "641662": 48,
    "641663": 48,
    "641664": 48,
    "641665": 48,
    "641666": 48,
    "641667": 48,
    "641668": 48,
    "641670": 48,
    "641671": 48,
    "641687": 48,
    "642001": 48,
    "642002": 48,
    "642003": 48,
    "642004": 48,
    "642005": 48,
    "642006": 48,
    "642007": 48,
    "642054": 48,
    "642101": 48,
    "642103": 48,
    "642104": 48,
    "642105": 96,
    "642106": 48,
    "642107": 48,
    "642108": 96,
    "642109": 48,
    "642110": 48,
    "642114": 48,
    "642117": 96,
    "642120": 48,
    "642123": 48,
    "642126": 48,
    "642127": 96,
    "642129": 48,
    "642130": 48,
    "642133": 48,
    "642134": 48,
    "642140": 48,
    "642142": 48,
    "642143": 48,
    "642144": 48,
    "642145": 48,
    "642147": 48,
    "642148": 48,
    "642149": 48,
    "642154": 48,
    "642202": 48,
    "642207": 48,
    "643001": 48,
    "643002": 48,
    "643003": 48,
    "643004": 48,
    "643053": 48,
    "643054": 48,
    "643101": 48,
    "643102": 48,
    "643103": 48,
    "643104": 48,
    "643105": 48,
    "643106": 48,
    "643201": 48,
    "643202": 48,
    "643204": 48,
    "643207": 96,
    "643211": 96,
    "643212": 96,
    "643213": 48,
    "643214": 48,
    "643216": 48,
    "643217": 48,
    "643218": 48,
    "643231": 48,
    "643232": 48,
    "643234": 48,
    "643242": 48,
    "643244": 48,
    "643245": 48,
    "643249": 48,
    "643251": 96,
    "643257": 48,
    "643260": 48,
    "643264": 48,
    "643266": 48,
    "643267": 96,
    "643270": 96,
    "643271": 48,
    "643277": 48,
    "643278": 48,
    "666664": 24,
    "666666": 24,
    "666677": 24,
    "666688": 24,
    "666699": 24,
    "670001": 48,
    "670002": 48,
    "670003": 48,
    "670004": 48,
    "670005": 48,
    "670006": 48,
    "670007": 48,
    "670008": 48,
    "670010": 48,
    "670011": 48,
    "670012": 48,
    "670013": 48,
    "670014": 48,
    "670015": 48,
    "670016": 48,
    "670017": 48,
    "670018": 48,
    "670101": 48,
    "670102": 48,
    "670104": 48,
    "670105": 48,
    "670106": 48,
    "670141": 48,
    "670301": 48,
    "670307": 48,
    "670501": 48,
    "670561": 48,
    "670565": 48,
    "670566": 48,
    "670567": 48,
    "670591": 48,
    "670592": 48,
    "670594": 48,
    "670597": 48,
    "670642": 96,
    "670643": 96,
    "670691": 96,
    "670694": 48,
    "670701": 96,
    "670741": 96,
    "671121": 96,
    "671122": 96,
    "671123": 96,
    "671315": 96,
    "671317": 96,
    "671319": 96,
    "671531": 96,
    "673001": 48,
    "673002": 48,
    "673003": 48,
    "673004": 48,
    "673005": 48,
    "673006": 48,
    "673007": 48,
    "673008": 48,
    "673009": 48,
    "673010": 48,
    "673011": 48,
    "673012": 48,
    "673013": 48,
    "673014": 48,
    "673015": 48,
    "673016": 48,
    "673017": 48,
    "673018": 48,
    "673019": 48,
    "673020": 48,
    "673021": 48,
    "673024": 48,
    "673025": 48,
    "673026": 48,
    "673027": 48,
    "673028": 48,
    "673029": 48,
    "673031": 48,
    "673032": 48,
    "673037": 48,
    "673101": 48,
    "673103": 48,
    "673104": 48,
    "673106": 48,
    "673303": 48,
    "673304": 48,
    "673305": 48,
    "673306": 48,
    "673315": 48,
    "673317": 48,
    "673323": 48,
    "673507": 48,
    "673508": 48,
    "673570": 48,
    "673585": 48,
    "673601": 48,
    "673602": 96,
    "673611": 48,
    "673613": 48,
    "673614": 48,
    "673616": 48,
    "673620": 48,
    "673632": 48,
    "673633": 48,
    "673634": 48,
    "673635": 48,
    "673639": 96,
    "673640": 96,
    "673641": 96,
    "673645": 96,
    "676101": 48,
    "676102": 48,
    "676103": 48,
    "676104": 48,
    "676105": 48,
    "676107": 48,
    "676108": 48,
    "676109": 48,
    "676121": 96,
    "676301": 96,
    "676502": 48,
    "676503": 48,
    "676505": 96,
    "676541": 96,
    "676551": 96,
    "676552": 96,
    "676561": 48,
    "676562": 48,
    "678001": 48,
    "678002": 48,
    "678003": 48,
    "678004": 48,
    "678005": 48,
    "678006": 48,
    "678007": 48,
    "678008": 48,
    "678009": 48,
    "678010": 48,
    "678011": 48,
    "678012": 48,
    "678013": 48,
    "678014": 48,
    "678015": 48,
    "678017": 48,
    "678018": 48,
    "678019": 48,
    "678020": 48,
    "678101": 96,
    "678102": 96,
    "678103": 96,
    "678104": 96,
    "678501": 96,
    "678503": 96,
    "678504": 96,
    "678506": 96,
    "678531": 96,
    "678532": 96,
    "678541": 96,
    "678542": 96,
    "678543": 96,
    "678545": 96,
    "678546": 96,
    "678551": 48,
    "678552": 96,
    "678553": 96,
    "678554": 96,
    "678557": 48,
    "678559": 48,
    "678582": 96,
    "678583": 96,
    "678593": 96,
    "678595": 96,
    "678596": 96,
    "678597": 96,
    "678598": 96,
    "678613": 96,
    "678621": 48,
    "678623": 48,
    "678633": 96,
    "678642": 96,
    "678681": 96,
    "678701": 48,
    "678731": 48,
    "678762": 96,
    "679101": 96,
    "679102": 96,
    "679103": 96,
    "679104": 96,
    "679105": 96,
    "679106": 96,
    "679121": 96,
    "679122": 96,
    "679123": 96,
    "679301": 96,
    "679302": 96,
    "679304": 96,
    "679306": 96,
    "679308": 96,
    "679313": 96,
    "679321": 48,
    "679322": 48,
    "679328": 96,
    "679329": 96,
    "679335": 96,
    "679340": 48,
    "679357": 48,
    "679501": 96,
    "679502": 96,
    "679503": 96,
    "679504": 96,
    "679505": 96,
    "679506": 96,
    "679511": 96,
    "679512": 96,
    "679513": 96,
    "679514": 96,
    "679515": 96,
    "679516": 96,
    "679521": 96,
    "679522": 96,
    "679523": 96,
    "679531": 96,
    "679551": 48,
    "679552": 48,
    "679553": 48,
    "679554": 48,
    "679564": 120,
    "679571": 96,
    "679572": 96,
    "679574": 48,
    "679576": 48,
    "679577": 48,
    "679578": 48,
    "679582": 48,
    "679583": 48,
    "679585": 48,
    "679586": 48,
    "680001": 48,
    "680002": 48,
    "680003": 48,
    "680004": 48,
    "680005": 48,
    "680006": 48,
    "680007": 96,
    "680008": 48,
    "680009": 48,
    "680010": 48,
    "680011": 48,
    "680012": 48,
    "680013": 96,
    "680014": 96,
    "680015": 96,
    "680018": 48,
    "680020": 48,
    "680021": 48,
    "680022": 48,
    "680026": 96,
    "680027": 96,
    "680101": 120,
    "680121": 96,
    "680125": 96,
    "680301": 48,
    "680302": 48,
    "680303": 48,
    "680305": 48,
    "680306": 48,
    "680307": 48,
    "680308": 48,
    "680309": 48,
    "680310": 96,
    "680311": 48,
    "680313": 48,
    "680314": 48,
    "680322": 48,
    "680501": 96,
    "680506": 120,
    "680507": 120,
    "680516": 120,
    "680518": 120,
    "680522": 120,
    "680541": 96,
    "680545": 96,
    "680546": 120,
    "680551": 96,
    "680552": 120,
    "680553": 48,
    "680555": 96,
    "680562": 96,
    "680563": 96,
    "680566": 120,
    "680567": 120,
    "680568": 120,
    "680569": 120,
    "680581": 96,
    "680588": 96,
    "680594": 96,
    "680611": 48,
    "680618": 48,
    "680620": 48,
    "680631": 48,
    "680641": 96,
    "680663": 48,
    "680664": 48,
    "680666": 48,
    "680667": 48,
    "680669": 48,
    "680670": 48,
    "680671": 48,
    "680682": 48,
    "680683": 48,
    "680689": 48,
    "680697": 48,
    "680699": 48,
    "680711": 96,
    "680712": 96,
    "680731": 48,
    "680732": 48,
    "680733": 48,
    "680734": 48,
    "680741": 48,
    "682000": 96,
    "682001": 48,
    "682002": 48,
    "682003": 48,
    "682005": 48,
    "682006": 48,
    "682007": 48,
    "682008": 48,
    "682009": 48,
    "682010": 48,
    "682011": 48,
    "682012": 48,
    "682013": 48,
    "682014": 48,
    "682015": 48,
    "682016": 48,
    "682017": 96,
    "682018": 48,
    "682019": 96,
    "682020": 96,
    "682021": 48,
    "682022": 48,
    "682023": 48,
    "682024": 48,
    "682025": 96,
    "682026": 48,
    "682027": 48,
    "682028": 96,
    "682029": 48,
    "682030": 48,
    "682031": 48,
    "682032": 96,
    "682033": 48,
    "682034": 48,
    "682035": 48,
    "682036": 96,
    "682037": 48,
    "682038": 120,
    "682039": 48,
    "682040": 96,
    "682041": 48,
    "682042": 48,
    "682222": 48,
    "682301": 48,
    "682302": 48,
    "682303": 48,
    "682304": 120,
    "682305": 48,
    "682306": 96,
    "682307": 48,
    "682308": 48,
    "682309": 48,
    "682310": 48,
    "682311": 48,
    "682312": 48,
    "682313": 48,
    "682314": 48,
    "682315": 48,
    "682316": 96,
    "682319": 48,
    "682501": 48,
    "682502": 48,
    "682503": 48,
    "682504": 48,
    "682505": 48,
    "682506": 96,
    "682507": 48,
    "682508": 48,
    "682509": 48,
    "682511": 48,
    "683101": 48,
    "683102": 48,
    "683103": 48,
    "683104": 48,
    "683105": 48,
    "683106": 48,
    "683108": 48,
    "683109": 48,
    "683110": 48,
    "683111": 48,
    "683112": 48,
    "683501": 48,
    "683502": 48,
    "683511": 48,
    "683512": 48,
    "683513": 48,
    "683517": 48,
    "683518": 48,
    "683519": 48,
    "683520": 48,
    "683541": 48,
    "683542": 48,
    "683543": 48,
    "683544": 48,
    "683556": 48,
    "683561": 48,
    "683562": 48,
    "683563": 48,
    "683564": 48,
    "683572": 48,
    "683573": 48,
    "683574": 48,
    "683576": 48,
    "683577": 48,
    "683578": 48,
    "683579": 48,
    "683582": 48,
    "683584": 48,
    "683585": 48,
    "683586": 48,
    "683587": 48,
    "683589": 48,
    "683591": 48,
    "683592": 48,
    "683594": 48,
    "685584": 96,
    "685585": 96,
    "685587": 96,
    "685605": 96,
    "685608": 96,
    "686001": 48,
    "686002": 48,
    "686003": 48,
    "686004": 48,
    "686005": 48,
    "686006": 48,
    "686007": 48,
    "686008": 48,
    "686009": 48,
    "686010": 48,
    "686011": 48,
    "686012": 48,
    "686013": 48,
    "686014": 48,
    "686015": 48,
    "686016": 48,
    "686017": 48,
    "686018": 48,
    "686019": 48,
    "686020": 48,
    "686021": 96,
    "686022": 48,
    "686023": 48,
    "686024": 48,
    "686025": 48,
    "686026": 48,
    "686029": 48,
    "686030": 48,
    "686032": 48,
    "686033": 48,
    "686035": 48,
    "686036": 48,
    "686037": 48,
    "686038": 48,
    "686039": 48,
    "686041": 48,
    "686101": 96,
    "686102": 96,
    "686103": 96,
    "686104": 96,
    "686105": 96,
    "686106": 96,
    "686107": 96,
    "686121": 48,
    "686141": 96,
    "686501": 48,
    "686503": 48,
    "686504": 48,
    "686505": 48,
    "686506": 48,
    "686507": 48,
    "686508": 48,
    "686509": 48,
    "686512": 48,
    "686515": 48,
    "686517": 48,
    "686518": 48,
    "686519": 48,
    "686521": 96,
    "686522": 48,
    "686531": 48,
    "686536": 96,
    "686539": 96,
    "686540": 96,
    "686541": 96,
    "686542": 96,
    "686545": 96,
    "686546": 96,
    "686552": 48,
    "686560": 48,
    "686561": 48,
    "686562": 96,
    "686572": 96,
    "686573": 48,
    "686574": 48,
    "686575": 48,
    "686576": 48,
    "686578": 48,
    "686583": 96,
    "686585": 48,
    "686587": 96,
    "686601": 96,
    "686602": 96,
    "686603": 96,
    "686604": 96,
    "686605": 96,
    "686609": 96,
    "686610": 96,
    "686611": 96,
    "686612": 96,
    "686613": 96,
    "686616": 96,
    "686619": 48,
    "686630": 96,
    "686631": 96,
    "686632": 96,
    "686633": 96,
    "686634": 48,
    "686636": 48,
    "686637": 96,
    "686661": 96,
    "686662": 48,
    "686663": 48,
    "686664": 48,
    "686665": 48,
    "686666": 96,
    "686667": 48,
    "686669": 96,
    "686674": 96,
    "686676": 96,
    "686677": 96,
    "686680": 48,
    "686689": 96,
    "688001": 48,
    "688002": 48,
    "688003": 48,
    "688004": 48,
    "688005": 48,
    "688006": 48,
    "688007": 48,
    "688008": 48,
    "688009": 48,
    "688010": 48,
    "688011": 48,
    "688012": 48,
    "688013": 48,
    "688014": 48,
    "688521": 48,
    "688522": 48,
    "688523": 48,
    "688524": 48,
    "688525": 48,
    "688526": 48,
    "688527": 48,
    "688528": 48,
    "688529": 48,
    "688530": 48,
    "688531": 48,
    "688532": 48,
    "688533": 48,
    "688534": 96,
    "688536": 48,
    "688538": 48,
    "688539": 48,
    "688540": 48,
    "688541": 48,
    "688542": 48,
    "688543": 48,
    "688544": 48,
    "688545": 48,
    "688546": 48,
    "688549": 48,
    "688554": 48,
    "688555": 48,
    "688561": 48,
    "688562": 48,
    "688564": 48,
    "688565": 48,
    "688582": 48,
    "688583": 48,
    "689101": 96,
    "689102": 96,
    "689103": 96,
    "689104": 96,
    "689105": 96,
    "689106": 96,
    "689107": 96,
    "689108": 96,
    "689109": 96,
    "689110": 96,
    "689111": 96,
    "689112": 96,
    "689113": 96,
    "689115": 96,
    "689121": 96,
    "689122": 96,
    "689123": 96,
    "689124": 96,
    "689126": 96,
    "689501": 96,
    "689502": 96,
    "689504": 96,
    "689505": 96,
    "689506": 96,
    "689508": 96,
    "689509": 96,
    "689510": 96,
    "689511": 48,
    "689512": 96,
    "689513": 96,
    "689520": 96,
    "689542": 96,
    "689543": 96,
    "689544": 96,
    "689546": 96,
    "689547": 96,
    "689549": 96,
    "689550": 96,
    "689551": 96,
    "689572": 48,
    "689573": 48,
    "689584": 96,
    "689585": 96,
    "689586": 96,
    "689587": 96,
    "689589": 96,
    "689591": 96,
    "689595": 48,
    "689597": 96,
    "689602": 96,
    "689621": 96,
    "689622": 48,
    "689624": 48,
    "689626": 96,
    "689641": 96,
    "689644": 96,
    "689645": 96,
    "689647": 96,
    "689648": 96,
    "689652": 96,
    "689653": 96,
    "689654": 96,
    "689661": 96,
    "689666": 96,
    "689668": 96,
    "689671": 96,
    "689678": 96,
    "690101": 48,
    "690102": 48,
    "690103": 48,
    "690104": 48,
    "690105": 48,
    "690106": 48,
    "690107": 48,
    "690108": 48,
    "690110": 48,
    "690502": 48,
    "690503": 48,
    "690506": 48,
    "690507": 48,
    "690510": 48,
    "690513": 48,
    "690514": 48,
    "690515": 48,
    "690516": 48,
    "690518": 96,
    "690519": 96,
    "690523": 96,
    "690524": 96,
    "690525": 96,
    "690526": 96,
    "690528": 96,
    "690531": 48,
    "690532": 48,
    "690533": 48,
    "690535": 48,
    "690536": 96,
    "690539": 96,
    "690542": 96,
    "690544": 96,
    "690546": 96,
    "690547": 96,
    "690552": 48,
    "690558": 48,
    "690570": 48,
    "690571": 48,
    "690572": 48,
    "690573": 96,
    "691001": 48,
    "691002": 48,
    "691003": 96,
    "691004": 48,
    "691005": 48,
    "691006": 48,
    "691007": 96,
    "691008": 48,
    "691009": 48,
    "691010": 48,
    "691011": 48,
    "691012": 96,
    "691013": 96,
    "691014": 48,
    "691015": 48,
    "691016": 48,
    "691017": 48,
    "691018": 48,
    "691019": 48,
    "691020": 48,
    "691021": 48,
    "691301": 96,
    "691302": 96,
    "691305": 96,
    "691306": 96,
    "691315": 96,
    "691318": 96,
    "691319": 96,
    "691320": 96,
    "691321": 96,
    "691324": 96,
    "691325": 96,
    "691331": 96,
    "691333": 96,
    "691378": 96,
    "691501": 96,
    "691504": 96,
    "691505": 96,
    "691506": 96,
    "691507": 96,
    "691511": 96,
    "691512": 96,
    "691523": 96,
    "691530": 96,
    "691531": 96,
    "691532": 96,
    "691533": 96,
    "691536": 96,
    "691538": 96,
    "691542": 96,
    "691557": 96,
    "691560": 96,
    "691566": 96,
    "691571": 48,
    "691574": 96,
    "691577": 48,
    "691581": 96,
    "691582": 96,
    "691583": 96,
    "691584": 96,
    "691588": 96,
    "691589": 48,
    "691590": 96,
    "691601": 96,
    "691602": 96,
    "691604": 96,
    "691605": 96,
    "694582": 96,
    "695001": 96,
    "695002": 96,
    "695003": 48,
    "695004": 48,
    "695005": 48,
    "695006": 96,
    "695007": 48,
    "695008": 96,
    "695009": 96,
    "695010": 96,
    "695011": 48,
    "695012": 96,
    "695013": 96,
    "695014": 96,
    "695015": 48,
    "695016": 48,
    "695017": 48,
    "695018": 96,
    "695019": 96,
    "695020": 96,
    "695021": 48,
    "695022": 48,
    "695023": 96,
    "695024": 48,
    "695025": 48,
    "695026": 96,
    "695027": 96,
    "695029": 48,
    "695030": 96,
    "695031": 48,
    "695032": 96,
    "695033": 96,
    "695034": 96,
    "695035": 96,
    "695036": 96,
    "695037": 48,
    "695038": 96,
    "695039": 96,
    "695040": 96,
    "695041": 96,
    "695042": 96,
    "695043": 48,
    "695044": 48,
    "695049": 96,
    "695099": 48,
    "695101": 96,
    "695102": 96,
    "695103": 96,
    "695104": 96,
    "695121": 96,
    "695122": 96,
    "695123": 96,
    "695124": 96,
    "695125": 96,
    "695126": 96,
    "695132": 96,
    "695133": 96,
    "695134": 96,
    "695141": 96,
    "695142": 96,
    "695143": 96,
    "695144": 96,
    "695145": 96,
    "695301": 48,
    "695302": 48,
    "695303": 48,
    "695304": 96,
    "695305": 48,
    "695306": 96,
    "695308": 96,
    "695311": 96,
    "695312": 96,
    "695316": 48,
    "695317": 48,
    "695318": 96,
    "695501": 96,
    "695502": 96,
    "695503": 96,
    "695504": 96,
    "695505": 96,
    "695506": 96,
    "695507": 96,
    "695508": 96,
    "695512": 96,
    "695513": 96,
    "695521": 96,
    "695522": 96,
    "695523": 96,
    "695525": 96,
    "695526": 96,
    "695527": 96,
    "695543": 96,
    "695571": 96,
    "695573": 96,
    "695575": 96,
    "695581": 48,
    "695582": 48,
    "695583": 48,
    "695584": 96,
    "695585": 48,
    "695586": 48,
    "695587": 96,
    "695588": 96,
    "695589": 96,
    "695601": 96,
    "695603": 96,
    "695606": 96,
    "695607": 96,
    "695608": 96,
    "695611": 96,
    "695612": 96,
    "695614": 96,
    "695615": 96,
    "700000": 24,
    "700001": 24,
    "700002": 24,
    "700003": 24,
    "700004": 24,
    "700005": 24,
    "700006": 24,
    "700007": 24,
    "700008": 24,
    "700009": 24,
    "700010": 24,
    "700011": 24,
    "700012": 24,
    "700013": 24,
    "700014": 24,
    "700015": 24,
    "700016": 24,
    "700017": 24,
    "700018": 24,
    "700019": 24,
    "700020": 24,
    "700021": 24,
    "700022": 24,
    "700023": 24,
    "700024": 24,
    "700025": 24,
    "700026": 24,
    "700027": 24,
    "700028": 24,
    "700029": 24,
    "700030": 24,
    "700031": 24,
    "700032": 24,
    "700033": 24,
    "700034": 24,
    "700035": 24,
    "700036": 24,
    "700037": 24,
    "700038": 24,
    "700039": 24,
    "700040": 24,
    "700041": 24,
    "700042": 24,
    "700043": 24,
    "700044": 24,
    "700045": 24,
    "700046": 24,
    "700047": 24,
    "700048": 24,
    "700049": 24,
    "700050": 24,
    "700051": 24,
    "700052": 24,
    "700053": 24,
    "700054": 24,
    "700055": 24,
    "700056": 24,
    "700057": 24,
    "700058": 24,
    "700059": 24,
    "700060": 24,
    "700061": 24,
    "700062": 24,
    "700063": 24,
    "700064": 24,
    "700065": 24,
    "700066": 24,
    "700067": 24,
    "700068": 24,
    "700069": 24,
    "700070": 24,
    "700071": 24,
    "700072": 24,
    "700073": 24,
    "700074": 24,
    "700075": 24,
    "700076": 24,
    "700077": 24,
    "700078": 24,
    "700079": 24,
    "700080": 24,
    "700081": 24,
    "700082": 24,
    "700083": 24,
    "700084": 24,
    "700085": 24,
    "700086": 24,
    "700087": 24,
    "700088": 24,
    "700089": 24,
    "700090": 24,
    "700091": 24,
    "700092": 24,
    "700093": 24,
    "700094": 24,
    "700095": 24,
    "700096": 24,
    "700097": 24,
    "700098": 24,
    "700099": 24,
    "700100": 24,
    "700101": 24,
    "700102": 24,
    "700103": 24,
    "700104": 48,
    "700105": 24,
    "700106": 24,
    "700107": 24,
    "700108": 24,
    "700109": 48,
    "700110": 48,
    "700111": 48,
    "700112": 48,
    "700113": 48,
    "700114": 48,
    "700115": 48,
    "700116": 48,
    "700117": 48,
    "700118": 48,
    "700119": 48,
    "700120": 48,
    "700121": 48,
    "700122": 48,
    "700123": 48,
    "700124": 24,
    "700125": 24,
    "700126": 24,
    "700127": 24,
    "700128": 24,
    "700129": 24,
    "700130": 24,
    "700131": 24,
    "700132": 24,
    "700133": 24,
    "700134": 24,
    "700135": 24,
    "700136": 24,
    "700137": 24,
    "700138": 24,
    "700139": 24,
    "700140": 24,
    "700141": 24,
    "700142": 24,
    "700143": 24,
    "700144": 24,
    "700145": 24,
    "700146": 24,
    "700147": 24,
    "700148": 24,
    "700149": 24,
    "700150": 24,
    "700151": 24,
    "700152": 24,
    "700153": 24,
    "700154": 24,
    "700155": 24,
    "700156": 24,
    "700157": 24,
    "700158": 24,
    "700159": 24,
    "700160": 24,
    "700161": 24,
    "700162": 24,
    "711101": 24,
    "711102": 24,
    "711103": 24,
    "711104": 24,
    "711105": 24,
    "711106": 24,
    "711107": 24,
    "711108": 24,
    "711109": 24,
    "711110": 24,
    "711111": 24,
    "711112": 24,
    "711113": 24,
    "711114": 24,
    "711115": 24,
    "711201": 24,
    "711202": 24,
    "711203": 24,
    "711204": 24,
    "711205": 24,
    "711206": 24,
    "711225": 48,
    "711226": 48,
    "711227": 24,
    "711301": 48,
    "711302": 24,
    "711303": 48,
    "711304": 24,
    "711305": 48,
    "711306": 48,
    "711307": 48,
    "711308": 48,
    "711309": 24,
    "711310": 48,
    "711312": 48,
    "711313": 24,
    "711314": 48,
    "711315": 48,
    "711316": 48,
    "711317": 24,
    "711320": 24,
    "711322": 48,
    "711401": 48,
    "711403": 24,
    "711404": 48,
    "711405": 24,
    "711408": 48,
    "711409": 24,
    "711410": 48,
    "711411": 24,
    "711412": 48,
    "711413": 48,
    "711414": 48,
    "712101": 48,
    "712102": 48,
    "712103": 48,
    "712104": 48,
    "712105": 48,
    "712121": 48,
    "712122": 48,
    "712123": 48,
    "712124": 48,
    "712125": 48,
    "712134": 48,
    "712135": 48,
    "712136": 48,
    "712137": 48,
    "712138": 48,
    "712139": 48,
    "712147": 48,
    "712148": 48,
    "712149": 48,
    "712152": 48,
    "712201": 48,
    "712202": 48,
    "712203": 48,
    "712204": 48,
    "712221": 48,
    "712222": 48,
    "712223": 48,
    "712232": 24,
    "712233": 24,
    "712234": 24,
    "712235": 24,
    "712245": 24,
    "712246": 24,
    "712247": 24,
    "712248": 48,
    "712249": 48,
    "712250": 48,
    "712258": 24,
    "712301": 48,
    "712302": 48,
    "712303": 48,
    "712304": 48,
    "712305": 48,
    "712306": 48,
    "712308": 48,
    "712310": 24,
    "712311": 24,
    "712344": 24,
    "712401": 48,
    "712402": 48,
    "712403": 48,
    "712404": 48,
    "712405": 48,
    "712406": 48,
    "712407": 48,
    "712409": 48,
    "712410": 48,
    "712412": 48,
    "712413": 48,
    "712414": 48,
    "712415": 48,
    "712416": 48,
    "712417": 48,
    "712502": 48,
    "712503": 48,
    "712504": 48,
    "712513": 48,
    "712514": 48,
    "712515": 48,
    "712601": 48,
    "712602": 48,
    "712611": 48,
    "712612": 48,
    "712613": 48,
    "712614": 48,
    "712615": 48,
    "712616": 48,
    "712617": 48,
    "712701": 24,
    "712702": 24,
    "712704": 24,
    "712706": 24,
    "713101": 48,
    "713102": 48,
    "713103": 48,
    "713104": 48,
    "713122": 48,
    "713123": 48,
    "713124": 48,
    "713125": 48,
    "713126": 48,
    "713127": 48,
    "713128": 48,
    "713129": 48,
    "713130": 48,
    "713131": 48,
    "713140": 48,
    "713141": 48,
    "713142": 48,
    "713143": 48,
    "713145": 48,
    "713146": 48,
    "713147": 48,
    "713148": 48,
    "713149": 48,
    "713150": 48,
    "713151": 48,
    "713154": 48,
    "713156": 48,
    "713158": 48,
    "713165": 48,
    "713166": 48,
    "713168": 48,
    "713173": 48,
    "713201": 48,
    "713202": 48,
    "713203": 48,
    "713204": 48,
    "713205": 48,
    "713206": 48,
    "713207": 48,
    "713208": 48,
    "713209": 48,
    "713210": 48,
    "713211": 48,
    "713212": 48,
    "713213": 48,
    "713214": 48,
    "713215": 48,
    "713216": 48,
    "713217": 48,
    "713218": 48,
    "713219": 48,
    "713301": 48,
    "713302": 48,
    "713303": 48,
    "713304": 48,
    "713305": 120,
    "713315": 48,
    "713321": 48,
    "713322": 48,
    "713323": 48,
    "713324": 48,
    "713325": 48,
    "713326": 48,
    "713330": 48,
    "713331": 48,
    "713332": 48,
    "713333": 48,
    "713334": 48,
    "713335": 48,
    "713336": 48,
    "713337": 48,
    "713338": 48,
    "713339": 48,
    "713340": 48,
    "713341": 48,
    "713342": 48,
    "713343": 48,
    "713347": 48,
    "713357": 48,
    "713358": 48,
    "713359": 48,
    "713360": 48,
    "713361": 48,
    "713362": 48,
    "713363": 48,
    "713365": 48,
    "713369": 48,
    "713371": 48,
    "713372": 48,
    "713373": 48,
    "713376": 48,
    "713378": 48,
    "713380": 48,
    "713384": 48,
    "713386": 48,
    "713401": 48,
    "713402": 48,
    "713403": 48,
    "713404": 48,
    "713405": 48,
    "713406": 48,
    "713407": 48,
    "713408": 48,
    "713409": 48,
    "713420": 48,
    "713422": 48,
    "713425": 48,
    "713426": 48,
    "713428": 48,
    "713429": 48,
    "713433": 48,
    "713502": 48,
    "713512": 48,
    "713513": 48,
    "713514": 48,
    "713515": 48,
    "713516": 48,
    "713517": 48,
    "713519": 48,
    "713520": 48,
    "721101": 48,
    "721121": 48,
    "721124": 48,
    "721126": 48,
    "721127": 48,
    "721128": 48,
    "721129": 48,
    "721130": 48,
    "721131": 48,
    "721132": 48,
    "721133": 48,
    "721134": 48,
    "721135": 48,
    "721136": 48,
    "721137": 48,
    "721139": 48,
    "721140": 48,
    "721144": 48,
    "721145": 48,
    "721146": 48,
    "721147": 48,
    "721148": 48,
    "721149": 48,
    "721150": 48,
    "721151": 48,
    "721152": 48,
    "721153": 48,
    "721154": 48,
    "721156": 48,
    "721157": 48,
    "721158": 48,
    "721159": 48,
    "721160": 48,
    "721166": 48,
    "721167": 48,
    "721168": 48,
    "721171": 48,
    "721172": 48,
    "721201": 48,
    "721211": 48,
    "721212": 48,
    "721222": 48,
    "721232": 48,
    "721253": 48,
    "721260": 48,
    "721301": 48,
    "721302": 48,
    "721303": 48,
    "721304": 48,
    "721305": 48,
    "721306": 48,
    "721401": 48,
    "721420": 48,
    "721422": 48,
    "721423": 48,
    "721424": 48,
    "721425": 48,
    "721426": 48,
    "721428": 48,
    "721429": 48,
    "721430": 48,
    "721431": 48,
    "721432": 48,
    "721433": 48,
    "721434": 48,
    "721435": 48,
    "721436": 48,
    "721437": 48,
    "721438": 48,
    "721439": 48,
    "721440": 48,
    "721441": 48,
    "721442": 48,
    "721443": 48,
    "721444": 48,
    "721445": 48,
    "721446": 48,
    "721449": 48,
    "721450": 48,
    "721451": 48,
    "721452": 48,
    "721454": 48,
    "721455": 48,
    "721457": 48,
    "721463": 48,
    "721467": 48,
    "721503": 48,
    "721504": 48,
    "721505": 48,
    "721507": 48,
    "721513": 48,
    "721514": 48,
    "721515": 48,
    "721517": 48,
    "721602": 48,
    "721603": 48,
    "721604": 48,
    "721605": 48,
    "721606": 48,
    "721607": 48,
    "721625": 48,
    "721627": 48,
    "721628": 48,
    "721629": 48,
    "721632": 48,
    "721633": 48,
    "721634": 48,
    "721635": 48,
    "721636": 48,
    "721641": 48,
    "721642": 48,
    "721643": 48,
    "721644": 48,
    "721645": 48,
    "721646": 48,
    "721647": 48,
    "721648": 48,
    "721649": 48,
    "721652": 48,
    "721653": 48,
    "721654": 48,
    "721657": 48,
    "721664": 48,
    "722101": 48,
    "722102": 48,
    "722107": 48,
    "722110": 48,
    "722111": 48,
    "722112": 48,
    "722121": 48,
    "722122": 48,
    "722132": 48,
    "722133": 48,
    "722135": 48,
    "722136": 48,
    "722137": 48,
    "722138": 48,
    "722139": 48,
    "722140": 48,
    "722144": 48,
    "722145": 48,
    "722146": 48,
    "722147": 48,
    "722148": 48,
    "722149": 48,
    "722151": 48,
    "722152": 48,
    "722154": 48,
    "722155": 48,
    "722156": 48,
    "722157": 48,
    "722158": 48,
    "722160": 48,
    "722162": 48,
    "722163": 48,
    "722164": 48,
    "722165": 48,
    "722169": 48,
    "722170": 48,
    "722171": 48,
    "722172": 48,
    "722173": 48,
    "722174": 48,
    "722175": 48,
    "722176": 48,
    "722178": 48,
    "722179": 48,
    "722180": 48,
    "722181": 48,
    "722182": 48,
    "722183": 48,
    "722203": 48,
    "722204": 48,
    "722206": 48,
    "722207": 48,
    "722208": 48,
    "722209": 48,
    "723101": 48,
    "723102": 48,
    "723103": 48,
    "723104": 48,
    "723121": 48,
    "723126": 48,
    "723127": 48,
    "723129": 48,
    "723130": 48,
    "723131": 48,
    "723132": 48,
    "723133": 48,
    "723142": 48,
    "723143": 48,
    "723145": 48,
    "723146": 48,
    "723147": 48,
    "723148": 48,
    "723149": 48,
    "723151": 48,
    "723153": 48,
    "723155": 48,
    "723156": 48,
    "723158": 48,
    "723161": 48,
    "723162": 48,
    "723168": 48,
    "723201": 48,
    "727120": 48,
    "731101": 48,
    "731102": 48,
    "731103": 48,
    "731104": 48,
    "731121": 48,
    "731123": 48,
    "731126": 48,
    "731127": 48,
    "731129": 48,
    "731130": 48,
    "731132": 48,
    "731201": 48,
    "731202": 48,
    "731204": 48,
    "731215": 48,
    "731216": 48,
    "731219": 48,
    "731220": 48,
    "731223": 48,
    "731224": 48,
    "731233": 48,
    "731234": 48,
    "731235": 48,
    "731236": 48,
    "731237": 48,
    "731238": 48,
    "731240": 48,
    "731241": 48,
    "731242": 48,
    "731243": 48,
    "731244": 48,
    "731245": 48,
    "731301": 48,
    "731302": 48,
    "731303": 48,
    "731304": 48,
    "732101": 48,
    "732102": 48,
    "732103": 48,
    "732121": 48,
    "732122": 48,
    "732123": 96,
    "732124": 96,
    "732125": 96,
    "732126": 96,
    "732127": 96,
    "732128": 48,
    "732138": 96,
    "732139": 96,
    "732140": 96,
    "732141": 48,
    "732142": 48,
    "732143": 48,
    "732144": 48,
    "732147": 96,
    "732150": 96,
    "732201": 48,
    "732202": 48,
    "732203": 48,
    "732204": 96,
    "732205": 96,
    "732206": 48,
    "732207": 48,
    "732208": 48,
    "732209": 48,
    "732210": 96,
    "732211": 48,
    "732212": 48,
    "732213": 96,
    "732214": 96,
    "732215": 96,
    "732216": 48,
    "733101": 96,
    "733102": 96,
    "733103": 96,
    "733121": 96,
    "733123": 96,
    "733124": 96,
    "733125": 96,
    "733126": 96,
    "733127": 96,
    "733128": 96,
    "733129": 96,
    "733130": 96,
    "733131": 96,
    "733132": 96,
    "733133": 96,
    "733134": 96,
    "733140": 96,
    "733141": 96,
    "733142": 96,
    "733143": 96,
    "733145": 96,
    "733151": 96,
    "733153": 96,
    "733155": 96,
    "733156": 96,
    "733158": 96,
    "733201": 96,
    "733202": 96,
    "733207": 96,
    "733208": 96,
    "733209": 96,
    "733210": 96,
    "733214": 96,
    "733215": 96,
    "733216": 96,
    "734001": 48,
    "734002": 48,
    "734003": 48,
    "734004": 48,
    "734005": 48,
    "734006": 48,
    "734007": 96,
    "734008": 48,
    "734009": 96,
    "734010": 96,
    "734011": 96,
    "734012": 96,
    "734013": 96,
    "734014": 96,
    "734015": 96,
    "734101": 96,
    "734121": 96,
    "734124": 96,
    "734201": 96,
    "734203": 96,
    "734216": 96,
    "734219": 96,
    "734333": 96,
    "734401": 48,
    "734403": 48,
    "734404": 48,
    "734405": 48,
    "734421": 96,
    "734422": 96,
    "734423": 96,
    "734424": 96,
    "734426": 96,
    "734427": 96,
    "734429": 96,
    "734431": 96,
    "734434": 96,
    "734436": 96,
    "734501": 96,
    "735101": 96,
    "735102": 96,
    "735121": 96,
    "735122": 96,
    "735132": 96,
    "735133": 96,
    "735134": 96,
    "735135": 96,
    "735139": 96,
    "735140": 96,
    "735202": 96,
    "735203": 96,
    "735204": 96,
    "735205": 96,
    "735206": 96,
    "735207": 96,
    "735208": 96,
    "735209": 96,
    "735210": 96,
    "735211": 96,
    "735212": 96,
    "735213": 96,
    "735214": 96,
    "735215": 96,
    "735216": 96,
    "735217": 96,
    "735218": 96,
    "735219": 96,
    "735220": 96,
    "735221": 96,
    "735222": 96,
    "735223": 96,
    "735224": 96,
    "735225": 96,
    "735226": 96,
    "735227": 96,
    "735228": 96,
    "735229": 96,
    "735230": 96,
    "735232": 96,
    "735233": 96,
    "735234": 96,
    "735301": 96,
    "735302": 96,
    "735304": 96,
    "735305": 96,
    "736101": 96,
    "736121": 96,
    "736122": 96,
    "736123": 96,
    "736133": 96,
    "736134": 96,
    "736135": 96,
    "736145": 96,
    "736146": 96,
    "736156": 96,
    "736157": 96,
    "736158": 96,
    "736159": 96,
    "736160": 96,
    "736169": 96,
    "736170": 96,
    "736171": 96,
    "736172": 96,
    "736179": 96,
    "736182": 96,
    "736206": 96,
    "736208": 96,
    "737101": 120,
    "737102": 96,
    "737103": 120,
    "737132": 96,
    "737134": 96,
    "737135": 96,
    "737136": 96,
    "741101": 48,
    "741102": 48,
    "741103": 48,
    "741121": 48,
    "741122": 48,
    "741123": 48,
    "741124": 48,
    "741125": 48,
    "741126": 48,
    "741127": 48,
    "741137": 48,
    "741138": 48,
    "741139": 48,
    "741140": 48,
    "741150": 48,
    "741151": 48,
    "741152": 48,
    "741153": 48,
    "741154": 48,
    "741155": 48,
    "741156": 48,
    "741157": 48,
    "741159": 48,
    "741160": 48,
    "741161": 48,
    "741162": 48,
    "741163": 48,
    "741164": 48,
    "741165": 48,
    "741166": 48,
    "741181": 48,
    "741201": 48,
    "741202": 48,
    "741221": 48,
    "741222": 48,
    "741223": 48,
    "741225": 48,
    "741232": 48,
    "741234": 48,
    "741235": 48,
    "741238": 48,
    "741245": 48,
    "741246": 48,
    "741247": 48,
    "741248": 48,
    "741249": 48,
    "741250": 48,
    "741251": 48,
    "741252": 48,
    "741253": 48,
    "741254": 48,
    "741255": 48,
    "741256": 48,
    "741257": 48,
    "741301": 48,
    "741302": 48,
    "741313": 48,
    "741315": 48,
    "741317": 48,
    "741319": 48,
    "741401": 48,
    "741402": 48,
    "741404": 48,
    "741501": 48,
    "741502": 48,
    "741504": 48,
    "741506": 48,
    "741507": 48,
    "741508": 48,
    "741509": 48,
    "742101": 48,
    "742102": 48,
    "742103": 48,
    "742104": 48,
    "742113": 48,
    "742122": 48,
    "742123": 48,
    "742132": 48,
    "742133": 48,
    "742134": 48,
    "742136": 48,
    "742137": 48,
    "742138": 48,
    "742140": 48,
    "742147": 48,
    "742148": 48,
    "742149": 48,
    "742151": 48,
    "742159": 48,
    "742160": 48,
    "742161": 48,
    "742163": 48,
    "742164": 48,
    "742165": 48,
    "742166": 48,
    "742168": 48,
    "742174": 48,
    "742175": 48,
    "742187": 48,
    "742201": 48,
    "742202": 48,
    "742212": 96,
    "742213": 48,
    "742223": 48,
    "742224": 48,
    "742225": 48,
    "742226": 48,
    "742227": 48,
    "742229": 48,
    "742235": 48,
    "742236": 96,
    "742237": 48,
    "742238": 48,
    "742301": 48,
    "742302": 48,
    "742303": 48,
    "742304": 48,
    "742305": 48,
    "742306": 48,
    "742308": 48,
    "742401": 48,
    "742402": 48,
    "742404": 48,
    "742405": 48,
    "742406": 48,
    "742407": 48,
    "742408": 48,
    "742409": 48,
    "743101": 48,
    "743102": 48,
    "743120": 48,
    "743121": 48,
    "743122": 48,
    "743123": 48,
    "743125": 48,
    "743126": 48,
    "743127": 48,
    "743128": 48,
    "743129": 48,
    "743133": 48,
    "743134": 48,
    "743135": 48,
    "743136": 48,
    "743144": 48,
    "743145": 48,
    "743155": 48,
    "743165": 48,
    "743166": 48,
    "743170": 48,
    "743175": 48,
    "743176": 48,
    "743177": 48,
    "743178": 48,
    "743179": 48,
    "743180": 48,
    "743186": 48,
    "743187": 48,
    "743188": 48,
    "743193": 48,
    "743194": 48,
    "743195": 48,
    "743221": 24,
    "743222": 48,
    "743223": 48,
    "743232": 48,
    "743233": 48,
    "743234": 48,
    "743235": 48,
    "743245": 48,
    "743247": 48,
    "743248": 24,
    "743249": 48,
    "743251": 48,
    "743252": 48,
    "743262": 48,
    "743263": 48,
    "743268": 48,
    "743269": 48,
    "743270": 48,
    "743271": 48,
    "743272": 48,
    "743273": 48,
    "743286": 48,
    "743287": 48,
    "743289": 48,
    "743290": 48,
    "743291": 48,
    "743292": 48,
    "743293": 48,
    "743294": 24,
    "743297": 48,
    "743313": 24,
    "743318": 48,
    "743329": 48,
    "743330": 48,
    "743331": 48,
    "743332": 96,
    "743336": 96,
    "743337": 96,
    "743338": 96,
    "743345": 96,
    "743351": 96,
    "743354": 96,
    "743355": 96,
    "743368": 48,
    "743372": 96,
    "743375": 96,
    "743376": 48,
    "743377": 48,
    "743385": 96,
    "743387": 96,
    "743391": 96,
    "743395": 96,
    "743396": 96,
    "743398": 48,
    "743401": 48,
    "743405": 48,
    "743411": 48,
    "743412": 48,
    "743422": 48,
    "743423": 24,
    "743424": 48,
    "743425": 48,
    "743426": 48,
    "743427": 48,
    "743428": 48,
    "743429": 48,
    "743437": 48,
    "743438": 48,
    "743445": 48,
    "743456": 48,
    "743502": 48,
    "743503": 48,
    "743504": 48,
    "743507": 48,
    "743513": 48,
    "743601": 96,
    "743609": 96,
    "743610": 96,
    "743613": 96,
    "743701": 48,
    "743702": 48,
    "743704": 48,
    "743710": 48,
    "743711": 48,
    "744101": 96,
    "744102": 96,
    "744103": 96,
    "744104": 96,
    "744106": 96,
    "744112": 96,
    "751001": 48,
    "751002": 48,
    "751003": 48,
    "751004": 48,
    "751005": 48,
    "751006": 48,
    "751007": 48,
    "751008": 48,
    "751009": 48,
    "751010": 48,
    "751011": 48,
    "751012": 48,
    "751013": 48,
    "751014": 48,
    "751015": 48,
    "751016": 48,
    "751017": 48,
    "751018": 48,
    "751019": 48,
    "751020": 48,
    "751021": 48,
    "751022": 48,
    "751023": 48,
    "751024": 48,
    "751025": 48,
    "751026": 48,
    "751027": 48,
    "751029": 48,
    "751030": 48,
    "751031": 48,
    "751062": 48,
    "752001": 48,
    "752002": 48,
    "752003": 48,
    "752010": 48,
    "752011": 48,
    "752012": 48,
    "752013": 48,
    "752014": 48,
    "752015": 96,
    "752017": 48,
    "752018": 96,
    "752019": 96,
    "752020": 96,
    "752021": 96,
    "752022": 96,
    "752023": 96,
    "752024": 96,
    "752025": 96,
    "752026": 96,
    "752030": 96,
    "752031": 96,
    "752034": 96,
    "752035": 96,
    "752037": 96,
    "752038": 96,
    "752045": 48,
    "752050": 96,
    "752054": 96,
    "752055": 96,
    "752056": 96,
    "752057": 96,
    "752060": 96,
    "752061": 96,
    "752062": 96,
    "752063": 96,
    "752064": 96,
    "752065": 96,
    "752066": 96,
    "752068": 96,
    "752069": 96,
    "752070": 96,
    "752077": 96,
    "752078": 96,
    "752079": 96,
    "752080": 96,
    "752081": 96,
    "752092": 96,
    "752094": 96,
    "752100": 48,
    "752101": 48,
    "752104": 96,
    "752105": 96,
    "752106": 96,
    "752108": 96,
    "752109": 96,
    "752110": 96,
    "752111": 96,
    "752114": 96,
    "753001": 48,
    "753002": 48,
    "753003": 48,
    "753004": 48,
    "753005": 48,
    "753006": 48,
    "753007": 48,
    "753008": 48,
    "753009": 48,
    "753010": 48,
    "753011": 48,
    "753012": 48,
    "753013": 48,
    "753014": 48,
    "753015": 48,
    "753051": 48,
    "754001": 48,
    "754004": 96,
    "754005": 48,
    "754006": 48,
    "754008": 96,
    "754011": 96,
    "754018": 96,
    "754021": 48,
    "754022": 48,
    "754023": 96,
    "754024": 96,
    "754025": 48,
    "754027": 96,
    "754028": 48,
    "754029": 96,
    "754030": 96,
    "754031": 96,
    "754032": 96,
    "754037": 96,
    "754071": 48,
    "754082": 96,
    "754102": 96,
    "754103": 96,
    "754104": 96,
    "754106": 96,
    "754107": 96,
    "754108": 96,
    "754109": 96,
    "754110": 96,
    "754111": 96,
    "754113": 96,
    "754114": 96,
    "754119": 96,
    "754120": 96,
    "754130": 96,
    "754131": 96,
    "754132": 96,
    "754133": 96,
    "754134": 96,
    "754136": 96,
    "754137": 96,
    "754140": 96,
    "754141": 96,
    "754142": 96,
    "754143": 96,
    "754145": 96,
    "754153": 96,
    "754160": 96,
    "754162": 96,
    "754200": 48,
    "754201": 48,
    "754202": 48,
    "754203": 48,
    "754204": 96,
    "754205": 96,
    "754210": 96,
    "754211": 96,
    "754212": 96,
    "754213": 96,
    "754214": 96,
    "754215": 96,
    "754216": 96,
    "754217": 96,
    "754218": 96,
    "754219": 96,
    "754220": 96,
    "754222": 96,
    "754223": 96,
    "754224": 96,
    "754228": 96,
    "754231": 96,
    "754239": 96,
    "754240": 96,
    "754244": 96,
    "754245": 96,
    "754246": 96,
    "754250": 96,
    "754253": 96,
    "754289": 96,
    "754292": 96,
    "754295": 96,
    "754296": 96,
    "755001": 96,
    "755003": 96,
    "755004": 96,
    "755005": 96,
    "755006": 96,
    "755007": 96,
    "755008": 96,
    "755009": 96,
    "755010": 96,
    "755011": 96,
    "755012": 96,
    "755013": 96,
    "755014": 96,
    "755015": 96,
    "755016": 96,
    "755017": 96,
    "755019": 96,
    "755020": 96,
    "755022": 96,
    "755023": 96,
    "755024": 96,
    "755026": 96,
    "755027": 96,
    "755036": 96,
    "755040": 96,
    "755043": 96,
    "755044": 96,
    "755049": 96,
    "755050": 96,
    "755061": 96,
    "755062": 96,
    "756001": 96,
    "756002": 96,
    "756003": 96,
    "756019": 96,
    "756020": 96,
    "756023": 96,
    "756024": 96,
    "756025": 96,
    "756026": 96,
    "756027": 96,
    "756029": 96,
    "756030": 96,
    "756032": 96,
    "756034": 96,
    "756035": 96,
    "756036": 96,
    "756038": 96,
    "756039": 96,
    "756040": 96,
    "756042": 96,
    "756043": 96,
    "756045": 96,
    "756046": 96,
    "756056": 96,
    "756058": 96,
    "756060": 96,
    "756079": 96,
    "756080": 96,
    "756081": 96,
    "756083": 96,
    "756084": 96,
    "756085": 96,
    "756086": 96,
    "756087": 96,
    "756100": 96,
    "756101": 96,
    "756111": 96,
    "756112": 96,
    "756113": 96,
    "756116": 96,
    "756118": 96,
    "756119": 96,
    "756124": 96,
    "756125": 96,
    "756127": 96,
    "756128": 96,
    "756129": 96,
    "756130": 96,
    "756131": 96,
    "756132": 96,
    "756133": 96,
    "756139": 96,
    "756163": 96,
    "756164": 96,
    "756165": 96,
    "756181": 96,
    "757001": 96,
    "757002": 96,
    "757003": 96,
    "757017": 96,
    "757019": 96,
    "757020": 96,
    "757021": 96,
    "757022": 96,
    "757023": 96,
    "757024": 96,
    "757025": 96,
    "757026": 96,
    "757027": 96,
    "757029": 96,
    "757030": 96,
    "757040": 96,
    "757041": 96,
    "757049": 96,
    "757075": 96,
    "757077": 96,
    "757079": 96,
    "757084": 96,
    "757085": 96,
    "757087": 96,
    "757101": 96,
    "757103": 96,
    "757104": 96,
    "757105": 96,
    "757107": 96,
    "758001": 96,
    "758002": 96,
    "758013": 96,
    "758014": 96,
    "758018": 96,
    "758031": 96,
    "758034": 96,
    "758035": 96,
    "758037": 96,
    "758038": 96,
    "758041": 96,
    "758046": 96,
    "758079": 96,
    "758087": 96,
    "759001": 96,
    "759013": 96,
    "759015": 96,
    "759024": 96,
    "759025": 96,
    "759027": 96,
    "759037": 96,
    "759100": 96,
    "759101": 96,
    "759102": 96,
    "759104": 96,
    "759106": 96,
    "759107": 96,
    "759111": 96,
    "759116": 96,
    "759121": 96,
    "759122": 96,
    "759123": 96,
    "759124": 96,
    "759125": 96,
    "759126": 96,
    "759128": 96,
    "759130": 96,
    "759143": 96,
    "759145": 96,
    "759146": 96,
    "760001": 96,
    "760002": 96,
    "760003": 96,
    "760004": 96,
    "760005": 96,
    "760006": 96,
    "760007": 96,
    "760008": 96,
    "760009": 96,
    "760010": 96,
    "760011": 96,
    "761001": 96,
    "761002": 96,
    "761003": 96,
    "761004": 96,
    "761008": 96,
    "761009": 96,
    "761010": 96,
    "761020": 96,
    "761025": 96,
    "761032": 96,
    "761041": 96,
    "761045": 96,
    "761052": 96,
    "761100": 96,
    "761101": 96,
    "761102": 96,
    "761103": 96,
    "761104": 96,
    "761106": 96,
    "761107": 96,
    "761108": 96,
    "761110": 96,
    "761114": 96,
    "761115": 96,
    "761116": 96,
    "761117": 96,
    "761118": 96,
    "761122": 96,
    "761123": 96,
    "761124": 96,
    "761133": 96,
    "761146": 96,
    "761200": 96,
    "761201": 96,
    "761206": 96,
    "761208": 96,
    "761210": 96,
    "761211": 96,
    "762001": 120,
    "762002": 120,
    "762010": 120,
    "762012": 120,
    "762013": 96,
    "762014": 96,
    "762019": 120,
    "762029": 120,
    "762100": 120,
    "762103": 120,
    "763001": 96,
    "763002": 96,
    "763003": 96,
    "763004": 96,
    "763008": 96,
    "764001": 96,
    "764003": 96,
    "764004": 96,
    "764005": 96,
    "764006": 96,
    "764011": 96,
    "764020": 96,
    "764021": 96,
    "764036": 96,
    "764043": 96,
    "764044": 96,
    "764045": 96,
    "764048": 96,
    "764049": 96,
    "764051": 96,
    "764056": 96,
    "764058": 96,
    "764059": 96,
    "764063": 96,
    "764070": 96,
    "764071": 96,
    "764078": 96,
    "764085": 96,
    "765001": 96,
    "765002": 96,
    "765017": 96,
    "765018": 96,
    "766001": 96,
    "766002": 96,
    "766014": 96,
    "766020": 96,
    "766027": 96,
    "766104": 96,
    "766105": 96,
    "766107": 120,
    "767001": 96,
    "767002": 96,
    "767016": 96,
    "767017": 96,
    "767018": 96,
    "767019": 96,
    "767020": 96,
    "767033": 120,
    "767039": 120,
    "767040": 120,
    "767065": 96,
    "767066": 120,
    "767067": 96,
    "767070": 120,
    "767071": 96,
    "768001": 96,
    "768002": 96,
    "768003": 96,
    "768004": 96,
    "768005": 96,
    "768006": 96,
    "768016": 96,
    "768017": 96,
    "768018": 96,
    "768019": 96,
    "768020": 96,
    "768027": 96,
    "768028": 96,
    "768040": 96,
    "768106": 96,
    "768108": 96,
    "768109": 96,
    "768118": 96,
    "768119": 96,
    "768201": 96,
    "768202": 96,
    "768203": 96,
    "768204": 96,
    "768210": 96,
    "768211": 96,
    "768216": 96,
    "768217": 96,
    "768218": 96,
    "768224": 96,
    "768225": 96,
    "768233": 96,
    "768234": 96,
    "769001": 96,
    "769002": 96,
    "769003": 96,
    "769004": 96,
    "769005": 96,
    "769006": 96,
    "769007": 96,
    "769008": 96,
    "769009": 96,
    "769010": 96,
    "769011": 96,
    "769012": 96,
    "769013": 96,
    "769014": 96,
    "769015": 96,
    "769016": 96,
    "769042": 96,
    "770001": 96,
    "770002": 96,
    "770016": 96,
    "770017": 96,
    "770018": 96,
    "770025": 96,
    "770031": 96,
    "770034": 96,
    "770070": 96,
    "770072": 96,
    "777888": 24,
    "781001": 24,
    "781002": 24,
    "781003": 24,
    "781004": 24,
    "781005": 24,
    "781006": 24,
    "781007": 24,
    "781008": 24,
    "781009": 24,
    "781010": 24,
    "781011": 24,
    "781012": 24,
    "781013": 24,
    "781014": 24,
    "781015": 24,
    "781016": 24,
    "781017": 24,
    "781018": 24,
    "781019": 24,
    "781020": 24,
    "781021": 24,
    "781022": 24,
    "781023": 24,
    "781024": 24,
    "781025": 24,
    "781026": 24,
    "781027": 24,
    "781028": 24,
    "781029": 24,
    "781030": 48,
    "781031": 24,
    "781032": 24,
    "781033": 24,
    "781034": 24,
    "781035": 24,
    "781036": 24,
    "781037": 24,
    "781038": 24,
    "781039": 48,
    "781040": 24,
    "781071": 24,
    "781101": 48,
    "781102": 48,
    "781103": 48,
    "781104": 48,
    "781121": 48,
    "781122": 48,
    "781123": 48,
    "781124": 48,
    "781125": 24,
    "781128": 24,
    "781131": 48,
    "781132": 48,
    "781133": 48,
    "781134": 48,
    "781150": 24,
    "781171": 24,
    "781301": 48,
    "781303": 48,
    "781304": 48,
    "781306": 48,
    "781309": 48,
    "781310": 48,
    "781313": 48,
    "781314": 48,
    "781315": 48,
    "781316": 48,
    "781317": 48,
    "781318": 48,
    "781319": 48,
    "781325": 48,
    "781326": 48,
    "781334": 48,
    "781335": 48,
    "781337": 48,
    "781338": 48,
    "781339": 48,
    "781340": 48,
    "781341": 48,
    "781346": 48,
    "781347": 48,
    "781348": 48,
    "781349": 48,
    "781351": 48,
    "781352": 48,
    "781353": 48,
    "781354": 48,
    "781360": 96,
    "781365": 48,
    "781366": 48,
    "781367": 96,
    "781369": 48,
    "781370": 48,
    "781371": 48,
    "781374": 48,
    "781376": 48,
    "781378": 48,
    "781380": 48,
    "781381": 48,
    "781382": 48,
    "782001": 48,
    "782002": 48,
    "782003": 48,
    "782102": 48,
    "782105": 48,
    "782120": 48,
    "782135": 48,
    "782136": 48,
    "782137": 48,
    "782138": 48,
    "782139": 48,
    "782140": 48,
    "782143": 48,
    "782402": 48,
    "782410": 48,
    "782429": 48,
    "782439": 48,
    "782440": 48,
    "782442": 48,
    "782445": 48,
    "782446": 48,
    "782447": 96,
    "782460": 120,
    "782461": 120,
    "782462": 120,
    "782480": 48,
    "783101": 96,
    "783120": 96,
    "783121": 96,
    "783122": 96,
    "783124": 96,
    "783125": 96,
    "783126": 96,
    "783133": 96,
    "783134": 96,
    "783301": 96,
    "783333": 96,
    "783336": 96,
    "783337": 96,
    "783345": 96,
    "783346": 96,
    "783347": 96,
    "783354": 96,
    "783360": 96,
    "783361": 96,
    "783369": 96,
    "783370": 96,
    "783373": 48,
    "783375": 48,
    "783376": 96,
    "783380": 48,
    "783381": 48,
    "783385": 48,
    "783390": 48,
    "783391": 48,
    "783392": 48,
    "783394": 48,
    "784001": 96,
    "784010": 48,
    "784025": 48,
    "784026": 48,
    "784027": 48,
    "784028": 48,
    "784101": 48,
    "784104": 48,
    "784105": 48,
    "784110": 96,
    "784115": 48,
    "784117": 96,
    "784125": 48,
    "784145": 48,
    "784149": 48,
    "784150": 48,
    "784153": 48,
    "784154": 96,
    "784160": 48,
    "784161": 48,
    "784163": 48,
    "784164": 48,
    "784168": 48,
    "784169": 48,
    "784170": 48,
    "784171": 48,
    "784172": 48,
    "784174": 96,
    "784175": 96,
    "784176": 96,
    "784177": 96,
    "784178": 48,
    "784180": 96,
    "784189": 96,
    "784501": 48,
    "784502": 48,
    "784504": 48,
    "784505": 48,
    "784506": 48,
    "784521": 48,
    "784525": 48,
    "785001": 48,
    "785002": 48,
    "785004": 48,
    "785005": 48,
    "785006": 48,
    "785007": 48,
    "785008": 48,
    "785009": 48,
    "785010": 48,
    "785013": 48,
    "785101": 48,
    "785102": 96,
    "785107": 48,
    "785108": 48,
    "785111": 48,
    "785112": 48,
    "785609": 48,
    "785610": 48,
    "785612": 48,
    "785613": 48,
    "785615": 48,
    "785618": 48,
    "785619": 48,
    "785621": 48,
    "785622": 48,
    "785625": 48,
    "785626": 48,
    "785630": 48,
    "785636": 48,
    "785640": 48,
    "785661": 48,
    "785662": 48,
    "785665": 48,
    "785669": 48,
    "785670": 48,
    "785671": 48,
    "785672": 48,
    "785680": 48,
    "785681": 48,
    "785682": 48,
    "785683": 48,
    "785684": 48,
    "785685": 96,
    "785686": 96,
    "785687": 48,
    "785688": 96,
    "785689": 96,
    "785690": 96,
    "785691": 96,
    "785692": 96,
    "785696": 48,
    "785699": 48,
    "785700": 48,
    "785701": 96,
    "785702": 48,
    "785703": 48,
    "785704": 48,
    "785705": 48,
    "786001": 48,
    "786002": 48,
    "786003": 48,
    "786004": 48,
    "786005": 48,
    "786006": 48,
    "786007": 48,
    "786008": 48,
    "786010": 48,
    "786012": 48,
    "786102": 48,
    "786125": 48,
    "786126": 48,
    "786145": 48,
    "786146": 48,
    "786147": 48,
    "786148": 48,
    "786150": 96,
    "786151": 96,
    "786152": 96,
    "786153": 96,
    "786156": 96,
    "786159": 96,
    "786160": 96,
    "786170": 48,
    "786171": 48,
    "786173": 48,
    "786179": 96,
    "786181": 48,
    "786182": 48,
    "786183": 48,
    "786184": 48,
    "786187": 48,
    "786188": 96,
    "786189": 48,
    "786190": 96,
    "786191": 48,
    "786192": 48,
    "786601": 48,
    "786602": 48,
    "786610": 48,
    "786611": 48,
    "786612": 48,
    "786614": 48,
    "786621": 48,
    "786622": 48,
    "786623": 48,
    "786692": 48,
    "787001": 96,
    "787023": 96,
    "787026": 96,
    "787031": 96,
    "787032": 96,
    "787034": 96,
    "787035": 96,
    "787051": 96,
    "787053": 96,
    "787054": 48,
    "787055": 96,
    "787056": 96,
    "787059": 48,
    "787060": 48,
    "787061": 48,
    "787110": 48,
    "788001": 96,
    "788002": 96,
    "788003": 96,
    "788004": 96,
    "788005": 96,
    "788006": 96,
    "788007": 96,
    "788009": 96,
    "788010": 96,
    "788011": 96,
    "788014": 96,
    "788015": 96,
    "788098": 120,
    "788101": 120,
    "788102": 120,
    "788103": 120,
    "788104": 120,
    "788106": 120,
    "788107": 120,
    "788150": 120,
    "788151": 120,
    "788152": 120,
    "788155": 120,
    "788160": 120,
    "788163": 120,
    "788164": 120,
    "788165": 120,
    "788166": 120,
    "788168": 120,
    "788709": 120,
    "788710": 120,
    "788711": 120,
    "788712": 120,
    "788713": 120,
    "788719": 120,
    "788720": 120,
    "788722": 120,
    "788723": 120,
    "788733": 120,
    "788781": 120,
    "788819": 96,
    "788820": 96,
    "791102": 48,
    "791110": 96,
    "791111": 48,
    "791113": 48,
    "791120": 96,
    "791123": 48,
    "792110": 96,
    "793001": 48,
    "793002": 48,
    "793003": 48,
    "793004": 48,
    "793005": 48,
    "793006": 48,
    "793007": 48,
    "793008": 48,
    "793010": 48,
    "793011": 48,
    "793014": 48,
    "793017": 48,
    "793018": 48,
    "793019": 48,
    "793022": 48,
    "793160": 48,
    "793200": 48,
    "793210": 48,
    "795001": 96,
    "795002": 96,
    "795003": 96,
    "795004": 96,
    "795005": 96,
    "795008": 96,
    "795009": 96,
    "795011": 96,
    "795103": 120,
    "795126": 96,
    "795134": 96,
    "795138": 120,
    "795140": 96,
    "796001": 96,
    "796004": 96,
    "796005": 96,
    "796007": 96,
    "796008": 96,
    "796009": 96,
    "796012": 96,
    "796014": 96,
    "796691": 120,
    "796701": 120,
    "797001": 48,
    "797004": 48,
    "797103": 48,
    "797111": 96,
    "797112": 48,
    "797113": 48,
    "797115": 48,
    "797116": 48,
    "797117": 48,
    "797121": 48,
    "798601": 168,
    "798612": 96,
    "798618": 96,
    "798620": 96,
    "798623": 96,
    "798627": 168,
    "799001": 96,
    "799002": 96,
    "799003": 96,
    "799004": 96,
    "799005": 96,
    "799006": 96,
    "799007": 96,
    "799008": 96,
    "799009": 96,
    "799010": 96,
    "799011": 96,
    "799012": 96,
    "799013": 96,
    "799014": 96,
    "799015": 96,
    "799022": 96,
    "799035": 96,
    "799046": 96,
    "799101": 96,
    "799103": 96,
    "799104": 96,
    "799105": 96,
    "799113": 96,
    "799114": 96,
    "799115": 96,
    "799120": 96,
    "799125": 96,
    "799130": 96,
    "799131": 96,
    "799132": 96,
    "799204": 96,
    "799210": 96,
    "799211": 96,
    "799250": 96,
    "799253": 96,
    "799254": 96,
    "799256": 96,
    "799260": 96,
    "799261": 96,
    "799263": 96,
    "799264": 96,
    "799270": 96,
    "799277": 96,
    "799278": 96,
    "799279": 96,
    "799280": 96,
    "799281": 96,
    "799282": 96,
    "799287": 96,
    "799289": 96,
    "800001": 48,
    "800002": 48,
    "800003": 48,
    "800004": 48,
    "800005": 48,
    "800006": 48,
    "800007": 48,
    "800008": 48,
    "800009": 48,
    "800010": 48,
    "800011": 48,
    "800012": 48,
    "800013": 48,
    "800014": 48,
    "800015": 48,
    "800016": 48,
    "800017": 48,
    "800018": 48,
    "800019": 48,
    "800020": 48,
    "800021": 48,
    "800022": 48,
    "800023": 48,
    "800024": 48,
    "800025": 48,
    "800026": 48,
    "800027": 48,
    "800028": 48,
    "800030": 48,
    "801102": 96,
    "801103": 96,
    "801104": 96,
    "801105": 96,
    "801106": 96,
    "801108": 96,
    "801109": 96,
    "801110": 96,
    "801111": 96,
    "801112": 96,
    "801113": 96,
    "801302": 96,
    "801304": 96,
    "801306": 96,
    "801501": 48,
    "801503": 96,
    "801505": 48,
    "801506": 48,
    "801507": 96,
    "802101": 96,
    "802102": 96,
    "802103": 96,
    "802111": 96,
    "802112": 96,
    "802113": 96,
    "802116": 96,
    "802117": 96,
    "802118": 96,
    "802119": 96,
    "802120": 96,
    "802122": 96,
    "802123": 96,
    "802125": 96,
    "802126": 96,
    "802130": 96,
    "802133": 96,
    "802134": 96,
    "802135": 96,
    "802136": 96,
    "802151": 96,
    "802152": 96,
    "802153": 96,
    "802154": 96,
    "802156": 96,
    "802157": 96,
    "802158": 96,
    "802159": 96,
    "802160": 96,
    "802161": 96,
    "802162": 96,
    "802163": 96,
    "802165": 96,
    "802166": 96,
    "802183": 96,
    "802201": 96,
    "802202": 96,
    "802203": 96,
    "802204": 96,
    "802205": 96,
    "802206": 96,
    "802207": 96,
    "802209": 96,
    "802210": 96,
    "802211": 96,
    "802212": 96,
    "802213": 96,
    "802214": 96,
    "802215": 96,
    "802216": 96,
    "802217": 96,
    "802218": 96,
    "802219": 96,
    "802220": 96,
    "802221": 96,
    "802223": 96,
    "802226": 96,
    "802229": 96,
    "802301": 96,
    "802302": 96,
    "802311": 96,
    "802312": 96,
    "802314": 96,
    "802316": 96,
    "802351": 96,
    "802352": 96,
    "803101": 96,
    "803108": 96,
    "803110": 96,
    "803111": 96,
    "803113": 96,
    "803114": 96,
    "803115": 96,
    "803116": 96,
    "803117": 96,
    "803118": 96,
    "803121": 96,
    "803201": 96,
    "803202": 96,
    "803203": 96,
    "803211": 96,
    "803212": 96,
    "803213": 96,
    "803214": 96,
    "803215": 96,
    "803221": 96,
    "803301": 96,
    "803302": 96,
    "803303": 96,
    "803306": 96,
    "803307": 96,
    "804401": 96,
    "804402": 96,
    "804404": 96,
    "804406": 96,
    "804408": 96,
    "804417": 96,
    "804418": 96,
    "804419": 96,
    "804420": 96,
    "804422": 96,
    "804423": 96,
    "804424": 96,
    "804425": 96,
    "804426": 96,
    "804427": 96,
    "804429": 96,
    "804430": 96,
    "804432": 96,
    "804434": 96,
    "804451": 96,
    "804452": 96,
    "804453": 96,
    "804454": 96,
    "805102": 96,
    "805103": 96,
    "805104": 96,
    "805106": 96,
    "805107": 96,
    "805108": 96,
    "805109": 96,
    "805110": 96,
    "805111": 96,
    "805112": 96,
    "805113": 96,
    "805121": 96,
    "805122": 96,
    "805123": 96,
    "805124": 96,
    "805125": 96,
    "805126": 96,
    "805127": 96,
    "805129": 96,
    "805130": 96,
    "805131": 96,
    "805132": 96,
    "805133": 96,
    "805141": 96,
    "805236": 96,
    "811101": 96,
    "811102": 96,
    "811103": 96,
    "811104": 96,
    "811105": 96,
    "811106": 96,
    "811107": 96,
    "811112": 96,
    "811201": 96,
    "811202": 96,
    "811211": 96,
    "811212": 96,
    "811213": 96,
    "811214": 96,
    "811302": 96,
    "811304": 96,
    "811305": 96,
    "811307": 96,
    "811308": 96,
    "811309": 96,
    "811310": 96,
    "811311": 96,
    "811312": 96,
    "811313": 96,
    "811315": 96,
    "811317": 96,
    "811538": 96,
    "812001": 96,
    "812002": 96,
    "812003": 96,
    "812004": 96,
    "812005": 96,
    "812006": 96,
    "812007": 96,
    "813101": 96,
    "813102": 96,
    "813103": 96,
    "813104": 96,
    "813105": 96,
    "813107": 96,
    "813108": 96,
    "813109": 96,
    "813110": 96,
    "813113": 96,
    "813128": 96,
    "813202": 96,
    "813203": 120,
    "813204": 120,
    "813205": 120,
    "813206": 120,
    "813207": 96,
    "813209": 120,
    "813210": 96,
    "813211": 96,
    "813213": 96,
    "813214": 120,
    "813221": 96,
    "813222": 120,
    "814101": 96,
    "814102": 96,
    "814103": 96,
    "814110": 96,
    "814111": 96,
    "814112": 96,
    "814113": 96,
    "814114": 96,
    "814115": 96,
    "814116": 96,
    "814118": 96,
    "814119": 96,
    "814120": 96,
    "814122": 96,
    "814133": 96,
    "814141": 96,
    "814142": 96,
    "814143": 96,
    "814144": 96,
    "814145": 96,
    "814147": 96,
    "814148": 96,
    "814150": 96,
    "814153": 96,
    "814154": 96,
    "814156": 96,
    "814157": 96,
    "814158": 96,
    "814160": 120,
    "814165": 96,
    "814166": 96,
    "814167": 96,
    "815301": 96,
    "815302": 96,
    "815311": 96,
    "815312": 96,
    "815351": 96,
    "815352": 96,
    "815354": 96,
    "815355": 96,
    "815357": 96,
    "816104": 96,
    "816107": 96,
    "816108": 120,
    "816109": 120,
    "816115": 120,
    "816116": 120,
    "816118": 96,
    "816120": 120,
    "816129": 120,
    "821101": 96,
    "821102": 96,
    "821103": 96,
    "821106": 96,
    "821107": 96,
    "821108": 96,
    "821109": 96,
    "821111": 96,
    "821112": 96,
    "821115": 96,
    "821307": 96,
    "821309": 96,
    "821310": 96,
    "822101": 96,
    "822102": 96,
    "822110": 96,
    "822111": 96,
    "822114": 96,
    "822121": 96,
    "822124": 96,
    "822128": 96,
    "822132": 96,
    "822133": 96,
    "823001": 96,
    "823002": 96,
    "823003": 96,
    "823004": 96,
    "823005": 96,
    "824101": 96,
    "824102": 96,
    "824103": 96,
    "824111": 96,
    "824112": 96,
    "824113": 96,
    "824114": 96,
    "824120": 96,
    "824121": 96,
    "824123": 96,
    "824124": 96,
    "824143": 96,
    "824202": 96,
    "824231": 96,
    "824301": 96,
    "824302": 96,
    "824303": 96,
    "825101": 96,
    "825102": 96,
    "825103": 96,
    "825301": 96,
    "825302": 96,
    "825311": 96,
    "825314": 96,
    "825316": 96,
    "825325": 96,
    "825330": 96,
    "825336": 96,
    "825401": 96,
    "825402": 96,
    "825403": 96,
    "825404": 96,
    "825407": 96,
    "825408": 96,
    "825409": 96,
    "825410": 96,
    "825413": 96,
    "825418": 96,
    "825421": 96,
    "826001": 96,
    "826003": 96,
    "826004": 96,
    "826005": 96,
    "826006": 96,
    "826106": 96,
    "827001": 96,
    "827003": 96,
    "827004": 96,
    "827006": 96,
    "827009": 96,
    "827010": 96,
    "827011": 96,
    "827012": 96,
    "827013": 96,
    "827014": 96,
    "827015": 96,
    "827302": 96,
    "827611": 96,
    "828101": 96,
    "828103": 96,
    "828104": 96,
    "828105": 96,
    "828106": 96,
    "828107": 96,
    "828108": 96,
    "828109": 96,
    "828110": 96,
    "828111": 96,
    "828112": 96,
    "828113": 96,
    "828114": 96,
    "828115": 96,
    "828116": 96,
    "828117": 96,
    "828119": 96,
    "828120": 96,
    "828121": 96,
    "828122": 96,
    "828123": 96,
    "828124": 96,
    "828125": 96,
    "828126": 96,
    "828127": 96,
    "828128": 96,
    "828129": 96,
    "828130": 96,
    "828131": 96,
    "828132": 96,
    "828133": 96,
    "828134": 96,
    "828135": 96,
    "828201": 96,
    "828206": 96,
    "828301": 96,
    "828302": 96,
    "828303": 96,
    "828304": 96,
    "828305": 96,
    "828306": 96,
    "828307": 96,
    "828309": 96,
    "828401": 96,
    "828402": 96,
    "828403": 96,
    "828404": 96,
    "829101": 96,
    "829102": 96,
    "829103": 96,
    "829104": 96,
    "829105": 96,
    "829106": 96,
    "829107": 96,
    "829108": 96,
    "829109": 96,
    "829110": 96,
    "829111": 96,
    "829112": 96,
    "829113": 96,
    "829114": 96,
    "829115": 96,
    "829116": 96,
    "829117": 96,
    "829118": 96,
    "829119": 96,
    "829121": 96,
    "829122": 96,
    "829123": 96,
    "829124": 96,
    "829125": 96,
    "829126": 96,
    "829127": 96,
    "829128": 96,
    "829129": 96,
    "829130": 96,
    "829131": 96,
    "829132": 96,
    "829133": 96,
    "829134": 96,
    "829135": 96,
    "829138": 96,
    "829143": 96,
    "829144": 96,
    "829149": 96,
    "829150": 96,
    "829203": 96,
    "829206": 96,
    "829207": 96,
    "829301": 96,
    "831001": 48,
    "831002": 48,
    "831003": 48,
    "831004": 48,
    "831005": 48,
    "831006": 48,
    "831007": 48,
    "831008": 48,
    "831009": 48,
    "831010": 48,
    "831011": 48,
    "831012": 48,
    "831013": 48,
    "831014": 48,
    "831015": 48,
    "831016": 48,
    "831017": 48,
    "831018": 48,
    "831019": 48,
    "831020": 48,
    "831021": 96,
    "831035": 48,
    "832102": 96,
    "832103": 96,
    "832104": 96,
    "832105": 48,
    "832106": 96,
    "832107": 48,
    "832108": 48,
    "832109": 48,
    "832110": 48,
    "832111": 96,
    "832302": 96,
    "832303": 96,
    "832304": 96,
    "833102": 96,
    "833103": 96,
    "833105": 96,
    "833201": 96,
    "833202": 96,
    "833212": 96,
    "833215": 96,
    "833217": 96,
    "833218": 96,
    "834001": 48,
    "834002": 48,
    "834003": 48,
    "834004": 48,
    "834005": 48,
    "834006": 48,
    "834007": 48,
    "834008": 48,
    "834009": 48,
    "834010": 48,
    "834011": 48,
    "834012": 48,
    "834013": 48,
    "835103": 48,
    "835207": 96,
    "835208": 96,
    "835213": 96,
    "835215": 48,
    "835217": 96,
    "835219": 96,
    "835222": 48,
    "835223": 96,
    "835224": 96,
    "835226": 96,
    "835228": 96,
    "835233": 96,
    "835235": 96,
    "835302": 96,
    "835325": 96,
    "841101": 48,
    "841201": 96,
    "841202": 96,
    "841203": 96,
    "841204": 96,
    "841205": 96,
    "841206": 96,
    "841207": 96,
    "841208": 96,
    "841209": 96,
    "841211": 96,
    "841212": 96,
    "841213": 96,
    "841214": 96,
    "841216": 96,
    "841217": 48,
    "841218": 96,
    "841219": 96,
    "841220": 96,
    "841221": 48,
    "841222": 48,
    "841223": 96,
    "841225": 96,
    "841226": 96,
    "841227": 96,
    "841231": 96,
    "841232": 96,
    "841233": 96,
    "841236": 96,
    "841237": 96,
    "841238": 96,
    "841239": 96,
    "841240": 96,
    "841241": 96,
    "841244": 96,
    "841245": 96,
    "841286": 96,
    "841287": 96,
    "841301": 96,
    "841302": 96,
    "841305": 96,
    "841311": 96,
    "841313": 96,
    "841316": 96,
    "841401": 96,
    "841402": 96,
    "841403": 96,
    "841405": 96,
    "841411": 96,
    "841412": 96,
    "841414": 96,
    "841415": 96,
    "841418": 96,
    "841419": 96,
    "841421": 96,
    "841422": 96,
    "841423": 96,
    "841424": 96,
    "841427": 96,
    "841428": 96,
    "841436": 96,
    "841438": 96,
    "841439": 96,
    "841440": 96,
    "841442": 96,
    "841446": 96,
    "841501": 96,
    "841503": 96,
    "841505": 96,
    "841506": 96,
    "842001": 96,
    "842002": 96,
    "842003": 96,
    "842004": 96,
    "842005": 96,
    "842008": 96,
    "843101": 96,
    "843102": 96,
    "843103": 96,
    "843104": 96,
    "843105": 96,
    "843106": 96,
    "843107": 96,
    "843108": 96,
    "843109": 96,
    "843110": 96,
    "843111": 96,
    "843112": 96,
    "843113": 96,
    "843114": 96,
    "843115": 96,
    "843116": 96,
    "843117": 96,
    "843118": 96,
    "843119": 96,
    "843120": 96,
    "843121": 96,
    "843122": 96,
    "843123": 96,
    "843124": 96,
    "843125": 96,
    "843126": 96,
    "843127": 96,
    "843128": 96,
    "843129": 96,
    "843130": 96,
    "843131": 96,
    "843132": 96,
    "843141": 96,
    "843146": 96,
    "843301": 96,
    "843302": 96,
    "843311": 96,
    "843312": 96,
    "843314": 96,
    "843315": 96,
    "843316": 96,
    "843317": 96,
    "843320": 96,
    "843321": 96,
    "843322": 96,
    "843323": 96,
    "843324": 96,
    "843325": 96,
    "843327": 96,
    "843328": 96,
    "843329": 96,
    "843330": 96,
    "843331": 96,
    "843332": 96,
    "843334": 96,
    "843351": 96,
    "843360": 96,
    "844101": 48,
    "844102": 48,
    "844103": 48,
    "844111": 96,
    "844112": 96,
    "844113": 48,
    "844114": 96,
    "844115": 48,
    "844116": 96,
    "844117": 48,
    "844118": 96,
    "844119": 48,
    "844120": 96,
    "844121": 48,
    "844122": 96,
    "844123": 96,
    "844124": 96,
    "844125": 96,
    "844126": 96,
    "844127": 96,
    "844128": 48,
    "844501": 96,
    "844502": 48,
    "844503": 48,
    "844504": 48,
    "844505": 96,
    "844507": 96,
    "845103": 120,
    "845106": 120,
    "845301": 120,
    "845305": 120,
    "845306": 120,
    "845307": 120,
    "845401": 96,
    "845411": 96,
    "845412": 96,
    "845414": 96,
    "845415": 96,
    "845416": 96,
    "845417": 96,
    "845419": 96,
    "845420": 96,
    "845422": 96,
    "845425": 96,
    "845426": 96,
    "845427": 96,
    "845429": 96,
    "845430": 96,
    "845431": 96,
    "845433": 120,
    "845434": 96,
    "845435": 96,
    "845436": 96,
    "845437": 96,
    "845438": 120,
    "845440": 120,
    "845449": 120,
    "845450": 120,
    "845451": 120,
    "845452": 120,
    "845453": 120,
    "845454": 120,
    "845455": 120,
    "845456": 120,
    "845458": 96,
    "845459": 120,
    "846001": 96,
    "846002": 96,
    "846003": 96,
    "846004": 96,
    "846005": 96,
    "846006": 96,
    "846007": 96,
    "846008": 96,
    "846009": 96,
    "847101": 96,
    "847103": 96,
    "847104": 96,
    "847106": 96,
    "847107": 96,
    "847109": 120,
    "847115": 96,
    "847121": 120,
    "847123": 96,
    "847211": 120,
    "847212": 120,
    "847222": 120,
    "847225": 120,
    "847226": 120,
    "847227": 120,
    "847229": 120,
    "847230": 120,
    "847232": 120,
    "847233": 96,
    "847234": 120,
    "847236": 120,
    "847238": 120,
    "847240": 120,
    "847306": 96,
    "847337": 120,
    "847401": 120,
    "847402": 120,
    "847403": 120,
    "847404": 120,
    "847407": 120,
    "847408": 120,
    "847409": 120,
    "847410": 120,
    "847411": 120,
    "847428": 96,
    "847429": 96,
    "848101": 96,
    "848102": 96,
    "848113": 96,
    "848114": 96,
    "848115": 96,
    "848117": 96,
    "848121": 96,
    "848122": 96,
    "848125": 96,
    "848127": 96,
    "848129": 96,
    "848130": 96,
    "848131": 96,
    "848132": 96,
    "848133": 96,
    "848134": 96,
    "848160": 96,
    "848203": 96,
    "848210": 96,
    "848211": 96,
    "848236": 96,
    "848301": 96,
    "848302": 96,
    "848502": 96,
    "848503": 96,
    "848505": 96,
    "851101": 96,
    "851111": 96,
    "851112": 96,
    "851113": 96,
    "851114": 96,
    "851115": 96,
    "851116": 96,
    "851117": 96,
    "851118": 96,
    "851126": 96,
    "851127": 96,
    "851128": 96,
    "851129": 96,
    "851130": 96,
    "851131": 96,
    "851132": 96,
    "851133": 96,
    "851134": 96,
    "851135": 96,
    "851202": 96,
    "851203": 96,
    "851204": 96,
    "851205": 96,
    "851210": 96,
    "851211": 96,
    "851212": 96,
    "851213": 96,
    "851214": 96,
    "851218": 96,
    "852105": 120,
    "852106": 120,
    "852107": 120,
    "852108": 120,
    "852109": 120,
    "852111": 120,
    "852113": 120,
    "852114": 120,
    "852115": 120,
    "852121": 120,
    "852122": 120,
    "852127": 120,
    "852128": 120,
    "852130": 120,
    "852131": 120,
    "852132": 120,
    "852133": 120,
    "852138": 120,
    "852139": 120,
    "852201": 120,
    "852202": 120,
    "852212": 120,
    "852218": 120,
    "852221": 120,
    "853201": 96,
    "853202": 96,
    "853204": 96,
    "853205": 96,
    "854103": 96,
    "854105": 96,
    "854106": 96,
    "854107": 96,
    "854108": 96,
    "854109": 96,
    "854113": 96,
    "854115": 96,
    "854202": 96,
    "854205": 96,
    "854301": 96,
    "854302": 96,
    "854303": 96,
    "854304": 96,
    "854305": 96,
    "854306": 96,
    "854311": 96,
    "854312": 96,
    "854316": 96,
    "854318": 96,
    "854325": 96,
    "854326": 96,
    "854327": 96,
    "854328": 96,
    "854329": 96,
    "854330": 96,
    "854332": 96,
    "854335": 96,
    "854336": 96,
    "854337": 96,
    "855105": 96,
    "855107": 96,
    "855108": 96,
    "855114": 96,
    "855115": 96,
    "855117": 96
}
    
    function calculateDistance() {
        const input = document.getElementById('locationInput').value.trim();
        const resultElement = document.getElementById('result');
        
        if (input === '') {
            resultElement.innerHTML = 'Please enter a location.';
            return;
        }

        const matchedState = Object.keys(statesData).find(state => 
            state.toLowerCase() === input.toLowerCase()
        );

        if (matchedState) {
            const distance = statesData[matchedState];
            const days = Math.ceil(distance / 24 ) + 2;
            const date = new Date();
            date.setDate(date.getDate() + days);

            const options = {weekday: 'long', month: 'long', day: 'numeric' };
            const estimatedDate = date.toLocaleDateString('en-US', options);

            resultElement.innerHTML = `
                                     <img class="dil-timer" src="https://cdn.shopify.com/s/files/1/0685/6373/0710/files/timer-new.svg?v=1762692185"/>  Get it as soon as<span>${estimatedDate}.</span>`;
        } else {
            resultElement.innerHTML = 'Location not served. Enter another pincode.';
        }
    }

    // Close suggestions when clicking outside
    // document.addEventListener('click', function(e) {
    //     if (!e.target.closest('.search-container')) {
    //         document.getElementById('suggestions').style.display = 'none';
    //     }
    // });